/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * Represents non-fractional signed whole numeric values. Since the value may
   * exceed the size of a 32-bit integer, it's encoded as a string.
   */
  BigInt: { input: string; output: string; }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: string; output: string; }
  /** Represents untyped JSON */
  JSON: { input: any; output: any; }
};

/** Account deletion reason enum */
export enum AccountDeletionReason {
  /** Found a better chat app */
  FoundBetterChatApp = 'FOUND_BETTER_CHAT_APP',
  /** I'm not active in any chats anymore */
  NotActiveInChats = 'NOT_ACTIVE_IN_CHATS',
  /** My friends don't use this app */
  NoFriendsUsing = 'NO_FRIENDS_USING',
  /** Other */
  Other = 'OTHER',
  /** Privacy concerns with group chats */
  PrivacyConcerns = 'PRIVACY_CONCERNS',
  /** App crashes or technical problems */
  TechnicalIssues = 'TECHNICAL_ISSUES',
  /** Too many notifications from groups */
  TooManyNotifications = 'TOO_MANY_NOTIFICATIONS',
  /** Encountered harassment or toxic behavior */
  ToxicCommunity = 'TOXIC_COMMUNITY'
}

export type Ad = {
  __typename?: 'Ad';
  body?: Maybe<Scalars['String']['output']>;
  ctaLink: Scalars['String']['output'];
  ctaText?: Maybe<Scalars['String']['output']>;
  format: AdFormat;
  id: Scalars['ID']['output'];
  imageHeight?: Maybe<Scalars['Int']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  imageWidth?: Maybe<Scalars['Int']['output']>;
  labelText?: Maybe<Scalars['String']['output']>;
  sponsor: Sponsor;
  title?: Maybe<Scalars['String']['output']>;
};

export enum AdFormat {
  Message = 'MESSAGE',
  Tag = 'TAG'
}

export type AdImpressionInput = {
  adId: Scalars['ID']['input'];
  surface: Scalars['String']['input'];
};

/** Autogenerated input type of AdTrackClick */
export type AdTrackClickInput = {
  adId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  surface: Scalars['String']['input'];
};

/** Autogenerated return type of AdTrackClick. */
export type AdTrackClickPayload = {
  __typename?: 'AdTrackClickPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AdTrackImpressions */
export type AdTrackImpressionsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  impressions: Array<AdImpressionInput>;
};

/** Autogenerated return type of AdTrackImpressions. */
export type AdTrackImpressionsPayload = {
  __typename?: 'AdTrackImpressionsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AdminAdCampaign = {
  __typename?: 'AdminAdCampaign';
  active: Scalars['Boolean']['output'];
  creatives: Array<AdminAdCreative>;
  creativesCount: Scalars['Int']['output'];
  endsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sponsor: AdminAdSponsor;
  startsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Autogenerated input type of AdminAdCampaignCreate */
export type AdminAdCampaignCreateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  endsAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  name: Scalars['String']['input'];
  sponsorId: Scalars['ID']['input'];
  startsAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** Autogenerated return type of AdminAdCampaignCreate. */
export type AdminAdCampaignCreatePayload = {
  __typename?: 'AdminAdCampaignCreatePayload';
  adCampaign: AdminAdCampaign;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of AdminAdCampaignDelete */
export type AdminAdCampaignDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of AdminAdCampaignDelete. */
export type AdminAdCampaignDeletePayload = {
  __typename?: 'AdminAdCampaignDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AdminAdCampaignUpdate */
export type AdminAdCampaignUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  endsAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  sponsorId?: InputMaybe<Scalars['ID']['input']>;
  startsAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** Autogenerated return type of AdminAdCampaignUpdate. */
export type AdminAdCampaignUpdatePayload = {
  __typename?: 'AdminAdCampaignUpdatePayload';
  adCampaign: AdminAdCampaign;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type AdminAdCreative = {
  __typename?: 'AdminAdCreative';
  body?: Maybe<Scalars['String']['output']>;
  campaign: AdminAdCampaign;
  ctaLink: Scalars['String']['output'];
  ctaText?: Maybe<Scalars['String']['output']>;
  format: AdFormat;
  id: Scalars['ID']['output'];
  imageHeight?: Maybe<Scalars['Int']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  imageWidth?: Maybe<Scalars['Int']['output']>;
  labelText?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of AdminAdCreativeCreate */
export type AdminAdCreativeCreateInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  campaignId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ctaLink: Scalars['String']['input'];
  ctaText?: InputMaybe<Scalars['String']['input']>;
  format: AdFormat;
  /** signedId of a presigned uploaded image */
  imageSignedId?: InputMaybe<Scalars['String']['input']>;
  labelText?: InputMaybe<Scalars['String']['input']>;
  /** Admin-facing identifier for reporting */
  name: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AdminAdCreativeCreate. */
export type AdminAdCreativeCreatePayload = {
  __typename?: 'AdminAdCreativeCreatePayload';
  adCreative: AdminAdCreative;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of AdminAdCreativeDelete */
export type AdminAdCreativeDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of AdminAdCreativeDelete. */
export type AdminAdCreativeDeletePayload = {
  __typename?: 'AdminAdCreativeDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AdminAdCreativeUpdate */
export type AdminAdCreativeUpdateInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ctaLink?: InputMaybe<Scalars['String']['input']>;
  ctaText?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<AdFormat>;
  id: Scalars['ID']['input'];
  /** signedId of a presigned uploaded image */
  imageSignedId?: InputMaybe<Scalars['String']['input']>;
  labelText?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** purge the stored image when no replacement is uploaded */
  removeImage?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AdminAdCreativeUpdate. */
export type AdminAdCreativeUpdatePayload = {
  __typename?: 'AdminAdCreativeUpdatePayload';
  adCreative: AdminAdCreative;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type AdminAdSponsor = {
  __typename?: 'AdminAdSponsor';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  campaignsCount: Scalars['Int']['output'];
  color?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  user?: Maybe<User>;
};

/** Autogenerated input type of AdminAdSponsorCreate */
export type AdminAdSponsorCreateInput = {
  /** signedId of a presigned uploaded avatar */
  avatarSignedId?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of AdminAdSponsorCreate. */
export type AdminAdSponsorCreatePayload = {
  __typename?: 'AdminAdSponsorCreatePayload';
  adSponsor: AdminAdSponsor;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of AdminAdSponsorDelete */
export type AdminAdSponsorDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of AdminAdSponsorDelete. */
export type AdminAdSponsorDeletePayload = {
  __typename?: 'AdminAdSponsorDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AdminAdSponsorUpdate */
export type AdminAdSponsorUpdateInput = {
  /** signedId of a presigned uploaded avatar */
  avatarSignedId?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of AdminAdSponsorUpdate. */
export type AdminAdSponsorUpdatePayload = {
  __typename?: 'AdminAdSponsorUpdatePayload';
  adSponsor: AdminAdSponsor;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of AdminAuraCashOut */
export type AdminAuraCashOutInput = {
  amount: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of AdminAuraCashOut. */
export type AdminAuraCashOutPayload = {
  __typename?: 'AdminAuraCashOutPayload';
  cashOut: AuraCashOut;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
};

/** Autogenerated input type of AdminAuraProductCreate */
export type AdminAuraProductCreateInput = {
  auraAmount: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  internalName: Scalars['String']['input'];
  purchaseOnWalletScreen?: InputMaybe<Scalars['Boolean']['input']>;
  state: SubscriptionProductState;
  store: StoreName;
  storeProductIdentifier: Scalars['String']['input'];
};

/** Autogenerated return type of AdminAuraProductCreate. */
export type AdminAuraProductCreatePayload = {
  __typename?: 'AdminAuraProductCreatePayload';
  auraProduct: AuraProduct;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of AdminAuraProductUpdate */
export type AdminAuraProductUpdateInput = {
  auraAmount?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  internalName?: InputMaybe<Scalars['String']['input']>;
  purchaseOnWalletScreen?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<SubscriptionProductState>;
  store?: InputMaybe<StoreName>;
  storeProductIdentifier?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AdminAuraProductUpdate. */
export type AdminAuraProductUpdatePayload = {
  __typename?: 'AdminAuraProductUpdatePayload';
  auraProduct: AuraProduct;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type AdminContentSuggestion = {
  __typename?: 'AdminContentSuggestion';
  content: Scalars['JSON']['output'];
  contentType: ContentSuggestionType;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  message: Message;
  ranking: Scalars['Int']['output'];
  reasoning?: Maybe<Scalars['String']['output']>;
  selectedToPublish: Scalars['Boolean']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for AdminContentSuggestion. */
export type AdminContentSuggestionConnection = {
  __typename?: 'AdminContentSuggestionConnection';
  /** A list of edges. */
  edges: Array<AdminContentSuggestionEdge>;
  /** A list of nodes. */
  nodes: Array<AdminContentSuggestion>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AdminContentSuggestionEdge = {
  __typename?: 'AdminContentSuggestionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AdminContentSuggestion;
};

/** Autogenerated input type of AdminContentSuggestionToggleSelected */
export type AdminContentSuggestionToggleSelectedInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contentSuggestionId?: InputMaybe<Scalars['ID']['input']>;
  episodeId: Scalars['ID']['input'];
  reapClipId?: InputMaybe<Scalars['ID']['input']>;
  selectedToPublish: Scalars['Boolean']['input'];
};

/** Autogenerated return type of AdminContentSuggestionToggleSelected. */
export type AdminContentSuggestionToggleSelectedPayload = {
  __typename?: 'AdminContentSuggestionToggleSelectedPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contentSuggestion?: Maybe<AdminContentSuggestion>;
  episode: AdminEpisode;
  reapClip?: Maybe<AdminReapClip>;
};

/** Autogenerated input type of AdminDemoChattersAdd */
export type AdminDemoChattersAddInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  roomId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of AdminDemoChattersAdd. */
export type AdminDemoChattersAddPayload = {
  __typename?: 'AdminDemoChattersAddPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  room: Room;
};

/** Autogenerated input type of AdminDemoChattersRemove */
export type AdminDemoChattersRemoveInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  roomId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of AdminDemoChattersRemove. */
export type AdminDemoChattersRemovePayload = {
  __typename?: 'AdminDemoChattersRemovePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  room: Room;
};

/** Autogenerated input type of AdminDemoGenerateEngagement */
export type AdminDemoGenerateEngagementInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  roomId: Scalars['ID']['input'];
};

/** Autogenerated return type of AdminDemoGenerateEngagement. */
export type AdminDemoGenerateEngagementPayload = {
  __typename?: 'AdminDemoGenerateEngagementPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  room: Room;
};

/** Autogenerated input type of AdminDemoMessageCreate */
export type AdminDemoMessageCreateInput = {
  attachmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  channelId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  parentMessageId?: InputMaybe<Scalars['ID']['input']>;
  quotedMessageId?: InputMaybe<Scalars['ID']['input']>;
  randomNonHostSender?: InputMaybe<Scalars['Boolean']['input']>;
  senderUserId?: InputMaybe<Scalars['ID']['input']>;
  textContent?: InputMaybe<Scalars['String']['input']>;
  textContentHeader?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AdminDemoMessageCreate. */
export type AdminDemoMessageCreatePayload = {
  __typename?: 'AdminDemoMessageCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  message: Message;
};

/** Autogenerated input type of AdminDemoMessageUpdate */
export type AdminDemoMessageUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  id: Scalars['ID']['input'];
  textContent?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AdminDemoMessageUpdate. */
export type AdminDemoMessageUpdatePayload = {
  __typename?: 'AdminDemoMessageUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  message: Message;
};

/** Autogenerated input type of AdminDemoRoomCreate */
export type AdminDemoRoomCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** signedId of a presigned uploaded file */
  csvSignedId?: InputMaybe<Scalars['String']['input']>;
  roomName: Scalars['String']['input'];
};

/** Autogenerated return type of AdminDemoRoomCreate. */
export type AdminDemoRoomCreatePayload = {
  __typename?: 'AdminDemoRoomCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  csvErrors?: Maybe<Array<DemoCsvRowError>>;
  room?: Maybe<Room>;
};

/** Autogenerated input type of AdminDemoRoomCreateV2 */
export type AdminDemoRoomCreateV2Input = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

/** Autogenerated return type of AdminDemoRoomCreateV2. */
export type AdminDemoRoomCreateV2Payload = {
  __typename?: 'AdminDemoRoomCreateV2Payload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  room?: Maybe<Room>;
};

/** Autogenerated input type of AdminDemoRoomRetry */
export type AdminDemoRoomRetryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the room whose demo workflow needs to be retried. */
  roomId: Scalars['ID']['input'];
};

/** Autogenerated return type of AdminDemoRoomRetry. */
export type AdminDemoRoomRetryPayload = {
  __typename?: 'AdminDemoRoomRetryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  room?: Maybe<Room>;
};

/** Autogenerated input type of AdminDemoUserCreate */
export type AdminDemoUserCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userInput: DemoUserInput;
};

/** Autogenerated return type of AdminDemoUserCreate. */
export type AdminDemoUserCreatePayload = {
  __typename?: 'AdminDemoUserCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
};

/** Autogenerated input type of AdminDemoUserUpdate */
export type AdminDemoUserUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  userInput: DemoUserInput;
};

/** Autogenerated return type of AdminDemoUserUpdate. */
export type AdminDemoUserUpdatePayload = {
  __typename?: 'AdminDemoUserUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
};

/** Autogenerated input type of AdminEarningsPlanCreate */
export type AdminEarningsPlanCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  endsAt: Scalars['ISO8601DateTime']['input'];
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  planItems: Array<EarningsPlanItemInput>;
  roomId: Scalars['ID']['input'];
  startsAt: Scalars['ISO8601DateTime']['input'];
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Autogenerated return type of AdminEarningsPlanCreate. */
export type AdminEarningsPlanCreatePayload = {
  __typename?: 'AdminEarningsPlanCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  earningsPlan: EarningsPlan;
};

/** Autogenerated input type of AdminEarningsPlanUpdate */
export type AdminEarningsPlanUpdateInput = {
  addUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  endsAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  startsAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** Autogenerated return type of AdminEarningsPlanUpdate. */
export type AdminEarningsPlanUpdatePayload = {
  __typename?: 'AdminEarningsPlanUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  earningsPlan: EarningsPlan;
};

export type AdminEpisode = {
  __typename?: 'AdminEpisode';
  /** Per-type counts of content currently selected to publish: { clips, poll, trivia_question, discussion_question, quote }. */
  announcementPublishCounts: Scalars['JSON']['output'];
  announcementPublishable: Scalars['Boolean']['output'];
  announcementPublishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  assemblyAiTranscriptId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  detailsSyncedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isYoutubeShort: Scalars['Boolean']['output'];
  liveStatus?: Maybe<Scalars['String']['output']>;
  membersOnly: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  reapClips: Array<AdminReapClip>;
  reapClipsCount: Scalars['Int']['output'];
  reapProjectId?: Maybe<Scalars['String']['output']>;
  reapTaskError?: Maybe<Scalars['String']['output']>;
  reapTaskStatus: Scalars['String']['output'];
  relevant?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The room this episode belongs to; exposes its channels and home channel for
   * choosing where to publish the announcement card.
   */
  room: Room;
  roomId: Scalars['ID']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  transcriptAudioDurationSeconds?: Maybe<Scalars['Int']['output']>;
  transcriptChapters?: Maybe<Array<TranscriptChapter>>;
  transcriptConfidence?: Maybe<Scalars['Float']['output']>;
  transcriptLanguage?: Maybe<Scalars['String']['output']>;
  transcriptText?: Maybe<Scalars['String']['output']>;
  transcriptUtterances?: Maybe<Array<AdminTranscriptUtterance>>;
  transcriptWordCount?: Maybe<Scalars['Int']['output']>;
  transcriptionError?: Maybe<Scalars['String']['output']>;
  transcriptionStatus: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  url: Scalars['String']['output'];
  youtubeId: Scalars['String']['output'];
  youtubeSource: AdminYoutubeSource;
};

/** The connection type for AdminEpisode. */
export type AdminEpisodeConnection = {
  __typename?: 'AdminEpisodeConnection';
  /** A list of edges. */
  edges: Array<AdminEpisodeEdge>;
  /** A list of nodes. */
  nodes: Array<AdminEpisode>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AdminEpisodeEdge = {
  __typename?: 'AdminEpisodeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AdminEpisode;
};

/** Autogenerated input type of AdminEpisodeGenerateContent */
export type AdminEpisodeGenerateContentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  episodeId: Scalars['ID']['input'];
};

/** Autogenerated return type of AdminEpisodeGenerateContent. */
export type AdminEpisodeGenerateContentPayload = {
  __typename?: 'AdminEpisodeGenerateContentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  episode: AdminEpisode;
};

/** Autogenerated input type of AdminEpisodePublishAnnouncement */
export type AdminEpisodePublishAnnouncementInput = {
  authorId?: InputMaybe<Scalars['ID']['input']>;
  channelId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  episodeId: Scalars['ID']['input'];
};

/** Autogenerated return type of AdminEpisodePublishAnnouncement. */
export type AdminEpisodePublishAnnouncementPayload = {
  __typename?: 'AdminEpisodePublishAnnouncementPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  episode: AdminEpisode;
};

export type AdminEpisodeVideo = {
  __typename?: 'AdminEpisodeVideo';
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** Autogenerated input type of AdminModerateMessage */
export type AdminModerateMessageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  messageId: Scalars['ID']['input'];
  moderationAction: AdminModerationAction;
};

/** Autogenerated return type of AdminModerateMessage. */
export type AdminModerateMessagePayload = {
  __typename?: 'AdminModerateMessagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  message: Message;
};

/** Filter options for admin moderated users */
export enum AdminModeratedUsersFilter {
  Default = 'DEFAULT',
  DmCount = 'DM_COUNT',
  FollowingCount = 'FOLLOWING_COUNT',
  LlmFlaggedReview = 'LLM_FLAGGED_REVIEW',
  Reports = 'REPORTS',
  SpamKeywords = 'SPAM_KEYWORDS',
  Suspended = 'SUSPENDED'
}

export enum AdminModerationAction {
  Delete = 'DELETE',
  Permit = 'PERMIT',
  Unpermit = 'UNPERMIT'
}

export type AdminNewMemberStats = {
  __typename?: 'AdminNewMemberStats';
  hostNames: Array<Scalars['String']['output']>;
  monthlyStats: Array<MonthlyNewMemberStats>;
  roomId: Scalars['ID']['output'];
  roomName: Scalars['String']['output'];
};

/** Autogenerated input type of AdminPredictionsGroupCreate */
export type AdminPredictionsGroupCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  predictionsGroup: PredictionsGroupInput;
};

/** Autogenerated return type of AdminPredictionsGroupCreate. */
export type AdminPredictionsGroupCreatePayload = {
  __typename?: 'AdminPredictionsGroupCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  gameGroup: PredictionsGameGroup;
};

/** Autogenerated input type of AdminPredictionsGroupUpdate */
export type AdminPredictionsGroupUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  predictionsGroup: PredictionsGroupInput;
};

/** Autogenerated return type of AdminPredictionsGroupUpdate. */
export type AdminPredictionsGroupUpdatePayload = {
  __typename?: 'AdminPredictionsGroupUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  gameGroup: PredictionsGameGroup;
};

/** Autogenerated input type of AdminPredictionsInputResults */
export type AdminPredictionsInputResultsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  questions: Array<PredictionsAdminResultInput>;
  resultsMessageText: Scalars['String']['input'];
  scheduledAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** Autogenerated return type of AdminPredictionsInputResults. */
export type AdminPredictionsInputResultsPayload = {
  __typename?: 'AdminPredictionsInputResultsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  gameGroup: PredictionsGameGroup;
};

export type AdminProductBenefitInput = {
  description: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type AdminReapClip = {
  __typename?: 'AdminReapClip';
  attachment?: Maybe<Attachment>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  durationSeconds?: Maybe<Scalars['Float']['output']>;
  episode?: Maybe<AdminEpisodeVideo>;
  error?: Maybe<Scalars['String']['output']>;
  exportStatus: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  reapClipId: Scalars['String']['output'];
  reapProjectId: Scalars['String']['output'];
  selectedToPublish: Scalars['Boolean']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Normalized 0..1 viral score for cross-provider comparison. */
  viralPercent?: Maybe<Scalars['Float']['output']>;
  viralScore?: Maybe<Scalars['Float']['output']>;
};

export type AdminRoomHostStats = {
  __typename?: 'AdminRoomHostStats';
  daysSinceOnboarded: Scalars['Int']['output'];
  daysWithAtLeastOneMessageAllTime: Scalars['Int']['output'];
  daysWithAtLeastOneMessageLastMonth: Scalars['Int']['output'];
  daysWithAtLeastOneMessageThisMonth: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  netAuraAllTime: Scalars['Int']['output'];
  netAuraLastMonth: Scalars['Int']['output'];
  netAuraThisMonth: Scalars['Int']['output'];
  numberMessagesAllTime: Scalars['Int']['output'];
  numberMessagesLastMonth: Scalars['Int']['output'];
  numberMessagesThisMonth: Scalars['Int']['output'];
  referralCountAllTime: Scalars['Int']['output'];
  referralCountLastMonth: Scalars['Int']['output'];
  referralCountThisMonth: Scalars['Int']['output'];
  user: User;
};

/** Autogenerated input type of AdminRoomToggleBounties */
export type AdminRoomToggleBountiesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  roomId: Scalars['ID']['input'];
};

/** Autogenerated return type of AdminRoomToggleBounties. */
export type AdminRoomToggleBountiesPayload = {
  __typename?: 'AdminRoomToggleBountiesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  room: Room;
};

/** Autogenerated input type of AdminRoomUpdate */
export type AdminRoomUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  roomInput: RoomInputAdmin;
};

/** Autogenerated return type of AdminRoomUpdate. */
export type AdminRoomUpdatePayload = {
  __typename?: 'AdminRoomUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  room: Room;
};

export type AdminRoomYoutubeSource = {
  __typename?: 'AdminRoomYoutubeSource';
  episodesCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  source: AdminYoutubeSource;
};

/** The connection type for AdminRoomYoutubeSource. */
export type AdminRoomYoutubeSourceConnection = {
  __typename?: 'AdminRoomYoutubeSourceConnection';
  /** A list of edges. */
  edges: Array<AdminRoomYoutubeSourceEdge>;
  /** A list of nodes. */
  nodes: Array<AdminRoomYoutubeSource>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AdminRoomYoutubeSourceEdge = {
  __typename?: 'AdminRoomYoutubeSourceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AdminRoomYoutubeSource;
};

/** Autogenerated input type of AdminSubscriptionProductCreate */
export type AdminSubscriptionProductCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  collectUserEmail?: InputMaybe<Scalars['Boolean']['input']>;
  collectUserPostalCode?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<AppHexColor>;
  displayName: Scalars['String']['input'];
  internalName: Scalars['String']['input'];
  permitsPromotedComments?: InputMaybe<Scalars['Boolean']['input']>;
  permitsSubscriberOnlyMessages?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of channel IDs that this product permits access to */
  permittedChannels?: InputMaybe<Array<Scalars['ID']['input']>>;
  productBenefits: Array<AdminProductBenefitInput>;
  roomId: Scalars['ID']['input'];
  state: SubscriptionProductState;
  store: StoreName;
  storeProductIdentifier: Scalars['String']['input'];
  /** signedId of a presigned uploaded image */
  subscriberBadge?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AdminSubscriptionProductCreate. */
export type AdminSubscriptionProductCreatePayload = {
  __typename?: 'AdminSubscriptionProductCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  subscriptionProduct: SubscriptionProduct;
};

/** Autogenerated input type of AdminSubscriptionProductReposition */
export type AdminSubscriptionProductRepositionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  positions: Array<Scalars['Int']['input']>;
  productIds: Array<Scalars['String']['input']>;
  roomId: Scalars['ID']['input'];
};

/** Autogenerated return type of AdminSubscriptionProductReposition. */
export type AdminSubscriptionProductRepositionPayload = {
  __typename?: 'AdminSubscriptionProductRepositionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  subscriptionProducts: Array<SubscriptionProduct>;
};

/** Autogenerated input type of AdminSubscriptionProductUpdate */
export type AdminSubscriptionProductUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  collectUserEmail?: InputMaybe<Scalars['Boolean']['input']>;
  collectUserPostalCode?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<AppHexColor>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** ID of the product to update */
  id: Scalars['ID']['input'];
  internalName?: InputMaybe<Scalars['String']['input']>;
  permitsPromotedComments?: InputMaybe<Scalars['Boolean']['input']>;
  permitsSubscriberOnlyMessages?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of channel IDs that this product permits access to */
  permittedChannels?: InputMaybe<Array<Scalars['ID']['input']>>;
  productBenefits?: InputMaybe<Array<AdminProductBenefitInput>>;
  state?: InputMaybe<SubscriptionProductState>;
  store?: InputMaybe<StoreName>;
  storeProductIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** signedId of a presigned uploaded image */
  subscriberBadge?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AdminSubscriptionProductUpdate. */
export type AdminSubscriptionProductUpdatePayload = {
  __typename?: 'AdminSubscriptionProductUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  subscriptionProduct?: Maybe<SubscriptionProduct>;
};

export type AdminTranscriptUtterance = {
  __typename?: 'AdminTranscriptUtterance';
  confidence?: Maybe<Scalars['Float']['output']>;
  endMs: Scalars['Int']['output'];
  speaker?: Maybe<Scalars['String']['output']>;
  startMs: Scalars['Int']['output'];
  text: Scalars['String']['output'];
};

export type AdminUser = {
  __typename?: 'AdminUser';
  activeFollowingNonVerifiedCount: Scalars['Int']['output'];
  activeFollowingVerifiedCount: Scalars['Int']['output'];
  activeRoomFollowsCount: Scalars['Int']['output'];
  blockedByCount: Scalars['Int']['output'];
  dmAcceptedAllCount: Scalars['Int']['output'];
  dmAcceptedCount: Scalars['Int']['output'];
  dmRoomsAcceptedCount: Scalars['Int']['output'];
  dmRoomsDeclinedCount: Scalars['Int']['output'];
  dmRoomsMutuallyAcceptedCount: Scalars['Int']['output'];
  dmRoomsPendingCount: Scalars['Int']['output'];
  followedRooms: Array<Room>;
  id: Scalars['ID']['output'];
  llmRecommendation: Scalars['String']['output'];
  postingRestrictionsCount: Scalars['Int']['output'];
  recentMessages: Array<Message>;
  reportedMessagesCount: Scalars['Int']['output'];
  roomBansCount: Scalars['Int']['output'];
  timeZone?: Maybe<Scalars['String']['output']>;
  user: User;
  userContentReports: MessageConnection;
};


export type AdminUserFollowedRoomsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type AdminUserRecentMessagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type AdminUserUserContentReportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for AdminUser. */
export type AdminUserConnection = {
  __typename?: 'AdminUserConnection';
  /** A list of edges. */
  edges: Array<AdminUserEdge>;
  /** A list of nodes. */
  nodes: Array<AdminUser>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Autogenerated input type of AdminUserCreate */
export type AdminUserCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};

/** Autogenerated return type of AdminUserCreate. */
export type AdminUserCreatePayload = {
  __typename?: 'AdminUserCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
};

/** An edge in a connection. */
export type AdminUserEdge = {
  __typename?: 'AdminUserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AdminUser;
};

/** Autogenerated input type of AdminUserModerationCreate */
export type AdminUserModerationCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  postingRestrictedUntil?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Room ID (null for global restriction) */
  roomId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
  warnMessage?: InputMaybe<Scalars['String']['input']>;
  warnReason: Scalars['String']['input'];
};

/** Autogenerated return type of AdminUserModerationCreate. */
export type AdminUserModerationCreatePayload = {
  __typename?: 'AdminUserModerationCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
  userModeration: UserModeration;
};

/** Autogenerated input type of AdminUserModerationDelete */
export type AdminUserModerationDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  moderationId: Scalars['ID']['input'];
};

/** Autogenerated return type of AdminUserModerationDelete. */
export type AdminUserModerationDeletePayload = {
  __typename?: 'AdminUserModerationDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  user: User;
};

/** Autogenerated input type of AdminUserModerationUpdate */
export type AdminUserModerationUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  moderationId: Scalars['ID']['input'];
  postingRestrictedUntil?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  warnMessage?: InputMaybe<Scalars['String']['input']>;
  warnReason?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AdminUserModerationUpdate. */
export type AdminUserModerationUpdatePayload = {
  __typename?: 'AdminUserModerationUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
  userModeration: UserModeration;
};

/** Autogenerated input type of AdminUserSuspend */
export type AdminUserSuspendInput = {
  /** When suspending, whether to annotate stored reCAPTCHA assessments as fraudulent */
  annotateRecaptcha?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** True to suspend the user, false to unsuspend */
  suspend: Scalars['Boolean']['input'];
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of AdminUserSuspend. */
export type AdminUserSuspendPayload = {
  __typename?: 'AdminUserSuspendPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
};

/** Autogenerated input type of AdminUserUpdate */
export type AdminUserUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  userInput: UserInputAdmin;
};

/** Autogenerated return type of AdminUserUpdate. */
export type AdminUserUpdatePayload = {
  __typename?: 'AdminUserUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
};

export type AdminYoutubeSource = {
  __typename?: 'AdminYoutubeSource';
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  handle?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastSyncedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** Autogenerated input type of AdminYoutubeSourceCreate */
export type AdminYoutubeSourceCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  roomId: Scalars['ID']['input'];
  url: Scalars['String']['input'];
};

/** Autogenerated return type of AdminYoutubeSourceCreate. */
export type AdminYoutubeSourceCreatePayload = {
  __typename?: 'AdminYoutubeSourceCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  youtubeSource: AdminYoutubeSource;
};

export enum AppHexColor {
  Blue = 'BLUE',
  Clay = 'CLAY',
  Cream = 'CREAM',
  Green = 'GREEN',
  Lime = 'LIME',
  Magenta = 'MAGENTA',
  Midnight = 'MIDNIGHT',
  Moss = 'MOSS',
  Orange = 'ORANGE',
  Pink = 'PINK',
  Purple = 'PURPLE',
  Red = 'RED',
  Sky = 'SKY',
  SoftLime = 'SOFT_LIME',
  Yellow = 'YELLOW'
}

/** Metadata for navigating to a channel */
export type AppPathChannelMetadata = AppPathMetadataInterface & {
  __typename?: 'AppPathChannelMetadata';
  /** Channel ID to navigate to */
  channelId: Scalars['ID']['output'];
  /** Message ID to focus on (optional) */
  messageId?: Maybe<Scalars['ID']['output']>;
  /** Room ID containing the channel */
  roomId: Scalars['ID']['output'];
  /** Type discriminator for push notification processing */
  targetType: NotificationTarget;
};

/** Metadata for navigating to a comment thread */
export type AppPathCommentMetadata = AppPathMetadataInterface & {
  __typename?: 'AppPathCommentMetadata';
  /** Channel ID containing the comment */
  channelId: Scalars['ID']['output'];
  /** Specific comment ID to center on (optional) */
  messageId?: Maybe<Scalars['ID']['output']>;
  /** Parent message ID (the post or root message) */
  parentMessageId: Scalars['ID']['output'];
  /** Room ID containing the comment */
  roomId: Scalars['ID']['output'];
  /** Type discriminator for push notification processing */
  targetType: NotificationTarget;
};

/** Metadata for navigating to a directory */
export type AppPathDirectoryMetadata = AppPathMetadataInterface & {
  __typename?: 'AppPathDirectoryMetadata';
  /** Room ID to navigate to */
  roomId: Scalars['ID']['output'];
  /** Type discriminator for push notification processing */
  targetType: NotificationTarget;
};

/** Metadata for navigating to an episode screen */
export type AppPathEpisodeMetadata = AppPathMetadataInterface & {
  __typename?: 'AppPathEpisodeMetadata';
  /** Episode ID to navigate to */
  episodeId: Scalars['ID']['output'];
  /** Room ID containing the episode */
  roomId: Scalars['ID']['output'];
  /** Type discriminator for push notification processing */
  targetType: NotificationTarget;
};

/** Metadata for navigating to a generic app path */
export type AppPathGenericPathMetadata = AppPathMetadataInterface & {
  __typename?: 'AppPathGenericPathMetadata';
  screenLink: Scalars['String']['output'];
  /** Type discriminator for push notification processing */
  targetType: NotificationTarget;
};

/** Metadata for navigating to a live session */
export type AppPathLiveSessionMetadata = AppPathMetadataInterface & {
  __typename?: 'AppPathLiveSessionMetadata';
  /** Live session ID to navigate to */
  liveSessionId: Scalars['ID']['output'];
  /** Room ID containing the live session */
  roomId: Scalars['ID']['output'];
  /** Type discriminator for push notification processing */
  targetType: NotificationTarget;
};

/** Shared interface for all app path metadata types */
export type AppPathMetadataInterface = {
  /** Type discriminator for push notification processing */
  targetType: NotificationTarget;
};

/** Union of different app path metadata types */
export type AppPathMetadataUnion = AppPathChannelMetadata | AppPathCommentMetadata | AppPathDirectoryMetadata | AppPathEpisodeMetadata | AppPathGenericPathMetadata | AppPathLiveSessionMetadata | AppPathUserConnectionsMetadata | AppPathUserProfileMetadata;

/** Metadata for navigating to user connections */
export type AppPathUserConnectionsMetadata = AppPathMetadataInterface & {
  __typename?: 'AppPathUserConnectionsMetadata';
  /** Type discriminator for push notification processing */
  targetType: NotificationTarget;
  /** User ID for connections navigation */
  userId: Scalars['ID']['output'];
};

/** Metadata for navigating to a user profile */
export type AppPathUserProfileMetadata = AppPathMetadataInterface & {
  __typename?: 'AppPathUserProfileMetadata';
  /** Type discriminator for push notification processing */
  targetType: NotificationTarget;
  /** User ID for profile navigation */
  userId: Scalars['ID']['output'];
};

export type Attachment = {
  __typename?: 'Attachment';
  aspectRatio?: Maybe<Scalars['String']['output']>;
  attachmentType: AttachmentType;
  contentType?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  episode?: Maybe<Episode>;
  event?: Maybe<Event>;
  giphy?: Maybe<Scalars['JSON']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  liveSession?: Maybe<LiveSession>;
  moderationImageUrl?: Maybe<Scalars['String']['output']>;
  muxPlaybackId?: Maybe<Scalars['String']['output']>;
  playbackUrl?: Maybe<Scalars['String']['output']>;
  poll?: Maybe<Poll>;
  predictions?: Maybe<PredictionsGame>;
  qAndAColor?: Maybe<Scalars['String']['output']>;
  qAndAPrompt?: Maybe<Scalars['String']['output']>;
  quoteAuthor?: Maybe<Scalars['String']['output']>;
  quoteText?: Maybe<Scalars['String']['output']>;
  replyPreviews: Array<Message>;
  transcodingState: TranscodingState;
  trivia?: Maybe<TriviaGame>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  videoTitle?: Maybe<Scalars['String']['output']>;
  voiceNoteUrl?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated input type of AttachmentCreate */
export type AttachmentCreateInput = {
  attachmentType: AttachmentType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  giphy?: InputMaybe<Scalars['JSON']['input']>;
  /** Giphy URL — server resolves the full giphy data via the Giphy API */
  giphyUrl?: InputMaybe<Scalars['String']['input']>;
  imageSignedId?: InputMaybe<Scalars['String']['input']>;
  qAndAColor?: InputMaybe<Scalars['String']['input']>;
  qAndAPrompt?: InputMaybe<Scalars['String']['input']>;
  voiceNoteSignedId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AttachmentCreate. */
export type AttachmentCreatePayload = {
  __typename?: 'AttachmentCreatePayload';
  attachment: Attachment;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  muxDirectUploadUrl?: Maybe<Scalars['String']['output']>;
};

export enum AttachmentType {
  Audio = 'AUDIO',
  Episode = 'EPISODE',
  Event = 'EVENT',
  EventPlaybackStart = 'EVENT_PLAYBACK_START',
  Giphy = 'GIPHY',
  Image = 'IMAGE',
  LiveSession = 'LIVE_SESSION',
  Poll = 'POLL',
  Predictions = 'PREDICTIONS',
  Quote = 'QUOTE',
  QAndA = 'Q_AND_A',
  Trivia = 'TRIVIA',
  Video = 'VIDEO'
}

/** Marketing attribution data from URL parameters */
export type AttributionDataInput = {
  /** Amplitude device ID for cross-platform identity linking */
  amplitudeDeviceId?: InputMaybe<Scalars['String']['input']>;
  /** Ad network click ID (fbclid, ttclid, rdt_cid) */
  clickId?: InputMaybe<Scalars['String']['input']>;
  /** Source of the click ID (meta, tiktok, reddit) */
  clickIdSource?: InputMaybe<Scalars['String']['input']>;
  /** URL of the page where the attribution was captured */
  pageUrl?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated [1.1.43] Platform is inferred server-side */
  platform?: InputMaybe<Scalars['String']['input']>;
  /** Referral source identifier */
  ref?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated [1.1.43] No longer tracked */
  referrer?: InputMaybe<Scalars['String']['input']>;
  /** Timestamp when the attribution data was captured */
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
  /** UTM adset parameter */
  utmAdset?: InputMaybe<Scalars['String']['input']>;
  /** UTM campaign parameter */
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  /** UTM content parameter */
  utmContent?: InputMaybe<Scalars['String']['input']>;
  /** UTM medium parameter */
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  /** UTM source parameter */
  utmSource?: InputMaybe<Scalars['String']['input']>;
};

/** An aura account for a user */
export type AuraAccount = {
  __typename?: 'AuraAccount';
  balance: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
};

export type AuraCashOut = {
  __typename?: 'AuraCashOut';
  admin: User;
  auraAmount: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  user: User;
};

/** The connection type for AuraCashOut. */
export type AuraCashOutConnection = {
  __typename?: 'AuraCashOutConnection';
  /** A list of edges. */
  edges: Array<AuraCashOutEdge>;
  /** A list of nodes. */
  nodes: Array<AuraCashOut>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AuraCashOutEdge = {
  __typename?: 'AuraCashOutEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AuraCashOut;
};

/** Autogenerated input type of AuraDecline */
export type AuraDeclineInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the DM room */
  roomId: Scalars['ID']['input'];
};

/** Autogenerated return type of AuraDecline. */
export type AuraDeclinePayload = {
  __typename?: 'AuraDeclinePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  room: Room;
};

export type AuraEarningsEvent = {
  __typename?: 'AuraEarningsEvent';
  amount: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  earningsPlan: EarningsPlan;
  earningsPlanItem: EarningsPlanItem;
  id: Scalars['ID']['output'];
  itemType: EarningsPlanItemType;
  occurredAt: Scalars['ISO8601DateTime']['output'];
  user: User;
};

/** The connection type for AuraEarningsEvent. */
export type AuraEarningsEventConnection = {
  __typename?: 'AuraEarningsEventConnection';
  /** A list of edges. */
  edges: Array<AuraEarningsEventEdge>;
  /** A list of nodes. */
  nodes: Array<AuraEarningsEvent>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AuraEarningsEventEdge = {
  __typename?: 'AuraEarningsEventEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AuraEarningsEvent;
};

export type AuraGift = {
  __typename?: 'AuraGift';
  amount: Scalars['Int']['output'];
  expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  recipient?: Maybe<User>;
  sender?: Maybe<User>;
  status: AuraGiftStatus;
  viewerIsGiver: Scalars['Boolean']['output'];
};

export enum AuraGiftStatus {
  Completed = 'COMPLETED',
  Expired = 'EXPIRED',
  Pending = 'PENDING'
}

/** Autogenerated input type of AuraGive */
export type AuraGiveInput = {
  amount: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  isAnonymous: Scalars['Boolean']['input'];
  messageId: Scalars['ID']['input'];
  publicComment?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AuraGive. */
export type AuraGivePayload = {
  __typename?: 'AuraGivePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  gift: AuraGift;
  message: Message;
  newBalance: Scalars['Int']['output'];
  viewer: User;
};

export type AuraProduct = {
  __typename?: 'AuraProduct';
  auraAmount: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  internalName: Scalars['String']['output'];
  isPaidDmOption: Scalars['Boolean']['output'];
  purchaseOnWalletScreen: Scalars['Boolean']['output'];
  state: SubscriptionProductState;
  store: StoreName;
  storeProductIdentifier: Scalars['String']['output'];
};

/** The connection type for AuraProduct. */
export type AuraProductConnection = {
  __typename?: 'AuraProductConnection';
  /** A list of edges. */
  edges: Array<AuraProductEdge>;
  /** A list of nodes. */
  nodes: Array<AuraProduct>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AuraProductEdge = {
  __typename?: 'AuraProductEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AuraProduct;
};

export type AuraPurchase = {
  __typename?: 'AuraPurchase';
  auraAmount: Scalars['Int']['output'];
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  status: AuraPurchaseStatus;
  store: StoreName;
  user: User;
};

/** Autogenerated input type of AuraPurchase */
export type AuraPurchaseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['String']['input'];
  purchaseToken: Scalars['String']['input'];
  sandbox?: InputMaybe<Scalars['Boolean']['input']>;
  store: StoreName;
};

/** Autogenerated return type of AuraPurchase. */
export type AuraPurchasePayload = {
  __typename?: 'AuraPurchasePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  purchase: AuraPurchase;
  viewer: User;
};

export enum AuraPurchaseStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Refunded = 'REFUNDED'
}

/** Auth type */
export enum AuthType {
  Session = 'SESSION',
  Token = 'TOKEN'
}

export type AuthorizationResult = {
  __typename?: 'AuthorizationResult';
  /** Human-readable error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Reasons of check failure */
  reasons?: Maybe<FailureReasons>;
  /** Result of applying a policy rule */
  value: Scalars['Boolean']['output'];
};

/** Configuration for banner display */
export type BannerConfig = {
  __typename?: 'BannerConfig';
  /** Optional CTA for the banner */
  cta?: Maybe<Cta>;
  /** Optional message override for the banner */
  message?: Maybe<Scalars['String']['output']>;
  shown: Scalars['Boolean']['output'];
  /** Optional title override for the banner */
  title?: Maybe<Scalars['String']['output']>;
};

export type Bounty = {
  __typename?: 'Bounty';
  allHostsEligible: Scalars['Boolean']['output'];
  bountyHunters: UserConnection;
  bountyHuntersCount: Scalars['Int']['output'];
  bountyHuntersPreview: Array<User>;
  expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  reactionAuraGifts: Array<ReactionAura>;
  reactionAuraGiftsCount: Scalars['Int']['output'];
  reactionAuraGiftsTotal: Scalars['Int']['output'];
  targetAmount?: Maybe<Scalars['Int']['output']>;
  viewerIsBountyHunter: Scalars['Boolean']['output'];
};


export type BountyBountyHuntersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type BountyBountyHuntersPreviewArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type BountyReactionAuraGiftsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of BountyAuraGive */
export type BountyAuraGiveInput = {
  amount: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  isAnonymous?: InputMaybe<Scalars['Boolean']['input']>;
  messageId: Scalars['ID']['input'];
};

/** Autogenerated return type of BountyAuraGive. */
export type BountyAuraGivePayload = {
  __typename?: 'BountyAuraGivePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  gift: AuraGift;
  message: Message;
  viewer: User;
};

/** Autogenerated input type of BountyMessageCreate */
export type BountyMessageCreateInput = {
  auraAmount: Scalars['Int']['input'];
  bountyHunterIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  channelId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  messageInput: MessageInput;
};

/** Autogenerated return type of BountyMessageCreate. */
export type BountyMessageCreatePayload = {
  __typename?: 'BountyMessageCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  gift?: Maybe<AuraGift>;
  message?: Maybe<Message>;
  room: Room;
};

export enum BountySort {
  /** Default sort */
  Default = 'DEFAULT',
  /** Newest first */
  New = 'NEW'
}

export enum BountyStatus {
  /** No filter */
  All = 'ALL',
  /** Has been claimed by a host */
  Claimed = 'CLAIMED',
  /** Past expiration date, not claimed */
  Expired = 'EXPIRED',
  /** Not claimed, not expired */
  Pending = 'PENDING'
}

export type Channel = Node & {
  __typename?: 'Channel';
  /** @deprecated Use memberships_count instead */
  activeChannelMembershipsCount: Scalars['Int']['output'];
  channelHandle?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  discardedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The event currently in playback for this channel, if any. */
  eventInPlayback?: Maybe<Event>;
  id: Scalars['ID']['output'];
  isAutoJoin: Scalars['Boolean']['output'];
  isSystem: Scalars['Boolean']['output'];
  isViewerChannelMember: Scalars['Boolean']['output'];
  latestMessage?: Maybe<Message>;
  latestMessageTimestamp?: Maybe<Scalars['ISO8601DateTime']['output']>;
  membershipsCount: Scalars['Int']['output'];
  messageCount: Scalars['Int']['output'];
  mode: ChannelMode;
  name: Scalars['String']['output'];
  pinnedMessages: Array<Message>;
  postingPermission: ChannelPostingPermission;
  promotedAuraThreshold: Scalars['Int']['output'];
  ranking?: Maybe<Scalars['Int']['output']>;
  requiresPaymentSubscription: Scalars['Boolean']['output'];
  room: Room;
  scheduledMessages: MessageConnection;
  seekMarkers?: Maybe<ChannelSeekMarkers>;
  topMessages: MessageConnection;
  /** Temporary key for backwards compatibility starting 1.0.35 */
  typingIndicatorKey?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  viewerCanDestroy: AuthorizationResult;
  viewerCanUpdate: AuthorizationResult;
  viewerChannelMembership?: Maybe<ChannelMembership>;
  viewerHasPaymentSubscriptionAccess: Scalars['Boolean']['output'];
  viewerLatestMessageReadTimestamp?: Maybe<Scalars['ISO8601DateTime']['output']>;
  viewerMessageReadCount: Scalars['Int']['output'];
  /** @deprecated Use viewerChannelMembership.mutedUntil instead */
  viewerMutedUntil?: Maybe<Scalars['ISO8601DateTime']['output']>;
  webUrl?: Maybe<Scalars['String']['output']>;
};


export type ChannelScheduledMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ChannelTopMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated input type of ChannelCreate */
export type ChannelCreateInput = {
  channelInput: ChannelInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  roomId: Scalars['ID']['input'];
};

/** Autogenerated return type of ChannelCreate. */
export type ChannelCreatePayload = {
  __typename?: 'ChannelCreatePayload';
  channel: Channel;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  room: Room;
};

/** Autogenerated input type of ChannelDiscard */
export type ChannelDiscardInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ChannelDiscard. */
export type ChannelDiscardPayload = {
  __typename?: 'ChannelDiscardPayload';
  channel: Channel;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  room: Room;
};

/** A seek marker for channel events */
export type ChannelEventSeekMarker = {
  __typename?: 'ChannelEventSeekMarker';
  event: Event;
  label: Scalars['String']['output'];
  messageId: Scalars['ID']['output'];
};

/** Input for filtering channels */
export type ChannelFilterInput = {
  /** Include discarded channels in results (admin only) */
  includeDiscarded?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter channels by viewer membership status */
  viewerChannelMembership?: InputMaybe<ViewerChannelMembershipFilter>;
};

export type ChannelInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<ChannelMode>;
  name?: InputMaybe<Scalars['String']['input']>;
  postingPermission?: InputMaybe<ChannelPostingPermission>;
  ranking?: InputMaybe<Scalars['Int']['input']>;
  webUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of ChannelJoin */
export type ChannelJoinInput = {
  channelId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ChannelJoin. */
export type ChannelJoinPayload = {
  __typename?: 'ChannelJoinPayload';
  channel: Channel;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  isNewRoomMembership: Scalars['Boolean']['output'];
  room: Room;
};

/** Autogenerated input type of ChannelLeave */
export type ChannelLeaveInput = {
  channelId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ChannelLeave. */
export type ChannelLeavePayload = {
  __typename?: 'ChannelLeavePayload';
  channel: Channel;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  room: Room;
};

/** Input for marking a channel as read */
export type ChannelMarkReadInput = {
  /** The ID of the channel to mark as read */
  channelId: Scalars['ID']['input'];
  /** The timestamp up to which messages should be marked as read */
  timestamp: Scalars['ISO8601DateTime']['input'];
};

export type ChannelMembership = Node & {
  __typename?: 'ChannelMembership';
  id: Scalars['ID']['output'];
  mutedUntil?: Maybe<Scalars['ISO8601DateTime']['output']>;
  notifyFor: ChannelMembershipNotifyFor;
};

/** Input for updating channel membership settings */
export type ChannelMembershipInput = {
  /** Who to receive notifications from in this channel */
  notifyFor?: InputMaybe<ChannelMembershipNotifyFor>;
};

export enum ChannelMembershipNotifyFor {
  Everyone = 'EVERYONE',
  HostsAndFollowees = 'HOSTS_AND_FOLLOWEES',
  OnlyFollowees = 'ONLY_FOLLOWEES',
  OnlyHosts = 'ONLY_HOSTS'
}

/** Autogenerated input type of ChannelMembershipUpdate */
export type ChannelMembershipUpdateInput = {
  channelId: Scalars['ID']['input'];
  channelMembershipInput: ChannelMembershipInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ChannelMembershipUpdate. */
export type ChannelMembershipUpdatePayload = {
  __typename?: 'ChannelMembershipUpdatePayload';
  channelMembership: ChannelMembership;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Channel mode enum - represents the type of channel */
export enum ChannelMode {
  /** Bounty channel for posting and claiming bounties */
  Bounty = 'BOUNTY',
  /** Chat-style with real-time messaging */
  Chat = 'CHAT',
  /** Forum-style with posts and pinned content */
  Forum = 'FORUM'
}

/** Channel posting permission enum - represents who can post in a channel */
export enum ChannelPostingPermission {
  /** Only channel hosts/admins can post */
  Host = 'HOST',
  /** Anyone with access can post */
  Open = 'OPEN'
}

/** A seek marker for navigating channel history */
export type ChannelSeekMarker = {
  __typename?: 'ChannelSeekMarker';
  label: Scalars['String']['output'];
  messageId?: Maybe<Scalars['ID']['output']>;
};

/** Seek markers for navigating channel history */
export type ChannelSeekMarkers = {
  __typename?: 'ChannelSeekMarkers';
  /** Event-based markers (episodes, announcements, etc.) */
  eventMarkers: Array<ChannelEventSeekMarker>;
  /** Time-based markers (1 hour ago, 1 day ago, etc.) */
  timeMarkers: Array<ChannelSeekMarker>;
};

/** Autogenerated input type of ChannelUpdate */
export type ChannelUpdateInput = {
  channelInput: ChannelInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ChannelUpdate. */
export type ChannelUpdatePayload = {
  __typename?: 'ChannelUpdatePayload';
  channel: Channel;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CheckSubscriptionStatus */
export type CheckSubscriptionStatusInput = {
  channelId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CheckSubscriptionStatus. */
export type CheckSubscriptionStatusPayload = {
  __typename?: 'CheckSubscriptionStatusPayload';
  active: Scalars['Boolean']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of ClearStoreReviewPromptTimestamp */
export type ClearStoreReviewPromptTimestampInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ClearStoreReviewPromptTimestamp. */
export type ClearStoreReviewPromptTimestampPayload = {
  __typename?: 'ClearStoreReviewPromptTimestampPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  storeReviewPrompt: StoreReviewPrompt;
};

export type Config = Node & {
  __typename?: 'Config';
  appDownloadUrl: Scalars['String']['output'];
  /** Needed temporarily until app adoption of 1.1.22+ is high */
  dmDisabled: Scalars['Boolean']['output'];
  /** When true, audience viewers see the Fishjam WHEP stream; when false, they see Mux HLS */
  fishjamBroadcastDisplay: Scalars['Boolean']['output'];
  /** Fishjam app ID for live streaming SDK initialization */
  fishjamId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Quality preset the client should use when re-encoding and cropping user-uploaded images */
  imageQuality: ImageQuality;
  /** Maximum number of active participants (on-stage and backstage) allowed in a Live Space */
  liveSpacesMaxParticipants: Scalars['Int']['output'];
};

export type ContactInput = {
  contactName?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type ContentReport = Node & {
  __typename?: 'ContentReport';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

/** Autogenerated input type of ContentReportCreate */
export type ContentReportCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  messageId: Scalars['ID']['input'];
};

/** Autogenerated return type of ContentReportCreate. */
export type ContentReportCreatePayload = {
  __typename?: 'ContentReportCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum ContentSuggestionType {
  DiscussionQuestion = 'discussion_question',
  Poll = 'poll',
  Quote = 'quote',
  TriviaQuestion = 'trivia_question'
}

/** Autogenerated input type of CredentialsUserAuth */
export type CredentialsUserAuthInput = {
  authType?: InputMaybe<AuthType>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  rememberMe: Scalars['Boolean']['input'];
};

/** Autogenerated return type of CredentialsUserAuth. */
export type CredentialsUserAuthPayload = {
  __typename?: 'CredentialsUserAuthPayload';
  authToken?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  csrfToken: Scalars['String']['output'];
  user?: Maybe<User>;
};

/** Call-to-action configuration with link and text */
export type Cta = {
  __typename?: 'Cta';
  /** URL for the CTA */
  link: Scalars['String']['output'];
  /** Display text for the CTA */
  text: Scalars['String']['output'];
};

/** Autogenerated input type of DeleteAccount */
export type DeleteAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Optional additional feedback (truncated to 256 characters if longer) */
  feedback?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<AccountDeletionReason>;
};

/** Autogenerated return type of DeleteAccount. */
export type DeleteAccountPayload = {
  __typename?: 'DeleteAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  viewer?: Maybe<User>;
};

export type DemoCsvRowError = {
  __typename?: 'DemoCsvRowError';
  errors: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  rowNumber: Scalars['Int']['output'];
};

export type DemoUserInput = {
  /** signedId of a presigned uploaded image */
  avatar?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  verifiedAccount?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents a Demo Room Workflow associated with a room */
export type DemoWorkflow = Node & {
  __typename?: 'DemoWorkflow';
  /** An ordered list of all possible workflow states. */
  allWorkflowStates: Array<DemoWorkflowState>;
  currentWorkflowState: DemoWorkflowState;
  /** Error message if the workflow failed or has issues. */
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  stepCompletionPercentage: Scalars['Float']['output'];
};

/** Possible states for a Demo Room Workflow */
export enum DemoWorkflowState {
  Complete = 'COMPLETE',
  CreateChatters = 'CREATE_CHATTERS',
  GenerateComments = 'GENERATE_COMMENTS',
  GenerateReactions = 'GENERATE_REACTIONS',
  ImportMainChatMessages = 'IMPORT_MAIN_CHAT_MESSAGES',
  Initial = 'INITIAL'
}

/** Autogenerated input type of DirectMessageCreate */
export type DirectMessageCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  recaptchaToken?: InputMaybe<Scalars['String']['input']>;
  /** Array of recipient user IDs (excluding current user) */
  recipientUserIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of DirectMessageCreate. */
export type DirectMessageCreatePayload = {
  __typename?: 'DirectMessageCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  room: Room;
};

/** DM aura gift status filter for inbox rooms */
export enum DmAuraGiftStatus {
  WithoutPendingAura = 'WITHOUT_PENDING_AURA',
  WithPendingAura = 'WITH_PENDING_AURA'
}

export type EarningsPlan = {
  __typename?: 'EarningsPlan';
  createdAt: Scalars['ISO8601DateTime']['output'];
  endsAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  planItems: Array<EarningsPlanItem>;
  room: Room;
  roomId: Scalars['ID']['output'];
  startsAt: Scalars['ISO8601DateTime']['output'];
  users: Array<User>;
};


export type EarningsPlanPlanItemsArgs = {
  itemType?: InputMaybe<EarningsPlanItemType>;
};

/** The connection type for EarningsPlan. */
export type EarningsPlanConnection = {
  __typename?: 'EarningsPlanConnection';
  /** A list of edges. */
  edges: Array<EarningsPlanEdge>;
  /** A list of nodes. */
  nodes: Array<EarningsPlan>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EarningsPlanEdge = {
  __typename?: 'EarningsPlanEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: EarningsPlan;
};

export type EarningsPlanItem = {
  __typename?: 'EarningsPlanItem';
  amount: Scalars['Int']['output'];
  amountEarned: Scalars['Int']['output'];
  amountEarnedTowardsLimit?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  internalDescription?: Maybe<Scalars['String']['output']>;
  itemType: EarningsPlanItemType;
  limitAmount?: Maybe<Scalars['Int']['output']>;
  limitDescription: Scalars['String']['output'];
  limitTimeFrame?: Maybe<EarningsPlanItemLimitTimeFrame>;
  messagesRequired?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
};


export type EarningsPlanItemAmountEarnedArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
  withEarningsEnd?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  withEarningsStart?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};


export type EarningsPlanItemAmountEarnedTowardsLimitArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type EarningsPlanItemInput = {
  amount: Scalars['Int']['input'];
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  itemType: EarningsPlanItemType;
  limitAmount?: InputMaybe<Scalars['Int']['input']>;
  limitTimeFrame?: InputMaybe<EarningsPlanItemLimitTimeFrame>;
  messagesRequired?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Earnings plan item limit time frame */
export enum EarningsPlanItemLimitTimeFrame {
  AllTime = 'ALL_TIME',
  PerMonth = 'PER_MONTH',
  PerWeek = 'PER_WEEK'
}

/** Earnings plan item type */
export enum EarningsPlanItemType {
  ActivityFeePerChatEventWithMessages = 'ACTIVITY_FEE_PER_CHAT_EVENT_WITH_MESSAGES',
  ActivityFeePerDayWithMessage = 'ACTIVITY_FEE_PER_DAY_WITH_MESSAGE',
  ActivityFeePerMessage = 'ACTIVITY_FEE_PER_MESSAGE',
  ActivityFeePerWeekWithMessage = 'ACTIVITY_FEE_PER_WEEK_WITH_MESSAGE',
  ReferralBonus = 'REFERRAL_BONUS',
  SpecialBonusTopMessageOfWeek = 'SPECIAL_BONUS_TOP_MESSAGE_OF_WEEK'
}

/** Type for the earnings screen data */
export type EarningsScreen = {
  __typename?: 'EarningsScreen';
  amountEarned: Scalars['Int']['output'];
  auraAmountEarned: Scalars['Int']['output'];
  auraEarningsDescription: Scalars['String']['output'];
  earningsEvents: AuraEarningsEventConnection;
  id: Scalars['ID']['output'];
  plans: EarningsPlanConnection;
};


/** Type for the earnings screen data */
export type EarningsScreenAmountEarnedArgs = {
  withEarningsEnd?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  withEarningsStart?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};


/** Type for the earnings screen data */
export type EarningsScreenAuraAmountEarnedArgs = {
  withEarningsEnd?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  withEarningsStart?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};


/** Type for the earnings screen data */
export type EarningsScreenEarningsEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  earningsPlanId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Type for the earnings screen data */
export type EarningsScreenPlansArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeAllUsers?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  roomId?: InputMaybe<Scalars['ID']['input']>;
  withEarningsEnd?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  withEarningsStart?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** Autogenerated input type of EmailTokenUserAuth */
export type EmailTokenUserAuthInput = {
  authType?: InputMaybe<AuthType>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  timeZone: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

/** Autogenerated return type of EmailTokenUserAuth. */
export type EmailTokenUserAuthPayload = {
  __typename?: 'EmailTokenUserAuthPayload';
  authToken?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  csrfToken: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of EmailUserAuthChallenge */
export type EmailUserAuthChallengeInput = {
  clientAuthCode: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};

/** Autogenerated return type of EmailUserAuthChallenge. */
export type EmailUserAuthChallengePayload = {
  __typename?: 'EmailUserAuthChallengePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of EnterWaitlistPassword */
export type EnterWaitlistPasswordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
};

/** Autogenerated return type of EnterWaitlistPassword. */
export type EnterWaitlistPasswordPayload = {
  __typename?: 'EnterWaitlistPasswordPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  viewer: User;
};

export type Episode = {
  __typename?: 'Episode';
  channelId: Scalars['ID']['output'];
  clips: MessageConnection;
  description?: Maybe<Scalars['String']['output']>;
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  episodeMessage?: Maybe<Message>;
  feedMessages: MessageConnection;
  id: Scalars['ID']['output'];
  previewComments: Array<Message>;
  publishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  source?: Maybe<EpisodeSource>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  transcriptChapters?: Maybe<Array<TranscriptChapter>>;
  youtubeId: Scalars['String']['output'];
};


export type EpisodeClipsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type EpisodeFeedMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<MessagesSort>;
};

export type EpisodeSource = {
  __typename?: 'EpisodeSource';
  id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type Event = {
  __typename?: 'Event';
  /** Whether the event's channels are auto-pinned. */
  autoPin: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  ended: Scalars['Boolean']['output'];
  endsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  link?: Maybe<Scalars['String']['output']>;
  /** Timezone suffixes considered 'live' for this event. nil means all timezones are live (no playback audience). */
  liveTimezones?: Maybe<Array<Scalars['String']['output']>>;
  /** Whether channel pins stay up until the event ends (count-up while live). */
  pinUntilEnd: Scalars['Boolean']['output'];
  playbackEnabled: Scalars['Boolean']['output'];
  playbackEndsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * Timezone reference labels (e.g. 'pt', 'mdt') that are NOT in the event's
   * live_timezones — i.e. the references that default into the playback audience.
   * Empty when live_timezones is nil (all timezones treated as live).
   */
  playbackTimezoneReferences: Array<Scalars['String']['output']>;
  secondsUntilStart: Scalars['Int']['output'];
  started: Scalars['Boolean']['output'];
  startsAt: Scalars['ISO8601DateTime']['output'];
  title: Scalars['String']['output'];
  user?: Maybe<User>;
  viewerCanUpdate: AuthorizationResult;
};

/** Autogenerated input type of EventCreate */
export type EventCreateInput = {
  /** Channels to announce in (defaults to the event channels). */
  announcementChannelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** When true, creates the event as the ChatBCC system user. Admin only. */
  asSystemUser?: InputMaybe<Scalars['Boolean']['input']>;
  /** Auto-pin the event in its channels. */
  autoPin?: InputMaybe<Scalars['Boolean']['input']>;
  /** Single event channel (mobile). Use channel_ids for multiple. */
  channelId?: InputMaybe<Scalars['ID']['input']>;
  /** Event channels. */
  channelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventInput: EventInput;
  /** Announcement message text. */
  messageText?: InputMaybe<Scalars['String']['input']>;
  /** Keep the pins up until the event ends (count-up while live). */
  pinUntilEnd?: InputMaybe<Scalars['Boolean']['input']>;
  /** When to send the announcement. */
  sendAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** Autogenerated return type of EventCreate. */
export type EventCreatePayload = {
  __typename?: 'EventCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  event: Event;
  message?: Maybe<Message>;
};

/** Autogenerated input type of EventDelete */
export type EventDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of EventDelete. */
export type EventDeletePayload = {
  __typename?: 'EventDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  event: Event;
};

export type EventInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  endsAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  /**
   * Timezone suffixes considered 'live' for this event (e.g. ['et', 'ct']).
   * Viewers outside these timezones default into the playback audience.
   */
  liveTimezones?: InputMaybe<Array<Scalars['String']['input']>>;
  playbackEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  startsAt: Scalars['ISO8601DateTime']['input'];
  title: Scalars['String']['input'];
};

export type EventScheduleInput = {
  eventInput: EventInput;
  /** Optional announcement message text for this event */
  messageText?: InputMaybe<Scalars['String']['input']>;
  /** When to send the announcement message for this event */
  sendAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** Autogenerated input type of EventUpdate */
export type EventUpdateInput = {
  /** Toggle auto-pin on the event's channels. */
  autoPin?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventInput: EventInput;
  id: Scalars['ID']['input'];
  /** When auto-pinning, keep the pins up until the event ends. */
  pinUntilEnd?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of EventUpdate. */
export type EventUpdatePayload = {
  __typename?: 'EventUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  event: Event;
};

/** Autogenerated input type of EventsCreate */
export type EventsCreateInput = {
  /** Channels to announce in. */
  announcementChannelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** When true, creates the events as the ChatBCC system user. Admin only. */
  asSystemUser?: InputMaybe<Scalars['Boolean']['input']>;
  /** Auto-pin every created event. */
  autoPin?: InputMaybe<Scalars['Boolean']['input']>;
  /** Event channels for every created event. */
  channelIds: Array<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Events to create (each an event input plus an optional announcement) */
  events: Array<EventScheduleInput>;
  /** Keep the pins up until each event ends (count-up while live). */
  pinUntilEnd?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of EventsCreate. */
export type EventsCreatePayload = {
  __typename?: 'EventsCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  events: Array<Event>;
  skippedCount: Scalars['Int']['output'];
};

/** Event filter type */
export enum EventsFilter {
  /** Events that have ended (sorted descending) */
  Past = 'PAST',
  /** Events starting in the future (sorted ascending) */
  Upcoming = 'UPCOMING'
}

export type FailureReasons = {
  __typename?: 'FailureReasons';
  /** JSON-encoded map of reasons */
  details: Scalars['String']['output'];
  /** Human-readable errors */
  fullMessages: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of FeedbackSubmit */
export type FeedbackSubmitInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of FeedbackSubmit. */
export type FeedbackSubmitPayload = {
  __typename?: 'FeedbackSubmitPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Followers/following users sort type */
export enum FollowSort {
  FollowerCount = 'FOLLOWER_COUNT',
  FollowDate = 'FOLLOW_DATE'
}

/** Represents an error returned as part of a GraphQL query result */
export type GraphqlResultError = {
  __typename?: 'GraphqlResultError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type GraphqlSubscription = {
  __typename?: 'GraphqlSubscription';
  /** @deprecated [1.0.35] Use rooms_list_event instead */
  appNotifications?: Maybe<NotificationsPayload>;
  liveSessionEvent?: Maybe<LiveSessionEventPayload>;
  messageEvent?: Maybe<MessageEventPayload>;
  predictionsResults?: Maybe<PredictionsResultsPayload>;
  roomEvent?: Maybe<RoomEventPayload>;
  roomsListEvent?: Maybe<RoomsListEventPayload>;
  triviaResults?: Maybe<TriviaResultsPayload>;
  typingIndication?: Maybe<TypingIndicationPayload>;
  /** Inbox events for the current user's direct messages */
  userInboxEvent?: Maybe<UserInboxEventPayload>;
};


export type GraphqlSubscriptionAppNotificationsArgs = {
  userId: Scalars['ID']['input'];
};


export type GraphqlSubscriptionLiveSessionEventArgs = {
  liveSessionId: Scalars['ID']['input'];
};


export type GraphqlSubscriptionMessageEventArgs = {
  channelId?: InputMaybe<Scalars['ID']['input']>;
  messageType?: InputMaybe<MessageType>;
  parentMessageId?: InputMaybe<Scalars['ID']['input']>;
  roomId?: InputMaybe<Scalars['ID']['input']>;
};


export type GraphqlSubscriptionPredictionsResultsArgs = {
  predictionsGameId: Scalars['ID']['input'];
};


export type GraphqlSubscriptionRoomEventArgs = {
  roomId: Scalars['ID']['input'];
};


export type GraphqlSubscriptionTriviaResultsArgs = {
  triviaGameId: Scalars['ID']['input'];
};


export type GraphqlSubscriptionTypingIndicationArgs = {
  roomId: Scalars['ID']['input'];
};

/** Quality preset the client should use when re-encoding and cropping user-uploaded images */
export enum ImageQuality {
  /** Larger files, retina-grade fidelity */
  High = 'HIGH',
  /** Smaller files, lower fidelity (legacy default) */
  Standard = 'STANDARD'
}

/** Update payload for inbox room events */
export type InboxRoomUpdate = {
  __typename?: 'InboxRoomUpdate';
  room: Room;
  user: User;
};

/** Type for the inbox/DM screen data */
export type InboxScreen = {
  __typename?: 'InboxScreen';
  id: Scalars['ID']['output'];
  previewPendingAuraRooms: Array<Room>;
  rooms: RoomConnection;
  suggestedUsers: Array<User>;
  totalPendingAura: Scalars['Int']['output'];
};


/** Type for the inbox/DM screen data */
export type InboxScreenPreviewPendingAuraRoomsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** Type for the inbox/DM screen data */
export type InboxScreenRoomsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  dmAuraGiftStatus?: InputMaybe<DmAuraGiftStatus>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  membershipState?: InputMaybe<RoomMembershipState>;
};

/** RoomInvitation invitation_type */
export enum InvitationType {
  /** Room admin invitation */
  Admin = 'ADMIN',
  /** Room follower invitation */
  Follower = 'FOLLOWER',
  /** Room member invitation */
  Member = 'MEMBER',
  /** Room moderator invitation */
  Moderator = 'MODERATOR'
}

/** Autogenerated input type of InviteRoomFollowers */
export type InviteRoomFollowersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contacts: Array<ContactInput>;
  inviterId?: InputMaybe<Scalars['ID']['input']>;
  roomId?: InputMaybe<Scalars['ID']['input']>;
  sendSms?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of InviteRoomFollowers. */
export type InviteRoomFollowersPayload = {
  __typename?: 'InviteRoomFollowersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  existingUserInvitedCount: Scalars['Int']['output'];
  newUserInvitedCount: Scalars['Int']['output'];
  room?: Maybe<Room>;
};

/** Autogenerated input type of InviteRoomMembers */
export type InviteRoomMembersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contacts: Array<ContactInput>;
  role?: InputMaybe<RoomMembershipRole>;
  roomId: Scalars['ID']['input'];
};

/** Autogenerated return type of InviteRoomMembers. */
export type InviteRoomMembersPayload = {
  __typename?: 'InviteRoomMembersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  existingUserInvitedCount: Scalars['Int']['output'];
  newUserInvitedCount: Scalars['Int']['output'];
  room: Room;
};

export type IpGeolocation = {
  __typename?: 'IpGeolocation';
  /** The country code determined from the client's IP address. */
  countryCode?: Maybe<Scalars['String']['output']>;
};

export type LiveParticipant = {
  __typename?: 'LiveParticipant';
  id: Scalars['ID']['output'];
  invitedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  joinedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  onStage: Scalars['Boolean']['output'];
  role: LiveParticipantRole;
  user: User;
};

/** Live participant role enum */
export enum LiveParticipantRole {
  Admin = 'ADMIN',
  Participant = 'PARTICIPANT'
}

export type LiveSession = {
  __typename?: 'LiveSession';
  announcementMessage?: Maybe<Message>;
  backend: LiveSessionBackend;
  /** Backend-specific room identifier used for broadcasting (e.g. fishjam_room_id for Fishjam) */
  broadcastingRoomId?: Maybe<Scalars['String']['output']>;
  createdBy: User;
  description?: Maybe<Scalars['String']['output']>;
  endedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  invitedParticipants: Array<LiveParticipant>;
  liveChatMessage?: Maybe<Message>;
  muxPlaybackId?: Maybe<Scalars['String']['output']>;
  participants: Array<LiveParticipant>;
  participantsOnstageCount: Scalars['Int']['output'];
  participantsOnstagePreview: Array<User>;
  replayAssetAvailable: Scalars['Boolean']['output'];
  replayAvailable: Scalars['Boolean']['output'];
  replayPlaybackId?: Maybe<Scalars['String']['output']>;
  room: Room;
  startedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  status: LiveSessionStatus;
  title: Scalars['String']['output'];
  viewCount: Scalars['Int']['output'];
  viewerCount: Scalars['Int']['output'];
};


export type LiveSessionParticipantsOnstagePreviewArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Live session backend enum */
export enum LiveSessionBackend {
  Fishjam = 'FISHJAM',
  Livekit = 'LIVEKIT'
}

/** Autogenerated input type of LiveSessionCreateOrJoin */
export type LiveSessionCreateOrJoinInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  liveSessionInput: LiveSessionInput;
  roomId: Scalars['ID']['input'];
};

/** Autogenerated return type of LiveSessionCreateOrJoin. */
export type LiveSessionCreateOrJoinPayload = {
  __typename?: 'LiveSessionCreateOrJoinPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  liveSession: LiveSession;
  serverUrl?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of LiveSessionEnd */
export type LiveSessionEndInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  liveSessionId: Scalars['ID']['input'];
};

/** Autogenerated return type of LiveSessionEnd. */
export type LiveSessionEndPayload = {
  __typename?: 'LiveSessionEndPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  liveSession: LiveSession;
};

/** Autogenerated return type of LiveSessionEvent. */
export type LiveSessionEventPayload = {
  __typename?: 'LiveSessionEventPayload';
  liveSessionUpdated?: Maybe<LiveSession>;
  participantJoined?: Maybe<LiveSessionParticipantEvent>;
  participantLeft?: Maybe<LiveSessionParticipantEvent>;
  participantStageUpdated?: Maybe<LiveParticipant>;
  participantUpdated?: Maybe<LiveParticipant>;
};

/** Autogenerated input type of LiveSessionFinalize */
export type LiveSessionFinalizeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  liveSessionId: Scalars['ID']['input'];
  saveReplay: Scalars['Boolean']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of LiveSessionFinalize. */
export type LiveSessionFinalizePayload = {
  __typename?: 'LiveSessionFinalizePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  liveSession: LiveSession;
};

/** Autogenerated input type of LiveSessionGoBackstage */
export type LiveSessionGoBackstageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  liveSessionId: Scalars['ID']['input'];
};

/** Autogenerated return type of LiveSessionGoBackstage. */
export type LiveSessionGoBackstagePayload = {
  __typename?: 'LiveSessionGoBackstagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  liveParticipant: LiveParticipant;
};

/** Autogenerated input type of LiveSessionGoOnStage */
export type LiveSessionGoOnStageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  liveSessionId: Scalars['ID']['input'];
};

/** Autogenerated return type of LiveSessionGoOnStage. */
export type LiveSessionGoOnStagePayload = {
  __typename?: 'LiveSessionGoOnStagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  liveParticipant: LiveParticipant;
};

export type LiveSessionInput = {
  backend?: InputMaybe<LiveSessionBackend>;
  description?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of LiveSessionInviteParticipant */
export type LiveSessionInviteParticipantInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  liveSessionId: Scalars['ID']['input'];
  role?: InputMaybe<LiveParticipantRole>;
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of LiveSessionInviteParticipant. */
export type LiveSessionInviteParticipantPayload = {
  __typename?: 'LiveSessionInviteParticipantPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  liveParticipant: LiveParticipant;
};

/** Autogenerated input type of LiveSessionJoin */
export type LiveSessionJoinInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  liveSessionId: Scalars['ID']['input'];
};

/** Autogenerated return type of LiveSessionJoin. */
export type LiveSessionJoinPayload = {
  __typename?: 'LiveSessionJoinPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  liveParticipant?: Maybe<LiveParticipant>;
  liveSession: LiveSession;
  token?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of LiveSessionLeave */
export type LiveSessionLeaveInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  liveSessionId: Scalars['ID']['input'];
};

/** Autogenerated return type of LiveSessionLeave. */
export type LiveSessionLeavePayload = {
  __typename?: 'LiveSessionLeavePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  liveSession: LiveSession;
  success: Scalars['Boolean']['output'];
};

export type LiveSessionParticipantEvent = {
  __typename?: 'LiveSessionParticipantEvent';
  liveSession: LiveSession;
  participant: LiveParticipant;
};

/** Autogenerated input type of LiveSessionStart */
export type LiveSessionStartInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  liveSessionId: Scalars['ID']['input'];
};

/** Autogenerated return type of LiveSessionStart. */
export type LiveSessionStartPayload = {
  __typename?: 'LiveSessionStartPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  liveSession: LiveSession;
};

/** Live session status enum */
export enum LiveSessionStatus {
  Cancelled = 'CANCELLED',
  Ended = 'ENDED',
  Pending = 'PENDING',
  Started = 'STARTED'
}

/** Autogenerated input type of LiveSessionUpdate */
export type LiveSessionUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  liveSessionId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of LiveSessionUpdateParticipantRole */
export type LiveSessionUpdateParticipantRoleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  liveSessionId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
  role: LiveParticipantRole;
};

/** Autogenerated return type of LiveSessionUpdateParticipantRole. */
export type LiveSessionUpdateParticipantRolePayload = {
  __typename?: 'LiveSessionUpdateParticipantRolePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  liveParticipant: LiveParticipant;
};

/** Autogenerated return type of LiveSessionUpdate. */
export type LiveSessionUpdatePayload = {
  __typename?: 'LiveSessionUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  liveSession: LiveSession;
};

/** Autogenerated input type of LiveSpacesIncrementView */
export type LiveSpacesIncrementViewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  liveSessionId: Scalars['ID']['input'];
};

/** Autogenerated return type of LiveSpacesIncrementView. */
export type LiveSpacesIncrementViewPayload = {
  __typename?: 'LiveSpacesIncrementViewPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  liveSession: LiveSession;
};

/** The response type for the location query, containing IP-based geolocation data. */
export type LocationResponse = {
  __typename?: 'LocationResponse';
  /** IP-based geolocation information. */
  ipGeolocation?: Maybe<IpGeolocation>;
};

/** Autogenerated input type of Logout */
export type LogoutInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of Logout. */
export type LogoutPayload = {
  __typename?: 'LogoutPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of MarkChannelRead */
export type MarkChannelReadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readMarks: Array<ChannelMarkReadInput>;
};

/** Autogenerated return type of MarkChannelRead. */
export type MarkChannelReadPayload = {
  __typename?: 'MarkChannelReadPayload';
  channels: Array<Channel>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated [1.1.3] Not needed in mutation response */
  viewer: User;
};

/** Autogenerated input type of MarkCommentsRead */
export type MarkCommentsReadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  commentIds: Array<Scalars['String']['input']>;
  roomId: Scalars['String']['input'];
};

/** Autogenerated return type of MarkCommentsRead. */
export type MarkCommentsReadPayload = {
  __typename?: 'MarkCommentsReadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of MarkNotificationRead */
export type MarkNotificationReadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of MarkNotificationRead. */
export type MarkNotificationReadPayload = {
  __typename?: 'MarkNotificationReadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  notification?: Maybe<Notification>;
};

/** Autogenerated input type of MarkNotificationsViewed */
export type MarkNotificationsViewedInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of MarkNotificationsViewed. */
export type MarkNotificationsViewedPayload = {
  __typename?: 'MarkNotificationsViewedPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
};

/** Autogenerated input type of MarkRead */
export type MarkReadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readMarks: Array<ReadMarkInput>;
};

/** Autogenerated return type of MarkRead. */
export type MarkReadPayload = {
  __typename?: 'MarkReadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  messages: Array<Message>;
  rooms: Array<Room>;
  viewer: User;
};

export type Message = Node & {
  __typename?: 'Message';
  /** @deprecated [CBC-2533] Unused by mobile clients. */
  adminTextContent?: Maybe<Scalars['String']['output']>;
  attachments: Array<Attachment>;
  /** @deprecated [1.1.29] Use reaction_aura_gifts_total instead */
  auraGiftsTotal: Scalars['Int']['output'];
  /** Bounty information if this message is a bounty question */
  bounty?: Maybe<Bounty>;
  /** @deprecated [CBC-2533] Unused by mobile clients. Use channel_id and the top-level channel query. */
  channel: Channel;
  channelId: Scalars['ID']['output'];
  childMessageUsers: Array<User>;
  childMessagesCount: Scalars['Int']['output'];
  /** @deprecated [CBC-2533] Unused by mobile clients. Admin tooling uses a dedicated query. */
  contentReports: Array<ContentReport>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  defaultCommentSort?: Maybe<MessagesSort>;
  discardedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** DM payment gift attached by message author (for paid-DM) */
  dmAuraGift?: Maybe<AuraGift>;
  editedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  firstReply?: Maybe<Message>;
  id: Scalars['ID']['output'];
  /** Number of unique viewers (admin only). */
  impressionsCount?: Maybe<Scalars['Int']['output']>;
  isQAndAReply: Scalars['Boolean']['output'];
  messageLinks: Array<MessageLink>;
  messageType?: Maybe<MessageType>;
  /** @deprecated [CBC-2533] Unused by mobile clients. Admin tooling uses a dedicated query. */
  moderationResponse?: Maybe<ModerationResponse>;
  /** @deprecated [CBC-2533] Unused by mobile chat feed. Use parent_message_id and resolve via the top-level node query if needed. */
  parentMessage?: Maybe<Message>;
  parentMessageId?: Maybe<Scalars['ID']['output']>;
  paymentSubscriberOnly?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated [1.1.56] use pinnedChannelIds instead */
  pinned: Scalars['Boolean']['output'];
  pinnedChannelIds: Array<Scalars['ID']['output']>;
  promoted: Scalars['Boolean']['output'];
  promotedChildren: Array<Message>;
  quotedMessage?: Maybe<Message>;
  reactionAuraGifts: Array<ReactionAura>;
  reactionAuraGiftsTotal: Scalars['Int']['output'];
  reactionGroups: Array<ReactionGroup>;
  /** @deprecated [CBC-2533] Unused by mobile clients. Use reaction_groups instead. */
  reactionsCount: Scalars['Int']['output'];
  /** @deprecated [CBC-2533] Unused by mobile clients. Use room_id and the top-level room query. */
  room: Room;
  roomId: Scalars['ID']['output'];
  selfPromoteAuraGiftsTotal: Scalars['Int']['output'];
  /** Time when this message is scheduled to be sent. If null, the message is not scheduled. */
  sendAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  tag?: Maybe<MessageTag>;
  textContent?: Maybe<Scalars['String']['output']>;
  textContentEncrypted?: Maybe<Scalars['String']['output']>;
  textContentHeader?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user?: Maybe<User>;
  userIsRoomHost: Scalars['Boolean']['output'];
  /** @deprecated [1.0.35] Use user_is_room_host instead */
  userIsRoomMember: Scalars['Boolean']['output'];
  /** @deprecated [1.1.40] Use userRoomMembership.vipStatus instead */
  userIsRoomVip: Scalars['Boolean']['output'];
  userRoomMembership?: Maybe<RoomMembership>;
  /**
   * Author's moderation status in this message's room
   * @deprecated [CBC-2533] Unused by mobile clients.
   */
  userRoomModeration?: Maybe<UserRoomModerationStatus>;
  userSubscriberBadgeUrl?: Maybe<Scalars['String']['output']>;
  viewerCanDelete: AuthorizationResult;
  viewerCanUpdate: AuthorizationResult;
  viewerHasCommented: Scalars['Boolean']['output'];
  viewerHasCreatedChildMessage: Scalars['Boolean']['output'];
  visibility: MessageVisibility;
};


export type MessagePromotedChildrenArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type MessageReactionAuraGiftsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of MessageAddToHomeChannel */
export type MessageAddToHomeChannelInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  messageId: Scalars['ID']['input'];
};

/** Autogenerated return type of MessageAddToHomeChannel. */
export type MessageAddToHomeChannelPayload = {
  __typename?: 'MessageAddToHomeChannelPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** True if the ChannelMessage row was created; false if it already existed. */
  created: Scalars['Boolean']['output'];
  message: Message;
};

/** The connection type for Message. */
export type MessageConnection = {
  __typename?: 'MessageConnection';
  /** A list of edges. */
  edges: Array<MessageEdge>;
  /** A list of nodes. */
  nodes: Array<Message>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Autogenerated input type of MessageCreateV2 */
export type MessageCreateV2Input = {
  channelId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  messageInput: MessageInput;
  parentMessageId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of MessageCreateV2. */
export type MessageCreateV2Payload = {
  __typename?: 'MessageCreateV2Payload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Message>;
  room: Room;
  successToast?: Maybe<Scalars['String']['output']>;
  warning?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of MessageDelete */
export type MessageDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of MessageDelete. */
export type MessageDeletePayload = {
  __typename?: 'MessageDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  message: Message;
};

/** An edge in a connection. */
export type MessageEdge = {
  __typename?: 'MessageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Message;
};

/** Autogenerated return type of MessageEvent. */
export type MessageEventPayload = {
  __typename?: 'MessageEventPayload';
  messageAuraReactionsUpdated?: Maybe<Message>;
  messageChildrenUpdated?: Maybe<Message>;
  messageCreated?: Maybe<Message>;
  messagePromotedChildrenUpdated?: Maybe<Message>;
  messageReactionsUpdated?: Maybe<Message>;
  messageUpdated?: Maybe<Message>;
  messagesUpdated?: Maybe<Array<Message>>;
  pollUpdated?: Maybe<Poll>;
  /** @deprecated 1.0.28: Use RoomEvent */
  postMessageCreated?: Maybe<Message>;
  predictionsUpdated?: Maybe<PredictionsGame>;
  triviaUpdated?: Maybe<TriviaGame>;
};

export type MessageInput = {
  attachmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  messageType?: InputMaybe<MessageType>;
  paymentSubscriberOnly?: InputMaybe<Scalars['Boolean']['input']>;
  quotedMessageId?: InputMaybe<Scalars['ID']['input']>;
  /** Optional unique identifier to prevent duplicate message creation */
  requestId?: InputMaybe<Scalars['String']['input']>;
  /** Amount of aura to spend to self-promote this message (only for replies) */
  selfPromoteAuraAmount?: InputMaybe<Scalars['Int']['input']>;
  /** Schedule this message to be sent at a specific time in the future */
  sendAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  textContent?: InputMaybe<Scalars['String']['input']>;
  textContentHeader?: InputMaybe<Scalars['String']['input']>;
};

export type MessageLink = Node & {
  __typename?: 'MessageLink';
  description?: Maybe<Scalars['String']['output']>;
  fallbackImageUrl?: Maybe<Scalars['String']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageHeight?: Maybe<Scalars['Int']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  imageWidth?: Maybe<Scalars['Int']['output']>;
  loading: Scalars['Boolean']['output'];
  position: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

/** Autogenerated input type of MessageRemoveFromHomeChannel */
export type MessageRemoveFromHomeChannelInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  messageId: Scalars['ID']['input'];
};

/** Autogenerated return type of MessageRemoveFromHomeChannel. */
export type MessageRemoveFromHomeChannelPayload = {
  __typename?: 'MessageRemoveFromHomeChannelPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  message: Message;
};

/** Autogenerated input type of MessageRequestAccept */
export type MessageRequestAcceptInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the DM room to accept */
  roomId: Scalars['ID']['input'];
};

/** Autogenerated return type of MessageRequestAccept. */
export type MessageRequestAcceptPayload = {
  __typename?: 'MessageRequestAcceptPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The now-accessible DM room */
  room: Room;
  /** The current user */
  viewer: User;
};

/** Autogenerated input type of MessageRequestDecline */
export type MessageRequestDeclineInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the DM room to decline */
  roomId: Scalars['ID']['input'];
};

/** Autogenerated return type of MessageRequestDecline. */
export type MessageRequestDeclinePayload = {
  __typename?: 'MessageRequestDeclinePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  room: Room;
  /** Whether the request was successfully declined */
  success: Scalars['Boolean']['output'];
  viewer: User;
};

/** Autogenerated input type of MessageRequestPending */
export type MessageRequestPendingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the DM room to set as pending */
  roomId: Scalars['ID']['input'];
};

/** Autogenerated return type of MessageRequestPending. */
export type MessageRequestPendingPayload = {
  __typename?: 'MessageRequestPendingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The DM room */
  room: Room;
  /** The current user */
  viewer: User;
};

/** User's message request privacy setting */
export enum MessageRequestSetting {
  /** Accept DM requests from anyone */
  Anyone = 'ANYONE',
  /** Disable DM requests (only people you follow can send you DMs) */
  Disable = 'DISABLE',
  /** Accept DM requests only from followers */
  Followers = 'FOLLOWERS'
}

export type MessageTag = {
  __typename?: 'MessageTag';
  appPath?: Maybe<AppPathMetadataUnion>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: MessageTagType;
};

export enum MessageTagType {
  Episode = 'EPISODE'
}

/** Autogenerated input type of MessageTogglePin */
export type MessageTogglePinInput = {
  /** Channel to pin/unpin within. Defaults to the message's own channel. */
  channelId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Optional expiration time for the pin (only used when pinning) */
  expiresAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  messageId: Scalars['ID']['input'];
  /** When true, also pins to the room's home channel (only used when pinning) */
  pinToHomeChannel?: InputMaybe<Scalars['Boolean']['input']>;
  pinned: Scalars['Boolean']['input'];
};

/** Autogenerated return type of MessageTogglePin. */
export type MessageTogglePinPayload = {
  __typename?: 'MessageTogglePinPayload';
  channel: Channel;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  message: Message;
  /** @deprecated Use channel instead */
  room?: Maybe<Room>;
};

export enum MessageType {
  MainChat = 'MAIN_CHAT',
  NestedReply = 'NESTED_REPLY',
  Post = 'POST',
  Reply = 'REPLY'
}

/** Autogenerated input type of MessageUpdate */
export type MessageUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  messageInput: MessageInput;
};

/** Autogenerated return type of MessageUpdate. */
export type MessageUpdatePayload = {
  __typename?: 'MessageUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  message: Message;
};

export enum MessageVisibility {
  All = 'ALL',
  Chatters = 'CHATTERS'
}

export enum MessagesSort {
  CenteredCreatedAtDesc = 'CENTERED_CREATED_AT_DESC',
  CommentsCreatedAtAscSelfFirst = 'COMMENTS_CREATED_AT_ASC_SELF_FIRST',
  CommentsReactionCountDescVipFirstSelfFirst = 'COMMENTS_REACTION_COUNT_DESC_VIP_FIRST_SELF_FIRST',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  Engagement = 'ENGAGEMENT',
  EngagementV2 = 'ENGAGEMENT_V2',
  EngagementWithGravity = 'ENGAGEMENT_WITH_GRAVITY',
  LastInteractionAtDesc = 'LAST_INTERACTION_AT_DESC'
}

/** Autogenerated input type of ModerateMessage */
export type ModerateMessageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Message ID to moderate */
  messageId: Scalars['ID']['input'];
  postingRestrictedUntil?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  warnMessage?: InputMaybe<Scalars['String']['input']>;
  warnReason: Scalars['String']['input'];
};

/** Autogenerated return type of ModerateMessage. */
export type ModerateMessagePayload = {
  __typename?: 'ModerateMessagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  message: Message;
  userRoomModerationStatus?: Maybe<UserRoomModerationStatus>;
};

export type ModerationResponse = Node & {
  __typename?: 'ModerationResponse';
  adminPermitted?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  textResponse?: Maybe<Scalars['JSON']['output']>;
  textResponseReport?: Maybe<Scalars['String']['output']>;
  textResult?: Maybe<ModerationResult>;
  visualResponse?: Maybe<Scalars['JSON']['output']>;
  visualResponseReport?: Maybe<Scalars['String']['output']>;
  visualResult?: Maybe<ModerationResult>;
};

export enum ModerationResult {
  AutoRemoved = 'AUTO_REMOVED',
  Error = 'ERROR',
  Flagged = 'FLAGGED',
  Initial = 'INITIAL',
  Ok = 'OK',
  Pending = 'PENDING'
}

export type MonthlyNewMemberStats = {
  __typename?: 'MonthlyNewMemberStats';
  count: Scalars['Int']['output'];
  month: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  adTrackClick: AdTrackClickPayload;
  adTrackImpressions: AdTrackImpressionsPayload;
  adminAdCampaignCreate: AdminAdCampaignCreatePayload;
  adminAdCampaignDelete: AdminAdCampaignDeletePayload;
  adminAdCampaignUpdate: AdminAdCampaignUpdatePayload;
  adminAdCreativeCreate: AdminAdCreativeCreatePayload;
  adminAdCreativeDelete: AdminAdCreativeDeletePayload;
  adminAdCreativeUpdate: AdminAdCreativeUpdatePayload;
  adminAdSponsorCreate: AdminAdSponsorCreatePayload;
  adminAdSponsorDelete: AdminAdSponsorDeletePayload;
  adminAdSponsorUpdate: AdminAdSponsorUpdatePayload;
  adminAuraCashOut: AdminAuraCashOutPayload;
  adminAuraProductCreate: AdminAuraProductCreatePayload;
  adminAuraProductUpdate: AdminAuraProductUpdatePayload;
  /**
   * Toggles whether a content suggestion or reap clip is included when a room's
   * episode announcement publishes. Provide exactly one of contentSuggestionId or
   * reapClipId, plus the room-episode (`episodeId`) being edited.
   */
  adminContentSuggestionToggleSelected: AdminContentSuggestionToggleSelectedPayload;
  /** Adds demo users to a demo room as chatters */
  adminDemoChattersAdd: AdminDemoChattersAddPayload;
  /** Removes a demo user from a demo room */
  adminDemoChattersRemove: AdminDemoChattersRemovePayload;
  /** Generates AI comments and reactions for a demo room */
  adminDemoGenerateEngagement: AdminDemoGenerateEngagementPayload;
  /** Creates a message as a specified demo user in a demo room */
  adminDemoMessageCreate: AdminDemoMessageCreatePayload;
  /** Updates a demo message (text content and/or created_at) */
  adminDemoMessageUpdate: AdminDemoMessageUpdatePayload;
  /** Creates a demo room from a CSV */
  adminDemoRoomCreate: AdminDemoRoomCreatePayload;
  /** Creates a demo room with a default channel */
  adminDemoRoomCreateV2: AdminDemoRoomCreateV2Payload;
  /** Retries a failed demo room workflow by re-queueing the current job. */
  adminDemoRoomRetry: AdminDemoRoomRetryPayload;
  /** Creates a demo user */
  adminDemoUserCreate: AdminDemoUserCreatePayload;
  /** Updates a demo user */
  adminDemoUserUpdate: AdminDemoUserUpdatePayload;
  adminEarningsPlanCreate: AdminEarningsPlanCreatePayload;
  adminEarningsPlanUpdate: AdminEarningsPlanUpdatePayload;
  /**
   * Manually kicks off transcript + reap-clip generation for an episode. Each
   * pipeline only fires when the episode is processable and its current status is
   * pending/failed/skipped.
   */
  adminEpisodeGenerateContent: AdminEpisodeGenerateContentPayload;
  /** Manually publishes a room's episode announcement (selected clips + content) to its feed. */
  adminEpisodePublishAnnouncement: AdminEpisodePublishAnnouncementPayload;
  adminModerateMessage: AdminModerateMessagePayload;
  adminPredictionsGroupCreate: AdminPredictionsGroupCreatePayload;
  adminPredictionsGroupUpdate: AdminPredictionsGroupUpdatePayload;
  adminPredictionsInputResults: AdminPredictionsInputResultsPayload;
  /** Enables or disables bounties for a room */
  adminRoomToggleBounties: AdminRoomToggleBountiesPayload;
  /** Updates a room by id */
  adminRoomUpdate: AdminRoomUpdatePayload;
  adminSubscriptionProductCreate: AdminSubscriptionProductCreatePayload;
  adminSubscriptionProductReposition: AdminSubscriptionProductRepositionPayload;
  /** Update a room subscription product */
  adminSubscriptionProductUpdate: AdminSubscriptionProductUpdatePayload;
  /** Creates a new admin user */
  adminUserCreate: AdminUserCreatePayload;
  /** Creates a user moderation record (admin only) */
  adminUserModerationCreate: AdminUserModerationCreatePayload;
  /** Deletes a user moderation record (admin only) */
  adminUserModerationDelete: AdminUserModerationDeletePayload;
  /** Updates a user moderation record (admin only) */
  adminUserModerationUpdate: AdminUserModerationUpdatePayload;
  /** Suspends or unsuspends a user (admin only) */
  adminUserSuspend: AdminUserSuspendPayload;
  /** Updates a user by id */
  adminUserUpdate: AdminUserUpdatePayload;
  /** Adds a YouTube source to a room and kicks off the initial sync */
  adminYoutubeSourceCreate: AdminYoutubeSourceCreatePayload;
  attachmentCreate: AttachmentCreatePayload;
  /** Decline pending aura gifts in a direct message room */
  auraDecline: AuraDeclinePayload;
  auraGive: AuraGivePayload;
  auraPurchase: AuraPurchasePayload;
  bountyAuraGive: BountyAuraGivePayload;
  bountyMessageCreate: BountyMessageCreatePayload;
  /** Creates a new channel in a room */
  channelCreate: ChannelCreatePayload;
  /** Discards a channel. Cannot discard the main chat channel. */
  channelDiscard: ChannelDiscardPayload;
  channelJoin: ChannelJoinPayload;
  channelLeave: ChannelLeavePayload;
  /** Updates the current user's channel membership settings */
  channelMembershipUpdate: ChannelMembershipUpdatePayload;
  channelUpdate: ChannelUpdatePayload;
  checkSubscriptionStatus: CheckSubscriptionStatusPayload;
  /** Clears the store review prompt timestamp for the current user (dev tools) */
  clearStoreReviewPromptTimestamp: ClearStoreReviewPromptTimestampPayload;
  /** Creates a new report */
  contentReportCreate: ContentReportCreatePayload;
  credentialsUserAuth: CredentialsUserAuthPayload;
  /** Request account deletion */
  deleteAccount: DeleteAccountPayload;
  directMessageCreate: DirectMessageCreatePayload;
  /** Authenticate a user with an email token */
  emailTokenUserAuth: EmailTokenUserAuthPayload;
  /** Send an email to the user with a challenge code */
  emailUserAuthChallenge: EmailUserAuthChallengePayload;
  /** Enters waitlist password */
  enterWaitlistPassword: EnterWaitlistPasswordPayload;
  /** Creates a new event, optionally associating it with channels and scheduling announcements */
  eventCreate: EventCreatePayload;
  /** Deletes an event */
  eventDelete: EventDeletePayload;
  /** Updates an existing event */
  eventUpdate: EventUpdatePayload;
  /** Creates many events across the same channels in a single transaction (single create = one element). */
  eventsCreate: EventsCreatePayload;
  /** Submit feedback from user */
  feedbackSubmit: FeedbackSubmitPayload;
  inviteRoomFollowers: InviteRoomFollowersPayload;
  inviteRoomMembers: InviteRoomMembersPayload;
  liveSessionCreateOrJoin: LiveSessionCreateOrJoinPayload;
  liveSessionEnd: LiveSessionEndPayload;
  liveSessionFinalize: LiveSessionFinalizePayload;
  liveSessionGoBackstage: LiveSessionGoBackstagePayload;
  liveSessionGoOnStage: LiveSessionGoOnStagePayload;
  liveSessionInviteParticipant: LiveSessionInviteParticipantPayload;
  liveSessionJoin: LiveSessionJoinPayload;
  liveSessionLeave: LiveSessionLeavePayload;
  liveSessionStart: LiveSessionStartPayload;
  liveSessionUpdate: LiveSessionUpdatePayload;
  liveSessionUpdateParticipantRole: LiveSessionUpdateParticipantRolePayload;
  liveSpacesIncrementView: LiveSpacesIncrementViewPayload;
  logout: LogoutPayload;
  markChannelRead: MarkChannelReadPayload;
  markCommentsRead: MarkCommentsReadPayload;
  markNotificationRead: MarkNotificationReadPayload;
  markNotificationsViewed: MarkNotificationsViewedPayload;
  markRead: MarkReadPayload;
  /** Adds a root message to the room's home channel */
  messageAddToHomeChannel: MessageAddToHomeChannelPayload;
  /** Creates a new message using channel_id */
  messageCreateV2: MessageCreateV2Payload;
  /** Deletes a message by ID */
  messageDelete: MessageDeletePayload;
  /** Removes a message from the room's home channel */
  messageRemoveFromHomeChannel: MessageRemoveFromHomeChannelPayload;
  /** Accept a pending message request (DM) */
  messageRequestAccept: MessageRequestAcceptPayload;
  /** Decline a pending message request (DM) */
  messageRequestDecline: MessageRequestDeclinePayload;
  /** Update a message request (DM) to pending state */
  messageRequestPending: MessageRequestPendingPayload;
  /** Toggles the pin status of a message */
  messageTogglePin: MessageTogglePinPayload;
  /** Updates a message by id */
  messageUpdate: MessageUpdatePayload;
  /** Moderates a message or user by issuing a warning/restriction */
  moderateMessage: ModerateMessagePayload;
  muteChannel: MuteChannelPayload;
  /** Updates a user's notification config */
  notificationConfigUpdate: NotificationConfigUpdatePayload;
  pollAttachmentCreate: PollAttachmentCreatePayload;
  pollVoteCreate: PollVoteCreatePayload;
  predictionsResponseCreate: PredictionsResponseCreatePayload;
  /** Creates a new reaction */
  reactionCreate: ReactionCreatePayload;
  reactionDelete: ReactionDeletePayload;
  roomArchive: RoomArchivePayload;
  roomChangeInvitationRole: RoomChangeInvitationRolePayload;
  roomChangeRole: RoomChangeRolePayload;
  roomCreate: RoomCreatePayload;
  roomFollow: RoomFollowPayload;
  roomJoin: RoomJoinPayload;
  roomLeave: RoomLeavePayload;
  /** Updates the current user's room membership settings */
  roomMembershipUpdate: RoomMembershipUpdatePayload;
  roomPublish: RoomPublishPayload;
  roomRemoveInvitation: RoomRemoveInvitationPayload;
  roomRemoveMember: RoomRemoveMemberPayload;
  /** Creates a new rule for a room */
  roomRuleCreate: RoomRuleCreatePayload;
  /** Deletes a room rule */
  roomRuleDelete: RoomRuleDeletePayload;
  /** Bulk updates rankings for room rules */
  roomRuleRankingsUpdate: RoomRuleRankingsUpdatePayload;
  /** Updates a room rule */
  roomRuleUpdate: RoomRuleUpdatePayload;
  roomSubmitForApproval: RoomSubmitForApprovalPayload;
  roomUnfollow: RoomUnfollowPayload;
  roomUpdate: RoomUpdatePayload;
  /** Sends a download app link via SMS to the given phone number */
  sendDownloadAppLink: SendDownloadAppLinkPayload;
  /** Sends a friend invite link via SMS to the given phone number */
  sendFriendInviteLink: SendFriendInviteLinkPayload;
  /** Sends a room share link via SMS to the given phone number */
  sendRoomShareLink: SendRoomShareLinkPayload;
  /** Manually triggers a scheduled message to be sent immediately. */
  sendScheduledMessage: SendScheduledMessagePayload;
  setTypingIndication: SetTypingIndicationPayload;
  smsUpdatePhone: SmsUpdatePhonePayload;
  smsUserAuth: SmsUserAuthPayload;
  /** Send a sms to the user with a challenge code */
  smsUserAuthChallenge: SmsUserAuthChallengePayload;
  /** Authenticates a user via SMS code with typed error handling (v2) */
  smsUserAuthV2: SmsUserAuthV2Payload;
  subscriptionAppStoreCreate: SubscriptionAppStoreCreatePayload;
  subscriptionPlayStoreCreate: SubscriptionPlayStoreCreatePayload;
  subscriptionUserInfoUpdate: SubscriptionUserInfoUpdatePayload;
  trackMessageImpressions: TrackMessageImpressionsPayload;
  triviaAttachmentCreate: TriviaAttachmentCreatePayload;
  triviaQuestionsGenerate: TriviaQuestionsGeneratePayload;
  triviaQuestionsRetrieve: TriviaQuestionsRetrievePayload;
  triviaResponseCreate: TriviaResponseCreatePayload;
  triviaResponseDelete: TriviaResponseDeletePayload;
  updateRoomRanking: UpdateRoomRankingMutationPayload;
  /** Updates the store review prompted at timestamp for the current user */
  updateStoreReviewPromptTimestamp: UpdateStoreReviewPromptTimestampPayload;
  uploadPresign: UploadPresignPayload;
  userBlockCreate: UserBlockCreatePayload;
  userBlockDelete: UserBlockDeletePayload;
  userFollow: UserFollowPayload;
  /** Onboards a user */
  userOnboard: UserOnboardPayload;
  userRoomBanCreate: UserRoomBanCreatePayload;
  userRoomBanRemove: UserRoomBanRemovePayload;
  userUnfollow: UserUnfollowPayload;
  /** Updates a user by id */
  userUpdate: UserUpdatePayload;
  waitlistCodeCreate: WaitlistCodeCreatePayload;
  waitlistCodeUpdate: WaitlistCodeUpdatePayload;
};


export type MutationAdTrackClickArgs = {
  input: AdTrackClickInput;
};


export type MutationAdTrackImpressionsArgs = {
  input: AdTrackImpressionsInput;
};


export type MutationAdminAdCampaignCreateArgs = {
  input: AdminAdCampaignCreateInput;
};


export type MutationAdminAdCampaignDeleteArgs = {
  input: AdminAdCampaignDeleteInput;
};


export type MutationAdminAdCampaignUpdateArgs = {
  input: AdminAdCampaignUpdateInput;
};


export type MutationAdminAdCreativeCreateArgs = {
  input: AdminAdCreativeCreateInput;
};


export type MutationAdminAdCreativeDeleteArgs = {
  input: AdminAdCreativeDeleteInput;
};


export type MutationAdminAdCreativeUpdateArgs = {
  input: AdminAdCreativeUpdateInput;
};


export type MutationAdminAdSponsorCreateArgs = {
  input: AdminAdSponsorCreateInput;
};


export type MutationAdminAdSponsorDeleteArgs = {
  input: AdminAdSponsorDeleteInput;
};


export type MutationAdminAdSponsorUpdateArgs = {
  input: AdminAdSponsorUpdateInput;
};


export type MutationAdminAuraCashOutArgs = {
  input: AdminAuraCashOutInput;
};


export type MutationAdminAuraProductCreateArgs = {
  input: AdminAuraProductCreateInput;
};


export type MutationAdminAuraProductUpdateArgs = {
  input: AdminAuraProductUpdateInput;
};


export type MutationAdminContentSuggestionToggleSelectedArgs = {
  input: AdminContentSuggestionToggleSelectedInput;
};


export type MutationAdminDemoChattersAddArgs = {
  input: AdminDemoChattersAddInput;
};


export type MutationAdminDemoChattersRemoveArgs = {
  input: AdminDemoChattersRemoveInput;
};


export type MutationAdminDemoGenerateEngagementArgs = {
  input: AdminDemoGenerateEngagementInput;
};


export type MutationAdminDemoMessageCreateArgs = {
  input: AdminDemoMessageCreateInput;
};


export type MutationAdminDemoMessageUpdateArgs = {
  input: AdminDemoMessageUpdateInput;
};


export type MutationAdminDemoRoomCreateArgs = {
  input: AdminDemoRoomCreateInput;
};


export type MutationAdminDemoRoomCreateV2Args = {
  input: AdminDemoRoomCreateV2Input;
};


export type MutationAdminDemoRoomRetryArgs = {
  input: AdminDemoRoomRetryInput;
};


export type MutationAdminDemoUserCreateArgs = {
  input: AdminDemoUserCreateInput;
};


export type MutationAdminDemoUserUpdateArgs = {
  input: AdminDemoUserUpdateInput;
};


export type MutationAdminEarningsPlanCreateArgs = {
  input: AdminEarningsPlanCreateInput;
};


export type MutationAdminEarningsPlanUpdateArgs = {
  input: AdminEarningsPlanUpdateInput;
};


export type MutationAdminEpisodeGenerateContentArgs = {
  input: AdminEpisodeGenerateContentInput;
};


export type MutationAdminEpisodePublishAnnouncementArgs = {
  input: AdminEpisodePublishAnnouncementInput;
};


export type MutationAdminModerateMessageArgs = {
  input: AdminModerateMessageInput;
};


export type MutationAdminPredictionsGroupCreateArgs = {
  input: AdminPredictionsGroupCreateInput;
};


export type MutationAdminPredictionsGroupUpdateArgs = {
  input: AdminPredictionsGroupUpdateInput;
};


export type MutationAdminPredictionsInputResultsArgs = {
  input: AdminPredictionsInputResultsInput;
};


export type MutationAdminRoomToggleBountiesArgs = {
  input: AdminRoomToggleBountiesInput;
};


export type MutationAdminRoomUpdateArgs = {
  input: AdminRoomUpdateInput;
};


export type MutationAdminSubscriptionProductCreateArgs = {
  input: AdminSubscriptionProductCreateInput;
};


export type MutationAdminSubscriptionProductRepositionArgs = {
  input: AdminSubscriptionProductRepositionInput;
};


export type MutationAdminSubscriptionProductUpdateArgs = {
  input: AdminSubscriptionProductUpdateInput;
};


export type MutationAdminUserCreateArgs = {
  input: AdminUserCreateInput;
};


export type MutationAdminUserModerationCreateArgs = {
  input: AdminUserModerationCreateInput;
};


export type MutationAdminUserModerationDeleteArgs = {
  input: AdminUserModerationDeleteInput;
};


export type MutationAdminUserModerationUpdateArgs = {
  input: AdminUserModerationUpdateInput;
};


export type MutationAdminUserSuspendArgs = {
  input: AdminUserSuspendInput;
};


export type MutationAdminUserUpdateArgs = {
  input: AdminUserUpdateInput;
};


export type MutationAdminYoutubeSourceCreateArgs = {
  input: AdminYoutubeSourceCreateInput;
};


export type MutationAttachmentCreateArgs = {
  input: AttachmentCreateInput;
};


export type MutationAuraDeclineArgs = {
  input: AuraDeclineInput;
};


export type MutationAuraGiveArgs = {
  input: AuraGiveInput;
};


export type MutationAuraPurchaseArgs = {
  input: AuraPurchaseInput;
};


export type MutationBountyAuraGiveArgs = {
  input: BountyAuraGiveInput;
};


export type MutationBountyMessageCreateArgs = {
  input: BountyMessageCreateInput;
};


export type MutationChannelCreateArgs = {
  input: ChannelCreateInput;
};


export type MutationChannelDiscardArgs = {
  input: ChannelDiscardInput;
};


export type MutationChannelJoinArgs = {
  input: ChannelJoinInput;
};


export type MutationChannelLeaveArgs = {
  input: ChannelLeaveInput;
};


export type MutationChannelMembershipUpdateArgs = {
  input: ChannelMembershipUpdateInput;
};


export type MutationChannelUpdateArgs = {
  input: ChannelUpdateInput;
};


export type MutationCheckSubscriptionStatusArgs = {
  input: CheckSubscriptionStatusInput;
};


export type MutationClearStoreReviewPromptTimestampArgs = {
  input: ClearStoreReviewPromptTimestampInput;
};


export type MutationContentReportCreateArgs = {
  input: ContentReportCreateInput;
};


export type MutationCredentialsUserAuthArgs = {
  input: CredentialsUserAuthInput;
};


export type MutationDeleteAccountArgs = {
  input: DeleteAccountInput;
};


export type MutationDirectMessageCreateArgs = {
  input: DirectMessageCreateInput;
};


export type MutationEmailTokenUserAuthArgs = {
  input: EmailTokenUserAuthInput;
};


export type MutationEmailUserAuthChallengeArgs = {
  input: EmailUserAuthChallengeInput;
};


export type MutationEnterWaitlistPasswordArgs = {
  input: EnterWaitlistPasswordInput;
};


export type MutationEventCreateArgs = {
  input: EventCreateInput;
};


export type MutationEventDeleteArgs = {
  input: EventDeleteInput;
};


export type MutationEventUpdateArgs = {
  input: EventUpdateInput;
};


export type MutationEventsCreateArgs = {
  input: EventsCreateInput;
};


export type MutationFeedbackSubmitArgs = {
  input: FeedbackSubmitInput;
};


export type MutationInviteRoomFollowersArgs = {
  input: InviteRoomFollowersInput;
};


export type MutationInviteRoomMembersArgs = {
  input: InviteRoomMembersInput;
};


export type MutationLiveSessionCreateOrJoinArgs = {
  input: LiveSessionCreateOrJoinInput;
};


export type MutationLiveSessionEndArgs = {
  input: LiveSessionEndInput;
};


export type MutationLiveSessionFinalizeArgs = {
  input: LiveSessionFinalizeInput;
};


export type MutationLiveSessionGoBackstageArgs = {
  input: LiveSessionGoBackstageInput;
};


export type MutationLiveSessionGoOnStageArgs = {
  input: LiveSessionGoOnStageInput;
};


export type MutationLiveSessionInviteParticipantArgs = {
  input: LiveSessionInviteParticipantInput;
};


export type MutationLiveSessionJoinArgs = {
  input: LiveSessionJoinInput;
};


export type MutationLiveSessionLeaveArgs = {
  input: LiveSessionLeaveInput;
};


export type MutationLiveSessionStartArgs = {
  input: LiveSessionStartInput;
};


export type MutationLiveSessionUpdateArgs = {
  input: LiveSessionUpdateInput;
};


export type MutationLiveSessionUpdateParticipantRoleArgs = {
  input: LiveSessionUpdateParticipantRoleInput;
};


export type MutationLiveSpacesIncrementViewArgs = {
  input: LiveSpacesIncrementViewInput;
};


export type MutationLogoutArgs = {
  input: LogoutInput;
};


export type MutationMarkChannelReadArgs = {
  input: MarkChannelReadInput;
};


export type MutationMarkCommentsReadArgs = {
  input: MarkCommentsReadInput;
};


export type MutationMarkNotificationReadArgs = {
  input: MarkNotificationReadInput;
};


export type MutationMarkNotificationsViewedArgs = {
  input: MarkNotificationsViewedInput;
};


export type MutationMarkReadArgs = {
  input: MarkReadInput;
};


export type MutationMessageAddToHomeChannelArgs = {
  input: MessageAddToHomeChannelInput;
};


export type MutationMessageCreateV2Args = {
  input: MessageCreateV2Input;
};


export type MutationMessageDeleteArgs = {
  input: MessageDeleteInput;
};


export type MutationMessageRemoveFromHomeChannelArgs = {
  input: MessageRemoveFromHomeChannelInput;
};


export type MutationMessageRequestAcceptArgs = {
  input: MessageRequestAcceptInput;
};


export type MutationMessageRequestDeclineArgs = {
  input: MessageRequestDeclineInput;
};


export type MutationMessageRequestPendingArgs = {
  input: MessageRequestPendingInput;
};


export type MutationMessageTogglePinArgs = {
  input: MessageTogglePinInput;
};


export type MutationMessageUpdateArgs = {
  input: MessageUpdateInput;
};


export type MutationModerateMessageArgs = {
  input: ModerateMessageInput;
};


export type MutationMuteChannelArgs = {
  input: MuteChannelInput;
};


export type MutationNotificationConfigUpdateArgs = {
  input: NotificationConfigUpdateInput;
};


export type MutationPollAttachmentCreateArgs = {
  input: PollAttachmentCreateInput;
};


export type MutationPollVoteCreateArgs = {
  input: PollVoteCreateInput;
};


export type MutationPredictionsResponseCreateArgs = {
  input: PredictionsResponseCreateInput;
};


export type MutationReactionCreateArgs = {
  input: ReactionCreateInput;
};


export type MutationReactionDeleteArgs = {
  input: ReactionDeleteInput;
};


export type MutationRoomArchiveArgs = {
  input: RoomArchiveInput;
};


export type MutationRoomChangeInvitationRoleArgs = {
  input: RoomChangeInvitationRoleInput;
};


export type MutationRoomChangeRoleArgs = {
  input: RoomChangeRoleInput;
};


export type MutationRoomCreateArgs = {
  input: RoomCreateInput;
};


export type MutationRoomFollowArgs = {
  input: RoomFollowInput;
};


export type MutationRoomJoinArgs = {
  input: RoomJoinInput;
};


export type MutationRoomLeaveArgs = {
  input: RoomLeaveInput;
};


export type MutationRoomMembershipUpdateArgs = {
  input: RoomMembershipUpdateInput;
};


export type MutationRoomPublishArgs = {
  input: RoomPublishInput;
};


export type MutationRoomRemoveInvitationArgs = {
  input: RoomRemoveInvitationInput;
};


export type MutationRoomRemoveMemberArgs = {
  input: RoomRemoveMemberInput;
};


export type MutationRoomRuleCreateArgs = {
  input: RoomRuleCreateInput;
};


export type MutationRoomRuleDeleteArgs = {
  input: RoomRuleDeleteInput;
};


export type MutationRoomRuleRankingsUpdateArgs = {
  input: RoomRuleRankingsUpdateInput;
};


export type MutationRoomRuleUpdateArgs = {
  input: RoomRuleUpdateInput;
};


export type MutationRoomSubmitForApprovalArgs = {
  input: RoomSubmitForApprovalInput;
};


export type MutationRoomUnfollowArgs = {
  input: RoomUnfollowInput;
};


export type MutationRoomUpdateArgs = {
  input: RoomUpdateInput;
};


export type MutationSendDownloadAppLinkArgs = {
  input: SendDownloadAppLinkInput;
};


export type MutationSendFriendInviteLinkArgs = {
  input: SendFriendInviteLinkInput;
};


export type MutationSendRoomShareLinkArgs = {
  input: SendRoomShareLinkInput;
};


export type MutationSendScheduledMessageArgs = {
  input: SendScheduledMessageInput;
};


export type MutationSetTypingIndicationArgs = {
  input: SetTypingIndicationInput;
};


export type MutationSmsUpdatePhoneArgs = {
  input: SmsUpdatePhoneInput;
};


export type MutationSmsUserAuthArgs = {
  input: SmsUserAuthInput;
};


export type MutationSmsUserAuthChallengeArgs = {
  input: SmsUserAuthChallengeInput;
};


export type MutationSmsUserAuthV2Args = {
  input: SmsUserAuthV2Input;
};


export type MutationSubscriptionAppStoreCreateArgs = {
  input: SubscriptionAppStoreCreateInput;
};


export type MutationSubscriptionPlayStoreCreateArgs = {
  input: SubscriptionPlayStoreCreateInput;
};


export type MutationSubscriptionUserInfoUpdateArgs = {
  input: SubscriptionUserInfoUpdateInput;
};


export type MutationTrackMessageImpressionsArgs = {
  input: TrackMessageImpressionsInput;
};


export type MutationTriviaAttachmentCreateArgs = {
  input: TriviaAttachmentCreateInput;
};


export type MutationTriviaQuestionsGenerateArgs = {
  input: TriviaQuestionsGenerateInput;
};


export type MutationTriviaQuestionsRetrieveArgs = {
  input: TriviaQuestionsRetrieveInput;
};


export type MutationTriviaResponseCreateArgs = {
  input: TriviaResponseCreateInput;
};


export type MutationTriviaResponseDeleteArgs = {
  input: TriviaResponseDeleteInput;
};


export type MutationUpdateRoomRankingArgs = {
  input: UpdateRoomRankingMutationInput;
};


export type MutationUpdateStoreReviewPromptTimestampArgs = {
  input: UpdateStoreReviewPromptTimestampInput;
};


export type MutationUploadPresignArgs = {
  input: UploadPresignInput;
};


export type MutationUserBlockCreateArgs = {
  input: UserBlockCreateInput;
};


export type MutationUserBlockDeleteArgs = {
  input: UserBlockDeleteInput;
};


export type MutationUserFollowArgs = {
  input: UserFollowInput;
};


export type MutationUserOnboardArgs = {
  input: UserOnboardInput;
};


export type MutationUserRoomBanCreateArgs = {
  input: UserRoomBanCreateInput;
};


export type MutationUserRoomBanRemoveArgs = {
  input: UserRoomBanRemoveInput;
};


export type MutationUserUnfollowArgs = {
  input: UserUnfollowInput;
};


export type MutationUserUpdateArgs = {
  input: UserUpdateInput;
};


export type MutationWaitlistCodeCreateArgs = {
  input: WaitlistCodeCreateInput;
};


export type MutationWaitlistCodeUpdateArgs = {
  input: WaitlistCodeUpdateInput;
};

/** Autogenerated input type of MuteChannel */
export type MuteChannelInput = {
  channelId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  mutedUntil?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** Autogenerated return type of MuteChannel. */
export type MuteChannelPayload = {
  __typename?: 'MuteChannelPayload';
  channel: Channel;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** An object with an ID. */
export type Node = {
  /** ID of the object. */
  id: Scalars['ID']['output'];
};

export type Notification = Node & {
  __typename?: 'Notification';
  /** [1.1.10] Legacy app path for backward compatibility */
  appPath?: Maybe<Scalars['String']['output']>;
  /** Structured metadata for app navigation */
  appPathMetadata?: Maybe<AppPathMetadataUnion>;
  body?: Maybe<Scalars['String']['output']>;
  count: Scalars['Int']['output'];
  date: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  photoAppPath?: Maybe<Scalars['String']['output']>;
  photoName?: Maybe<Scalars['String']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  read: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  user: User;
};

export type NotificationConfig = Node & {
  __typename?: 'NotificationConfig';
  asList: Array<NotificationConfigListItem>;
  /** @deprecated [1.1.30] Use user.notification_setting_for(type:) instead */
  commentMention: Scalars['Boolean']['output'];
  /** ID of the object. */
  id: Scalars['ID']['output'];
  /** @deprecated [1.1.30] Use user.notification_setting_for(type:) instead */
  messageMention: Scalars['Boolean']['output'];
  /** @deprecated [1.1.30] Use member_room_message or follower_room_message instead */
  roomMessage: Scalars['Boolean']['output'];
  /** @deprecated [1.1.30] Use user.notification_setting_for(type:) instead */
  viewerCommentReaction: Scalars['Boolean']['output'];
};

export type NotificationConfigCategory = {
  __typename?: 'NotificationConfigCategory';
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

/** Input type for updating notification config */
export type NotificationConfigInput = {
  channelEventReminder?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Merged into message_mention */
  commentMention?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated No longer user-configurable */
  followerNewQAndAOrPoll?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated No longer sent */
  followerReferralJoin?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated No longer configurable - use per-chat settings */
  followerRoomMessage?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated No longer user-configurable */
  followerVipStatusUnlocked?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated No longer configurable - use per-chat settings */
  memberRoomMessage?: InputMaybe<Scalars['Boolean']['input']>;
  messageMention?: InputMaybe<Scalars['Boolean']['input']>;
  messageMentionPriority?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use the new :member_room_message or :follower_room_message instead for app > 1.0.9 */
  roomMessage?: InputMaybe<Scalars['Boolean']['input']>;
  threadMessagesViaComment?: InputMaybe<Scalars['Boolean']['input']>;
  threadMessagesViaReaction?: InputMaybe<Scalars['Boolean']['input']>;
  unreadReminders?: InputMaybe<Scalars['Boolean']['input']>;
  userFollow?: InputMaybe<Scalars['Boolean']['input']>;
  viewerCommentReaction?: InputMaybe<Scalars['Boolean']['input']>;
  viewerCommentReply?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated No longer sent */
  viewerCommentViewed?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Merged into viewer_comment_reply */
  viewerMessageSharedInRoom?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationConfigListItem = {
  __typename?: 'NotificationConfigListItem';
  category: NotificationConfigCategory;
  notifications: Array<NotificationConfigNotification>;
};

export type NotificationConfigNotification = {
  __typename?: 'NotificationConfigNotification';
  description?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the type field instead */
  fieldName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  notificationType: NotificationType;
  /** Whether it is a default setting */
  systemDefault: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  value: Scalars['Boolean']['output'];
};

/** Autogenerated input type of NotificationConfigUpdate */
export type NotificationConfigUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  notificationConfigInput: NotificationConfigInput;
};

/** Autogenerated return type of NotificationConfigUpdate. */
export type NotificationConfigUpdatePayload = {
  __typename?: 'NotificationConfigUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated [1.1.30] query updated_notifications on update, instead of refetching entire list */
  notificationConfig: NotificationConfig;
  updatedNotifications: Array<NotificationConfigNotification>;
};

/** The connection type for Notification. */
export type NotificationConnection = {
  __typename?: 'NotificationConnection';
  /** A list of edges. */
  edges: Array<NotificationEdge>;
  /** A list of nodes. */
  nodes: Array<Notification>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type NotificationEdge = {
  __typename?: 'NotificationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Notification;
};

/** Type of target for notification navigation */
export enum NotificationTarget {
  /** Navigate to a channel (with optional focused message) */
  Channel = 'CHANNEL',
  /** Navigate to a comment thread */
  Comment = 'COMMENT',
  /** Navigate to a directory/room view */
  Directory = 'DIRECTORY',
  /** Navigate to an episode screen */
  Episode = 'EPISODE',
  /** Navigate to a generic app path without additional parameters */
  GenericPath = 'GENERIC_PATH',
  /** Navigate to a live session */
  LiveSession = 'LIVE_SESSION',
  /** Navigate to user connections (followers, etc.) */
  UserConnections = 'USER_CONNECTIONS',
  /** Navigate to a user profile */
  UserProfile = 'USER_PROFILE'
}

/** Notfication notification_type enum */
export enum NotificationType {
  BountyClaimable = 'BOUNTY_CLAIMABLE',
  BountyClaimed = 'BOUNTY_CLAIMED',
  BountyExpiring = 'BOUNTY_EXPIRING',
  ChannelEventReminder = 'CHANNEL_EVENT_REMINDER',
  ChannelEventSummary = 'CHANNEL_EVENT_SUMMARY',
  CommentMention = 'COMMENT_MENTION',
  FollowerNewPoll = 'FOLLOWER_NEW_POLL',
  FollowerNewPredictions = 'FOLLOWER_NEW_PREDICTIONS',
  FollowerNewQAndA = 'FOLLOWER_NEW_Q_AND_A',
  FollowerNewQAndAOrPoll = 'FOLLOWER_NEW_Q_AND_A_OR_POLL',
  FollowerNewTrivia = 'FOLLOWER_NEW_TRIVIA',
  FollowerReferralJoin = 'FOLLOWER_REFERRAL_JOIN',
  FollowerReferralJoinInApp = 'FOLLOWER_REFERRAL_JOIN_IN_APP',
  FollowerRoomMessage = 'FOLLOWER_ROOM_MESSAGE',
  FollowerVipStatusUnlocked = 'FOLLOWER_VIP_STATUS_UNLOCKED',
  FollowerVipStatusUnlockedInApp = 'FOLLOWER_VIP_STATUS_UNLOCKED_IN_APP',
  LiveSessionInvite = 'LIVE_SESSION_INVITE',
  MemberRoomMessage = 'MEMBER_ROOM_MESSAGE',
  MessageAuraGift = 'MESSAGE_AURA_GIFT',
  MessageAuraSelfPromote = 'MESSAGE_AURA_SELF_PROMOTE',
  MessageMention = 'MESSAGE_MENTION',
  MessageMentionPriority = 'MESSAGE_MENTION_PRIORITY',
  PaidDmReminder = 'PAID_DM_REMINDER',
  PaidDmRequest = 'PAID_DM_REQUEST',
  RoomPromotion = 'ROOM_PROMOTION',
  ThreadMessagesViaComment = 'THREAD_MESSAGES_VIA_COMMENT',
  ThreadMessagesViaReaction = 'THREAD_MESSAGES_VIA_REACTION',
  UnreadReminders = 'UNREAD_REMINDERS',
  UserFollow = 'USER_FOLLOW',
  UserFollowInApp = 'USER_FOLLOW_IN_APP',
  ViewerCommentReaction = 'VIEWER_COMMENT_REACTION',
  ViewerCommentReply = 'VIEWER_COMMENT_REPLY',
  ViewerCommentViewed = 'VIEWER_COMMENT_VIEWED',
  ViewerMessageSharedInRoom = 'VIEWER_MESSAGE_SHARED_IN_ROOM'
}

/** Autogenerated return type of Notifications. */
export type NotificationsPayload = {
  __typename?: 'NotificationsPayload';
  currentUser?: Maybe<User>;
  roomUpdated?: Maybe<Room>;
};

export type Organization = Node & {
  __typename?: 'Organization';
  badgeUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  url: Scalars['String']['output'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Response type for parse_deeplink query */
export type ParseDeeplinkResponse = {
  __typename?: 'ParseDeeplinkResponse';
  /** Navigation metadata for the linked message, if resolvable */
  appPathMetadata?: Maybe<AppPathMetadataUnion>;
  /**
   * The message being linked to (if provided)
   * @deprecated [1.1.57] Use app_path_metadata instead
   */
  message?: Maybe<Message>;
  /** Room to prompt joining (returned if share_token is provided and membership doesn't exist) */
  promptJoinRoom?: Maybe<Room>;
  /** The room id containing the message */
  roomId: Scalars['ID']['output'];
};

export type PaymentSubscription = Node & {
  __typename?: 'PaymentSubscription';
  autoRenewalStatus: PaymentSubscriptionAutoRenewalStatus;
  billingIssuesDetectedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  originalPurchaseDate: Scalars['ISO8601DateTime']['output'];
  periodEndsAt: Scalars['ISO8601DateTime']['output'];
  periodStartsAt: Scalars['ISO8601DateTime']['output'];
  product?: Maybe<SubscriptionProduct>;
  recordType: SubscriptionRecord;
  refundDetectedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  status: PaymentSubscriptionStatus;
  storeProductIdentifier: Scalars['String']['output'];
  storeSubscriptionIdentifier: Scalars['String']['output'];
  unsubscribeDetectedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  user?: Maybe<User>;
  userDeclinedInfoCollection: Scalars['Boolean']['output'];
  userEmail?: Maybe<Scalars['String']['output']>;
  userPostalCode?: Maybe<Scalars['String']['output']>;
};

export enum PaymentSubscriptionAutoRenewalStatus {
  WillChangeProduct = 'WILL_CHANGE_PRODUCT',
  WillNotRenew = 'WILL_NOT_RENEW',
  WillRenew = 'WILL_RENEW'
}

/** The connection type for PaymentSubscription. */
export type PaymentSubscriptionConnection = {
  __typename?: 'PaymentSubscriptionConnection';
  /** A list of edges. */
  edges: Array<PaymentSubscriptionEdge>;
  /** A list of nodes. */
  nodes: Array<PaymentSubscription>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PaymentSubscriptionEdge = {
  __typename?: 'PaymentSubscriptionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PaymentSubscription;
};

export type PaymentSubscriptionEntitlement = {
  __typename?: 'PaymentSubscriptionEntitlement';
  id: Scalars['ID']['output'];
  messageEncryptionKey?: Maybe<Scalars['String']['output']>;
};

export enum PaymentSubscriptionStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  InBillingRecovery = 'IN_BILLING_RECOVERY',
  Pending = 'PENDING'
}

/** Payments subscriptions mode enum */
export enum PaymentSubscriptionsMode {
  AdminOnly = 'ADMIN_ONLY',
  Disabled = 'DISABLED',
  Enabled = 'ENABLED'
}

export type Poll = Node & {
  __typename?: 'Poll';
  id: Scalars['ID']['output'];
  pollOptions: Array<PollOption>;
  title: Scalars['String']['output'];
};

/** Autogenerated input type of PollAttachmentCreate */
export type PollAttachmentCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  pollOptions: Array<PollOptionInput>;
  pollTitle: Scalars['String']['input'];
};

/** Autogenerated return type of PollAttachmentCreate. */
export type PollAttachmentCreatePayload = {
  __typename?: 'PollAttachmentCreatePayload';
  attachment: Attachment;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type PollOption = Node & {
  __typename?: 'PollOption';
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  pollVotesCount: Scalars['Int']['output'];
  viewerVoted: Scalars['Boolean']['output'];
};

export type PollOptionInput = {
  content: Scalars['String']['input'];
  position: Scalars['Int']['input'];
};

/** Autogenerated input type of PollVoteCreate */
export type PollVoteCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  pollOptionId: Scalars['ID']['input'];
};

/** Autogenerated return type of PollVoteCreate. */
export type PollVoteCreatePayload = {
  __typename?: 'PollVoteCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  poll: Poll;
};

export type PredictionsAdminResultInput = {
  correctOptionIds: Array<Scalars['ID']['input']>;
  questionId: Scalars['ID']['input'];
};

export type PredictionsGame = Node & {
  __typename?: 'PredictionsGame';
  adCreativeId?: Maybe<Scalars['ID']['output']>;
  channel?: Maybe<Channel>;
  endsAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  questionCount: Scalars['Int']['output'];
  questions: Array<PredictionsQuestion>;
  responseCount: Scalars['Int']['output'];
  resultsInputAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated [1.1.19] deprecated as part of channel-based approach.   */
  room?: Maybe<Room>;
  scoringCompletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  sponsorship?: Maybe<Ad>;
  title: Scalars['String']['output'];
  viewerPosition?: Maybe<Scalars['Int']['output']>;
  viewerResponse?: Maybe<PredictionsGameResponse>;
  viewerScore?: Maybe<Scalars['Int']['output']>;
  viewerSubmittedResponse: Scalars['Boolean']['output'];
};

export type PredictionsGameGroup = Node & {
  __typename?: 'PredictionsGameGroup';
  gameCount: Scalars['Int']['output'];
  games: Array<PredictionsGame>;
  id: Scalars['ID']['output'];
  launchMessageText?: Maybe<Scalars['String']['output']>;
  pinStartingMessage: Scalars['Boolean']['output'];
  resultsMessageSentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  resultsMessageText?: Maybe<Scalars['String']['output']>;
  resultsScheduledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  startingMessageSentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  startsAt: Scalars['ISO8601DateTime']['output'];
  templateGame?: Maybe<PredictionsGame>;
};

/** The connection type for PredictionsGameGroup. */
export type PredictionsGameGroupConnection = {
  __typename?: 'PredictionsGameGroupConnection';
  /** A list of edges. */
  edges: Array<PredictionsGameGroupEdge>;
  /** A list of nodes. */
  nodes: Array<PredictionsGameGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PredictionsGameGroupEdge = {
  __typename?: 'PredictionsGameGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PredictionsGameGroup;
};

export type PredictionsGameResponse = Node & {
  __typename?: 'PredictionsGameResponse';
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** @deprecated [1.1.19] deprecated to provide consistent result across single game and seasonal leaderboards */
  game?: Maybe<PredictionsGame>;
  id: Scalars['ID']['output'];
  questionsCorrectCount: Scalars['Int']['output'];
  score?: Maybe<Scalars['Int']['output']>;
  totalQuestionsCount: Scalars['Int']['output'];
  user: User;
  viewerCorrectCount?: Maybe<Scalars['Int']['output']>;
};

/** The connection type for PredictionsGameResponse. */
export type PredictionsGameResponseConnection = {
  __typename?: 'PredictionsGameResponseConnection';
  /** A list of edges. */
  edges: Array<PredictionsGameResponseEdge>;
  /** A list of nodes. */
  nodes: Array<PredictionsGameResponse>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PredictionsGameResponseEdge = {
  __typename?: 'PredictionsGameResponseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PredictionsGameResponse;
};

export type PredictionsGroupInput = {
  /** Ad creative shown on this group's games; null clears it */
  adCreativeId?: InputMaybe<Scalars['ID']['input']>;
  channelIds: Array<Scalars['ID']['input']>;
  endsAt: Scalars['ISO8601DateTime']['input'];
  launchMessageText: Scalars['String']['input'];
  pinStartingMessage?: InputMaybe<Scalars['Boolean']['input']>;
  questions: Array<PredictionsQuestionInput>;
  startsAt: Scalars['ISO8601DateTime']['input'];
  title: Scalars['String']['input'];
};

export type PredictionsOption = {
  __typename?: 'PredictionsOption';
  correct: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  responseCount: Scalars['Int']['output'];
  text: Scalars['String']['output'];
};

export type PredictionsOptionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  text: Scalars['String']['input'];
};

export type PredictionsQuestion = {
  __typename?: 'PredictionsQuestion';
  id: Scalars['ID']['output'];
  options: Array<PredictionsOption>;
  pointValue: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  viewerSelectedOptionId?: Maybe<Scalars['ID']['output']>;
};

export type PredictionsQuestionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  options: Array<PredictionsOptionInput>;
  pointValue: Scalars['Int']['input'];
  text: Scalars['String']['input'];
};

/** Autogenerated input type of PredictionsResponseCreate */
export type PredictionsResponseCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  gameId: Scalars['ID']['input'];
  responses: Array<PredictionsResponseInput>;
};

/** Autogenerated return type of PredictionsResponseCreate. */
export type PredictionsResponseCreatePayload = {
  __typename?: 'PredictionsResponseCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  game: PredictionsGame;
};

export type PredictionsResponseInput = {
  optionId: Scalars['ID']['input'];
  questionId: Scalars['ID']['input'];
};

/** Autogenerated return type of PredictionsResults. */
export type PredictionsResultsPayload = {
  __typename?: 'PredictionsResultsPayload';
  gameUpdated?: Maybe<PredictionsGame>;
};

export type PredictionsSeason = Node & {
  __typename?: 'PredictionsSeason';
  id: Scalars['ID']['output'];
  viewerPosition?: Maybe<Scalars['Int']['output']>;
  viewerResult?: Maybe<PredictionsGameResponse>;
};

export type ProductBenefit = Node & {
  __typename?: 'ProductBenefit';
  createdAt: Scalars['ISO8601DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  adminAdCampaign: AdminAdCampaign;
  adminAdCampaigns: Array<AdminAdCampaign>;
  adminAdCreatives: Array<AdminAdCreative>;
  adminAdSponsors: Array<AdminAdSponsor>;
  adminAuraCashOuts: AuraCashOutConnection;
  /** Fetches cache hit tracking statistics for admin purposes */
  adminCacheStats: Scalars['JSON']['output'];
  /** Lists content suggestions for a episode's completed transcript batch. */
  adminContentSuggestions: AdminContentSuggestionConnection;
  adminEarningsPlan: EarningsPlan;
  /** Fetches a single episode for the AI Buddy admin page */
  adminEpisode: AdminEpisode;
  /** Lists episodes with full details synced for a room */
  adminEpisodes: AdminEpisodeConnection;
  /** Fetches load shedding tracking statistics for admin purposes */
  adminLoadSheddingStats: Scalars['JSON']['output'];
  /** Fetches a message for admin moderation purposes */
  adminMessage: Message;
  adminModeratedMessages: MessageConnection;
  adminModeratedUsers: AdminUserConnection;
  adminNewMemberStats: Array<AdminNewMemberStats>;
  /** Fetches a single game group with all details for admin purposes */
  adminPredictionGroup: PredictionsGameGroup;
  adminPredictionGroups: PredictionsGameGroupConnection;
  /** Fetches a single room with all details for admin purposes */
  adminRoom: Room;
  adminRooms: RoomConnection;
  adminUserDetails: AdminUser;
  adminUserModerations: UserModerationConnection;
  /** Lists YouTube channels feeding the AI Buddy for a room */
  adminYoutubeSources: AdminRoomYoutubeSourceConnection;
  auraProducts: AuraProductConnection;
  /** Fetches a bounty given its ID */
  bounty: Bounty;
  /** Fetches a channel given its channel_id */
  channel: Channel;
  config: Config;
  /** Fetches info needed to render the earnings screen */
  earningsScreen: EarningsScreen;
  /** Fetches an episode given its ID */
  episode: Episode;
  /** Fetches a single event by ID */
  event?: Maybe<Event>;
  /** Fetches events for a room */
  events: Array<Event>;
  /** Fetches info needed to render the inbox/DM screen */
  inboxScreen: InboxScreen;
  /** Fetches a live session given its ID */
  liveSession?: Maybe<LiveSession>;
  location?: Maybe<LocationResponse>;
  /** Fetches a message given its ID */
  message: Message;
  messages: MessageConnection;
  /** Fetches an object given its ID. */
  node?: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Node>;
  notifications: NotificationConnection;
  parseDeeplink: ParseDeeplinkResponse;
  /** Fetches a Predictions::Game given its ID */
  predictionsGame: PredictionsGame;
  predictionsLeaderboard: PredictionsGameResponseConnection;
  predictionsSeason?: Maybe<PredictionsSeason>;
  randomMessage: Message;
  reactions: ReactionConnection;
  /** Fetches a room given its ID or room_handle */
  room: Room;
  roomDirectoryScreen: RoomDirectoryScreenResult;
  roomInvitations: RoomInvitationConnection;
  /** Fetches info needed to render a room screen */
  roomScreen: RoomScreenResult;
  rooms: RoomConnection;
  /** Fetches info needed to render the rooms screen */
  roomsScreen: RoomsScreen;
  /** Fetches a Trivia::Game given its ID */
  triviaGame: TriviaGame;
  triviaLeaderboard: TriviaGameResponseConnection;
  /** Fetches a user given its ID */
  user: User;
  users: UserConnection;
  viewer?: Maybe<User>;
};


export type QueryAdminAdCampaignArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminAdCampaignsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  sponsorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAdminAdCreativesArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  format?: InputMaybe<AdFormat>;
};


export type QueryAdminAuraCashOutsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['ID']['input'];
};


export type QueryAdminContentSuggestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<ContentSuggestionType>;
  episodeId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminEarningsPlanArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminEpisodeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminEpisodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isYoutubeShort?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  roomId: Scalars['ID']['input'];
};


export type QueryAdminMessageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminModeratedMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeUserContentReports?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  moderationResult?: InputMaybe<ModerationResult>;
};


export type QueryAdminModeratedUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdWithinDays?: InputMaybe<Scalars['Int']['input']>;
  excludeInvitedUsers?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AdminModeratedUsersFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminPredictionGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminPredictionGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminRoomArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminRoomsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  roomStatus?: InputMaybe<RoomStatus>;
  roomStatuses?: InputMaybe<Array<RoomStatus>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminUserDetailsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryAdminUserModerationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  daysBack?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['ID']['input'];
};


export type QueryAdminYoutubeSourcesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  roomId: Scalars['ID']['input'];
};


export type QueryAuraProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  store?: InputMaybe<StoreName>;
};


export type QueryBountyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryChannelArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEarningsScreenArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryEpisodeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEventArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryEventsArgs = {
  filter?: InputMaybe<EventsFilter>;
  roomId: Scalars['ID']['input'];
};


export type QueryLiveSessionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMessageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  centeredOnId?: InputMaybe<Scalars['ID']['input']>;
  centeredOnOldestUnread?: InputMaybe<Scalars['Boolean']['input']>;
  centeredOnTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  channelId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastInteractionAtAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  messageType?: InputMaybe<MessageType>;
  normalizeNestedIds?: InputMaybe<Scalars['Boolean']['input']>;
  parentMessageId?: InputMaybe<Scalars['ID']['input']>;
  roomId?: InputMaybe<Scalars['ID']['input']>;
  sort?: InputMaybe<MessagesSort>;
  sortReferenceTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};


export type QueryNodeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryNodesArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryParseDeeplinkArgs = {
  episodeId?: InputMaybe<Scalars['ID']['input']>;
  messageId?: InputMaybe<Scalars['ID']['input']>;
  roomHandle: Scalars['String']['input'];
  shareToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPredictionsGameArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPredictionsLeaderboardArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  gameId: Scalars['ID']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  seasonalResults?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPredictionsSeasonArgs = {
  gameId: Scalars['ID']['input'];
};


export type QueryReactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  emoji?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  messageId: Scalars['ID']['input'];
};


export type QueryRoomArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  roomHandle?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRoomDirectoryScreenArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRoomInvitationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  invitationType?: InputMaybe<InvitationType>;
  last?: InputMaybe<Scalars['Int']['input']>;
  roomId: Scalars['ID']['input'];
};


export type QueryRoomScreenArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRoomsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  roomUserFilter?: InputMaybe<RoomUserFilterInput>;
};


export type QueryTriviaGameArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTriviaLeaderboardArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  gameId: Scalars['ID']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channelId?: InputMaybe<Scalars['ID']['input']>;
  contextRoomId?: InputMaybe<Scalars['ID']['input']>;
  discoverQuery?: InputMaybe<Scalars['String']['input']>;
  excludeDemoUsers?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  followRoomId?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  membershipRoomId?: InputMaybe<Scalars['ID']['input']>;
  moderatorRoomId?: InputMaybe<Scalars['ID']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  userRoles?: InputMaybe<Array<UserRole>>;
  userSort?: InputMaybe<UserSort>;
};

export type Reaction = {
  __typename?: 'Reaction';
  createdAt: Scalars['ISO8601DateTime']['output'];
  emoji: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
};

export type ReactionAura = {
  __typename?: 'ReactionAura';
  amount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  sender?: Maybe<User>;
  viewerIsGiver: Scalars['Boolean']['output'];
};

/** The connection type for Reaction. */
export type ReactionConnection = {
  __typename?: 'ReactionConnection';
  /** A list of edges. */
  edges: Array<ReactionEdge>;
  /** A list of nodes. */
  nodes: Array<Reaction>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Autogenerated input type of ReactionCreate */
export type ReactionCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  emoji: Scalars['String']['input'];
  messageId: Scalars['ID']['input'];
};

/** Autogenerated return type of ReactionCreate. */
export type ReactionCreatePayload = {
  __typename?: 'ReactionCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  message: Message;
};

/** Autogenerated input type of ReactionDelete */
export type ReactionDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  emoji: Scalars['String']['input'];
  messageId: Scalars['ID']['input'];
};

/** Autogenerated return type of ReactionDelete. */
export type ReactionDeletePayload = {
  __typename?: 'ReactionDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  message: Message;
};

/** An edge in a connection. */
export type ReactionEdge = {
  __typename?: 'ReactionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Reaction;
};

export type ReactionGroup = {
  __typename?: 'ReactionGroup';
  emoji: Scalars['String']['output'];
  id: Scalars['String']['output'];
  reactionCount: Scalars['Int']['output'];
  viewerReacted: Scalars['Boolean']['output'];
};

export type ReadMarkInput = {
  messageType?: InputMaybe<MessageType>;
  roomId: Scalars['ID']['input'];
  timestamp: Scalars['ISO8601DateTime']['input'];
};

/** ReCAPTCHA verification failed */
export type RecaptchaError = {
  __typename?: 'RecaptchaError';
  message?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

export type Room = Node & {
  __typename?: 'Room';
  activeLiveSession?: Maybe<LiveSession>;
  activeRoomFollowsCount: Scalars['Int']['output'];
  activeRoomMembershipsCount: Scalars['Int']['output'];
  adminChatbccScheduledMessages: MessageConnection;
  /** The demo room workflow associated with this room, if any. Admin-only. */
  adminDemoWorkflow?: Maybe<DemoWorkflow>;
  adminPaymentSubscriptions: PaymentSubscriptionConnection;
  adminRoomHostStats?: Maybe<Array<AdminRoomHostStats>>;
  appStoreSubscriptionGroupIdentifier?: Maybe<Scalars['String']['output']>;
  auraEnabled: Scalars['Boolean']['output'];
  autoJoinChannelIds: Array<Scalars['ID']['output']>;
  bannedUsers: UserConnection;
  bountyChannelId?: Maybe<Scalars['ID']['output']>;
  bountyEntryThreshold: Scalars['Int']['output'];
  bountyMessages: MessageConnection;
  canViewerModerate: Scalars['Boolean']['output'];
  channel?: Maybe<Channel>;
  /** Get channels for a room with simple filtering options */
  channels: Array<Channel>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The room's default ad creative (admin) */
  defaultAdCreative?: Maybe<AdminAdCreative>;
  /** Ad creative used as the default for this room's games */
  defaultAdCreativeId?: Maybe<Scalars['ID']['output']>;
  defaultChannel?: Maybe<Channel>;
  defaultChannelId?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Subtitle for pending DM payments overview */
  dmPaymentOverviewSubtitle?: Maybe<Scalars['String']['output']>;
  /** Products required to send message (for purchase flow) */
  dmPaymentProducts: Array<AuraProduct>;
  /** Pending DM Aura gifts for this room */
  dmPendingAuraGifts: Array<AuraGift>;
  /** Total claimable DM Aura for in this room */
  dmPendingAuraTotal: Scalars['Int']['output'];
  /**
   * Default live_timezones for new events created in this room. nil means new
   * events default to all-live (no playback audience).
   */
  eventLiveTimezonesDefault?: Maybe<Array<Scalars['String']['output']>>;
  eventsOverview: RoomEventsOverview;
  hasDmPayments: Scalars['Boolean']['output'];
  homeChannelId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  isViewerAdmin: Scalars['Boolean']['output'];
  isViewerFollower: Scalars['Boolean']['output'];
  isViewerHost: Scalars['Boolean']['output'];
  /** @deprecated [1.0.35] Use is_viewer_host instead */
  isViewerMember: Scalars['Boolean']['output'];
  isViewerPaymentSubscribed: Scalars['Boolean']['output'];
  isViewerVip: Scalars['Boolean']['output'];
  /** @deprecated [1.1.6] Use channels latestMessageTimestamp instead */
  latestMessage?: Maybe<Message>;
  liveSpacesEnabled: Scalars['Boolean']['output'];
  /** Search for mentionable users in a room.  Do not use this query in a list */
  mentionableUsers: UserConnection;
  name: Scalars['String']['output'];
  offersPaymentSubscriberOnlyMessages: Scalars['Boolean']['output'];
  offersPaymentSubscriptions: Scalars['Boolean']['output'];
  openChatUntil?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Number of days recipient has to respond before payment expires */
  paidDmResponseWindowDays: Scalars['Int']['output'];
  paymentSubscriptionEntitlements?: Maybe<PaymentSubscriptionEntitlement>;
  paymentSubscriptionsMode: PaymentSubscriptionsMode;
  photoUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated [1.1.20] Use channel.pinnedMessages instead. */
  pinnedMessages: Array<Message>;
  playStoreSubscriptionGroupIdentifier?: Maybe<Scalars['String']['output']>;
  ranking?: Maybe<Scalars['Int']['output']>;
  requiresPaymentForNextMessage: Scalars['Boolean']['output'];
  roomHandle?: Maybe<Scalars['String']['output']>;
  /** Get waitlist codes for a room */
  roomInviters: RoomInviterConnection;
  /** For direct messages, returns all participants. Null for non-DM rooms. */
  roomMembers?: Maybe<Array<User>>;
  roomMembershipsPreview: Array<RoomMembership>;
  roomPrivacy: RoomStatusPrivacy;
  /** @deprecated [1.1.3] Use room_privacy / is_archived instead */
  roomStatus: RoomStatus;
  /** Get waitlist codes for a room */
  roomWaitlistCodes: RoomWaitlistCodeConnection;
  /** Community rules for this room */
  rules: Array<RoomRule>;
  /** @deprecated Use channel.scheduledMessages instead. */
  scheduledMessages: MessageConnection;
  /** Share token for private rooms */
  shareToken?: Maybe<Scalars['String']['output']>;
  /** @deprecated [1.1.3] Use viewer_can_share? instead */
  sharingAllowed: Scalars['Boolean']['output'];
  sharingEnabled: Scalars['Boolean']['output'];
  subscriptionProducts: Array<SubscriptionProduct>;
  taglineEnabled: Scalars['Boolean']['output'];
  /** Total aura cost to send next message (sum of all paid recipients) */
  totalDmPaymentAmount: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  useDirectory: Scalars['Boolean']['output'];
  viewerCanArchive: AuthorizationResult;
  viewerCanChangeChatterRole: AuthorizationResult;
  viewerCanInviteChatters: AuthorizationResult;
  viewerCanJoinAsAdminOrQa: AuthorizationResult;
  viewerCanPublish: AuthorizationResult;
  viewerCanRemoveUsers: AuthorizationResult;
  viewerCanShare: AuthorizationResult;
  viewerCanSubmitForApproval: AuthorizationResult;
  viewerCanUpdate: AuthorizationResult;
  /** The current user's membership for this room. Null if not a member. */
  viewerMembership?: Maybe<RoomMembership>;
  /** @deprecated [1.1.6] Use channels viewerMutedUntil instead */
  viewerMutedUntil?: Maybe<Scalars['ISO8601DateTime']['output']>;
  viewerPaymentSubscriptions: Array<PaymentSubscription>;
  /** @deprecated [1.1.2] Use channels read timestamp instead */
  viewerReadAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  viewerReferralPlanItem?: Maybe<EarningsPlanItem>;
  /** Current moderation status for the viewer in this room */
  viewerRoomModeration?: Maybe<UserRoomModerationStatus>;
  /** The name for this room from the viewer's perspective. For DMs, excludes the viewer and uses participant names. */
  viewerRoomName: Scalars['String']['output'];
  vipBadgeUrl?: Maybe<Scalars['String']['output']>;
  vipColor?: Maybe<Scalars['String']['output']>;
  vipEnabled: Scalars['Boolean']['output'];
  vipName?: Maybe<Scalars['String']['output']>;
  vipUsers: UserConnection;
  webUrl?: Maybe<Scalars['String']['output']>;
  /** Welcome message for this room */
  welcomeMessage?: Maybe<Scalars['String']['output']>;
};


export type RoomAdminChatbccScheduledMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type RoomAdminPaymentSubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<PaymentSubscriptionStatus>;
};


export type RoomBannedUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type RoomBountyMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  centeredOnId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<BountySort>;
  status?: InputMaybe<BountyStatus>;
};


export type RoomChannelArgs = {
  channelId: Scalars['ID']['input'];
};


export type RoomChannelsArgs = {
  filter?: InputMaybe<ChannelFilterInput>;
};


export type RoomMentionableUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


export type RoomRoomInvitersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  invitationType?: InputMaybe<InvitationType>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type RoomRoomMembershipsPreviewArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type RoomRoomWaitlistCodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type RoomScheduledMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type RoomSubscriptionProductsArgs = {
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RoomVipUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Activity in a room */
export type RoomActivity = {
  __typename?: 'RoomActivity';
  /** List of activity items in the room */
  activityList: RoomActivityItemUnionConnection;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
};


/** Activity in a room */
export type RoomActivityActivityListArgs = {
  activityFilter?: InputMaybe<RoomActivityFilterInput>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Types of actions that can occur in a room activity */
export enum RoomActivityAction {
  /** A reply was sent to a main chatmessage */
  Reply = 'REPLY'
}

/** Input type for filtering room activity */
export type RoomActivityFilterInput = {
  /** Filter activities by action type */
  actionType?: InputMaybe<RoomActivityAction>;
  /** Filter activities by user focus */
  userFocus?: InputMaybe<RoomActivityUserFocus>;
};

/** Interface for room activity items */
export type RoomActivityItem = {
  /** When the last action of this type occurred */
  actionLastCreatedAt: Scalars['ISO8601DateTime']['output'];
  /** The type of action that occurred */
  actionType: RoomActivityAction;
  /** The unique identifier for this activity item */
  id: Scalars['ID']['output'];
  /** Number of unique users that commented on a message */
  previewUserCount: Scalars['Int']['output'];
  /** Up to 2 users associated with this activity */
  previewUsers: Array<User>;
};

/** A message activity in a room */
export type RoomActivityItemMessage = RoomActivityItem & {
  __typename?: 'RoomActivityItemMessage';
  /** When the last action of this type occurred */
  actionLastCreatedAt: Scalars['ISO8601DateTime']['output'];
  /** The type of action that occurred */
  actionType: RoomActivityAction;
  /** The unique identifier for this activity item */
  id: Scalars['ID']['output'];
  /** The message that was sent */
  message: Message;
  previewMessages: Array<Message>;
  /** Number of unique users that commented on a message */
  previewUserCount: Scalars['Int']['output'];
  /** Up to 2 users associated with this activity */
  previewUsers: Array<User>;
};

/** Union of all possible room activity item types */
export type RoomActivityItemUnion = RoomActivityItemMessage;

/** The connection type for RoomActivityItemUnion. */
export type RoomActivityItemUnionConnection = {
  __typename?: 'RoomActivityItemUnionConnection';
  /** A list of edges. */
  edges: Array<RoomActivityItemUnionEdge>;
  /** A list of nodes. */
  nodes: Array<RoomActivityItemUnion>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RoomActivityItemUnionEdge = {
  __typename?: 'RoomActivityItemUnionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: RoomActivityItemUnion;
};

/** Types of user focus for room activity filtering */
export enum RoomActivityUserFocus {
  /** Focus on the current user's activity */
  Me = 'ME',
  /** No specific user focus */
  None = 'NONE'
}

/** Autogenerated input type of RoomArchive */
export type RoomArchiveInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RoomArchive. */
export type RoomArchivePayload = {
  __typename?: 'RoomArchivePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  room: Room;
};

/** RoomAssociationType type */
export enum RoomAssociation {
  DirectMessages = 'DIRECT_MESSAGES',
  Discovery = 'DISCOVERY',
  Follower = 'FOLLOWER',
  Member = 'MEMBER',
  /** @deprecated [1.0.9] No longer used */
  MyRooms = 'MY_ROOMS',
  Recommended = 'RECOMMENDED'
}

/** Autogenerated input type of RoomChangeInvitationRole */
export type RoomChangeInvitationRoleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  role: RoomMembershipRole;
  roomInvitationId: Scalars['ID']['input'];
};

/** Autogenerated return type of RoomChangeInvitationRole. */
export type RoomChangeInvitationRolePayload = {
  __typename?: 'RoomChangeInvitationRolePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  roomInvitation: RoomInvitation;
};

/** Autogenerated input type of RoomChangeRole */
export type RoomChangeRoleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  role: RoomMembershipRole;
  roomId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of RoomChangeRole. */
export type RoomChangeRolePayload = {
  __typename?: 'RoomChangeRolePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  room: Room;
  user: User;
};

/** The connection type for Room. */
export type RoomConnection = {
  __typename?: 'RoomConnection';
  /** A list of edges. */
  edges: Array<RoomEdge>;
  /** A list of nodes. */
  nodes: Array<Room>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Autogenerated input type of RoomCreate */
export type RoomCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  roomInput: RoomInput;
  roomPrivacy?: InputMaybe<RoomStatusPrivacy>;
};

/** Autogenerated return type of RoomCreate. */
export type RoomCreatePayload = {
  __typename?: 'RoomCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  room: Room;
};

/** Type for the room directory screen data */
export type RoomDirectoryScreen = {
  __typename?: 'RoomDirectoryScreen';
  id: Scalars['ID']['output'];
  room: Room;
};

/** Union type for room directory screen query result */
export type RoomDirectoryScreenResult = GraphqlResultError | RoomDirectoryScreen;

/** An edge in a connection. */
export type RoomEdge = {
  __typename?: 'RoomEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Room;
};

/** Autogenerated return type of RoomEvent. */
export type RoomEventPayload = {
  __typename?: 'RoomEventPayload';
  channelUpdated?: Maybe<Channel>;
  roomUpdated?: Maybe<Room>;
};

/** Overview of upcoming events for a room */
export type RoomEventsOverview = {
  __typename?: 'RoomEventsOverview';
  /**
   * Number of upcoming events
   * @deprecated [1.1.35] Use upcoming_count instead
   */
  count: Scalars['Int']['output'];
  /** Whether the room has any events (past or upcoming) */
  hasEvent: Scalars['Boolean']['output'];
  /** @deprecated [1.1.35] No longer showing next start time */
  nextStartTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Number of upcoming events */
  upcomingCount: Scalars['Int']['output'];
};

/** Autogenerated input type of RoomFollow */
export type RoomFollowInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  roomId: Scalars['ID']['input'];
  shareToken?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RoomFollow. */
export type RoomFollowPayload = {
  __typename?: 'RoomFollowPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  room: Room;
};

export type RoomInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** signedId of a presigned uploaded image */
  photo?: InputMaybe<Scalars['String']['input']>;
  useDirectory?: InputMaybe<Scalars['Boolean']['input']>;
  webUrl?: InputMaybe<Scalars['String']['input']>;
  welcomeMessage?: InputMaybe<Scalars['String']['input']>;
};

export type RoomInputAdmin = {
  appStoreSubscriptionGroupIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** List of channel IDs that users will auto-join when joining the room */
  autoJoinChannelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Ad creative used as the default for this room's games; null clears it */
  defaultAdCreativeId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Default live_timezones for new events created in this room. nil means new
   * events default to all-live (no playback audience).
   */
  eventLiveTimezonesDefault?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** signedId of a presigned uploaded image for room photo */
  photo?: InputMaybe<Scalars['String']['input']>;
  playStoreSubscriptionGroupIdentifier?: InputMaybe<Scalars['String']['input']>;
  roomHandle?: InputMaybe<Scalars['String']['input']>;
  roomStatus?: InputMaybe<RoomStatus>;
  sharingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether subscriptions are enabled for this room */
  subscriptionsMode?: InputMaybe<PaymentSubscriptionsMode>;
  /** signedId of a presigned uploaded image */
  vipBadge?: InputMaybe<Scalars['String']['input']>;
  vipColor?: InputMaybe<Scalars['String']['input']>;
  vipEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  vipName?: InputMaybe<Scalars['String']['input']>;
  webUrl?: InputMaybe<Scalars['String']['input']>;
  welcomeMessage?: InputMaybe<Scalars['String']['input']>;
};

export type RoomInvitation = Node & {
  __typename?: 'RoomInvitation';
  contactName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Type of invitation (member or follower) */
  invitationType: Scalars['String']['output'];
  number?: Maybe<Scalars['String']['output']>;
};

/** The connection type for RoomInvitation. */
export type RoomInvitationConnection = {
  __typename?: 'RoomInvitationConnection';
  /** A list of edges. */
  edges: Array<RoomInvitationEdge>;
  /** A list of nodes. */
  nodes: Array<RoomInvitation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RoomInvitationEdge = {
  __typename?: 'RoomInvitationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: RoomInvitation;
};

export type RoomInviter = Node & {
  __typename?: 'RoomInviter';
  count: Scalars['Int']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  username: Scalars['String']['output'];
};

/** The connection type for RoomInviter. */
export type RoomInviterConnection = {
  __typename?: 'RoomInviterConnection';
  /** A list of edges. */
  edges: Array<RoomInviterEdge>;
  /** A list of nodes. */
  nodes: Array<RoomInviter>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RoomInviterEdge = {
  __typename?: 'RoomInviterEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: RoomInviter;
};

/** Autogenerated input type of RoomJoin */
export type RoomJoinInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  roomId: Scalars['ID']['input'];
};

/** Autogenerated return type of RoomJoin. */
export type RoomJoinPayload = {
  __typename?: 'RoomJoinPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  room: Room;
};

/** Autogenerated input type of RoomLeave */
export type RoomLeaveInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  roomId: Scalars['ID']['input'];
};

/** Autogenerated return type of RoomLeave. */
export type RoomLeavePayload = {
  __typename?: 'RoomLeavePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  room: Room;
};

export type RoomMembership = Node & {
  __typename?: 'RoomMembership';
  id: Scalars['ID']['output'];
  membershipState: RoomMembershipState;
  role: RoomMembershipRole;
  room: Room;
  roomId: Scalars['ID']['output'];
  tagline?: Maybe<Scalars['String']['output']>;
  user: User;
  vipStatus: Scalars['Boolean']['output'];
};

/** Input for updating room membership settings */
export type RoomMembershipInput = {
  /** Per-room flair displayed next to the user's name in chat */
  tagline?: InputMaybe<Scalars['String']['input']>;
};

export enum RoomMembershipRole {
  Admin = 'ADMIN',
  Chatter = 'CHATTER',
  Follower = 'FOLLOWER',
  Moderator = 'MODERATOR'
}

/** Room membership state */
export enum RoomMembershipState {
  /** Membership is accepted and active */
  Accepted = 'ACCEPTED',
  /** Membership was declined (message request rejected) */
  Declined = 'DECLINED',
  /** Membership is pending approval (message request) */
  Pending = 'PENDING'
}

/** Autogenerated input type of RoomMembershipUpdate */
export type RoomMembershipUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  roomMembershipInput: RoomMembershipInput;
};

/** Autogenerated return type of RoomMembershipUpdate. */
export type RoomMembershipUpdatePayload = {
  __typename?: 'RoomMembershipUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  roomMembership: RoomMembership;
};

/** Autogenerated input type of RoomPublish */
export type RoomPublishInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RoomPublish. */
export type RoomPublishPayload = {
  __typename?: 'RoomPublishPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  room: Room;
};

/** Autogenerated input type of RoomRemoveInvitation */
export type RoomRemoveInvitationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  roomInvitationId: Scalars['ID']['input'];
};

/** Autogenerated return type of RoomRemoveInvitation. */
export type RoomRemoveInvitationPayload = {
  __typename?: 'RoomRemoveInvitationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RoomRemoveMember */
export type RoomRemoveMemberInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  roomId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of RoomRemoveMember. */
export type RoomRemoveMemberPayload = {
  __typename?: 'RoomRemoveMemberPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  room: Room;
};

export type RoomRule = {
  __typename?: 'RoomRule';
  /** The description of the room rule */
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The ranking/order of the room rule */
  ranking?: Maybe<Scalars['Int']['output']>;
  /** The title of the room rule */
  title: Scalars['String']['output'];
};

/** Autogenerated input type of RoomRuleCreate */
export type RoomRuleCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  roomId: Scalars['ID']['input'];
  roomRuleInput: RoomRuleInput;
};

/** Autogenerated return type of RoomRuleCreate. */
export type RoomRuleCreatePayload = {
  __typename?: 'RoomRuleCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  room: Room;
  roomRule: RoomRule;
};

/** Autogenerated input type of RoomRuleDelete */
export type RoomRuleDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RoomRuleDelete. */
export type RoomRuleDeletePayload = {
  __typename?: 'RoomRuleDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  room: Room;
  roomRule: RoomRule;
};

export type RoomRuleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  ranking?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
};

export type RoomRuleRankingInput = {
  id: Scalars['ID']['input'];
  ranking: Scalars['Int']['input'];
};

/** Autogenerated input type of RoomRuleRankingsUpdate */
export type RoomRuleRankingsUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  roomId: Scalars['ID']['input'];
  roomRuleRankings: Array<RoomRuleRankingInput>;
};

/** Autogenerated return type of RoomRuleRankingsUpdate. */
export type RoomRuleRankingsUpdatePayload = {
  __typename?: 'RoomRuleRankingsUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  room: Room;
};

/** Autogenerated input type of RoomRuleUpdate */
export type RoomRuleUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  roomRuleInput: RoomRuleInput;
};

/** Autogenerated return type of RoomRuleUpdate. */
export type RoomRuleUpdatePayload = {
  __typename?: 'RoomRuleUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  room: Room;
  roomRule: RoomRule;
};

/** Type for the room screen data */
export type RoomScreen = {
  __typename?: 'RoomScreen';
  activity: RoomActivity;
  id: Scalars['ID']['output'];
  room: Room;
  /** @deprecated [1.1.3] Use room.room_privacy instead */
  showPrivateBanner: Scalars['Boolean']['output'];
};

/** Union type for room screen query result */
export type RoomScreenResult = GraphqlResultError | RoomScreen;

/** Room status enum */
export enum RoomStatus {
  Archived = 'ARCHIVED',
  DirectMessage = 'DIRECT_MESSAGE',
  Draft = 'DRAFT',
  PendingApproval = 'PENDING_APPROVAL',
  Published = 'PUBLISHED',
  Unpublished = 'UNPUBLISHED'
}

/** Privacy level for room status */
export enum RoomStatusPrivacy {
  /** Make the room private */
  Private = 'PRIVATE',
  /** Make the room public */
  Public = 'PUBLIC'
}

/** Autogenerated input type of RoomSubmitForApproval */
export type RoomSubmitForApprovalInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RoomSubmitForApproval. */
export type RoomSubmitForApprovalPayload = {
  __typename?: 'RoomSubmitForApprovalPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  room: Room;
};

/** Autogenerated input type of RoomUnfollow */
export type RoomUnfollowInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  roomId: Scalars['ID']['input'];
};

/** Autogenerated return type of RoomUnfollow. */
export type RoomUnfollowPayload = {
  __typename?: 'RoomUnfollowPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  room: Room;
};

/** Autogenerated input type of RoomUpdate */
export type RoomUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  roomInput: RoomInput;
  roomPrivacy?: InputMaybe<RoomStatusPrivacy>;
};

/** Autogenerated return type of RoomUpdate. */
export type RoomUpdatePayload = {
  __typename?: 'RoomUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  room: Room;
};

export type RoomUserFilterInput = {
  /** Filter by membership state (for DMs: 'accepted', 'pending', or 'declined') */
  membershipState?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  roomAssociationType?: InputMaybe<RoomAssociation>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  vipStatus?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RoomWaitlistCode = Node & {
  __typename?: 'RoomWaitlistCode';
  archived?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  room: Room;
};

/** The connection type for RoomWaitlistCode. */
export type RoomWaitlistCodeConnection = {
  __typename?: 'RoomWaitlistCodeConnection';
  /** A list of edges. */
  edges: Array<RoomWaitlistCodeEdge>;
  /** A list of nodes. */
  nodes: Array<RoomWaitlistCode>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RoomWaitlistCodeEdge = {
  __typename?: 'RoomWaitlistCodeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: RoomWaitlistCode;
};

/** Autogenerated return type of RoomsListEvent. */
export type RoomsListEventPayload = {
  __typename?: 'RoomsListEventPayload';
  channelUpdated?: Maybe<Channel>;
};

/** Type for the rooms screen data */
export type RoomsScreen = {
  __typename?: 'RoomsScreen';
  bannerConfig: BannerConfig;
  preloadDisabled: Scalars['Boolean']['output'];
  shakeForFeedback: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SendDownloadAppLink */
export type SendDownloadAppLinkInput = {
  attributionData?: InputMaybe<AttributionDataInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  recaptchaToken?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SendDownloadAppLink. */
export type SendDownloadAppLinkPayload = {
  __typename?: 'SendDownloadAppLinkPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SendFriendInviteLink */
export type SendFriendInviteLinkInput = {
  attributionData?: InputMaybe<AttributionDataInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  inviterId?: InputMaybe<Scalars['ID']['input']>;
  phoneNumber: Scalars['String']['input'];
  recaptchaToken?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SendFriendInviteLink. */
export type SendFriendInviteLinkPayload = {
  __typename?: 'SendFriendInviteLinkPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SendRoomShareLink */
export type SendRoomShareLinkInput = {
  attributionData?: InputMaybe<AttributionDataInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  inviterId?: InputMaybe<Scalars['ID']['input']>;
  phoneNumber: Scalars['String']['input'];
  recaptchaToken?: InputMaybe<Scalars['String']['input']>;
  roomId: Scalars['ID']['input'];
};

/** Autogenerated return type of SendRoomShareLink. */
export type SendRoomShareLinkPayload = {
  __typename?: 'SendRoomShareLinkPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SendScheduledMessage */
export type SendScheduledMessageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the scheduled message to send. */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of SendScheduledMessage. */
export type SendScheduledMessagePayload = {
  __typename?: 'SendScheduledMessagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  message: Message;
};

/** Autogenerated input type of SetTypingIndication */
export type SetTypingIndicationInput = {
  activeAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  roomId: Scalars['ID']['input'];
};

/** Autogenerated return type of SetTypingIndication. */
export type SetTypingIndicationPayload = {
  __typename?: 'SetTypingIndicationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SmsUpdatePhone */
export type SmsUpdatePhoneInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

/** Autogenerated return type of SmsUpdatePhone. */
export type SmsUpdatePhonePayload = {
  __typename?: 'SmsUpdatePhonePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

/** Autogenerated input type of SmsUserAuthChallenge */
export type SmsUserAuthChallengeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
};

/** Autogenerated return type of SmsUserAuthChallenge. */
export type SmsUserAuthChallengePayload = {
  __typename?: 'SmsUserAuthChallengePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SmsUserAuth */
export type SmsUserAuthInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SmsUserAuth. */
export type SmsUserAuthPayload = {
  __typename?: 'SmsUserAuthPayload';
  authToken?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  isNewUser?: Maybe<Scalars['Boolean']['output']>;
  isResurrectedUser?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<User>;
};

/** Result of SMS user authentication */
export type SmsUserAuthResult = RecaptchaError | SmsUserAuthSuccess;

/** Successful SMS user authentication */
export type SmsUserAuthSuccess = {
  __typename?: 'SmsUserAuthSuccess';
  authToken: Scalars['String']['output'];
  isNewUser: Scalars['Boolean']['output'];
  isResurrectedUser: Scalars['Boolean']['output'];
  recaptchaScore?: Maybe<Scalars['Float']['output']>;
  user: User;
};

/** Autogenerated input type of SmsUserAuthV2 */
export type SmsUserAuthV2Input = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  recaptchaToken?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SmsUserAuthV2. */
export type SmsUserAuthV2Payload = {
  __typename?: 'SmsUserAuthV2Payload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  result: SmsUserAuthResult;
};

export type Sponsor = {
  __typename?: 'Sponsor';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
};

export enum StoreName {
  AppStore = 'APP_STORE',
  PlayStore = 'PLAY_STORE'
}

export type StoreReviewPrompt = Node & {
  __typename?: 'StoreReviewPrompt';
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  promptedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Autogenerated input type of SubscriptionAppStoreCreate */
export type SubscriptionAppStoreCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  originalTransactionId: Scalars['String']['input'];
  sandbox: Scalars['Boolean']['input'];
};

/** Autogenerated return type of SubscriptionAppStoreCreate. */
export type SubscriptionAppStoreCreatePayload = {
  __typename?: 'SubscriptionAppStoreCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  room?: Maybe<Room>;
  subscriptionId?: Maybe<Scalars['String']['output']>;
  viewer: User;
};

/** Autogenerated input type of SubscriptionPlayStoreCreate */
export type SubscriptionPlayStoreCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  purchaseToken: Scalars['String']['input'];
};

/** Autogenerated return type of SubscriptionPlayStoreCreate. */
export type SubscriptionPlayStoreCreatePayload = {
  __typename?: 'SubscriptionPlayStoreCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  room?: Maybe<Room>;
  subscriptionId?: Maybe<Scalars['String']['output']>;
  viewer: User;
};

export type SubscriptionProduct = Node & {
  __typename?: 'SubscriptionProduct';
  collectUserEmail: Scalars['Boolean']['output'];
  collectUserPostalCode: Scalars['Boolean']['output'];
  color: AppHexColor;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** @deprecated Use productBenefits instead */
  descriptionBullets: Array<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  internalName: Scalars['String']['output'];
  permitsPromotedComments: Scalars['Boolean']['output'];
  permitsSubscriberOnlyMessages: Scalars['Boolean']['output'];
  permittedChannels: Array<Channel>;
  position: Scalars['Int']['output'];
  productBenefits: Array<ProductBenefit>;
  state: SubscriptionProductState;
  store: StoreName;
  storeProductIdentifier: Scalars['String']['output'];
  subscriberBadgeUrl?: Maybe<Scalars['String']['output']>;
};

export enum SubscriptionProductState {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED'
}

export enum SubscriptionRecord {
  AppStore = 'APP_STORE',
  Comped = 'COMPED',
  PlayStore = 'PLAY_STORE'
}

/** Autogenerated input type of SubscriptionUserInfoUpdate */
export type SubscriptionUserInfoUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the subscription to update */
  subscriptionId: Scalars['ID']['input'];
  /** Whether user declined to provide info */
  userDeclinedInfoCollection?: InputMaybe<Scalars['Boolean']['input']>;
  /** User's email address */
  userEmail?: InputMaybe<Scalars['String']['input']>;
  /** User's postal code */
  userPostalCode?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SubscriptionUserInfoUpdate. */
export type SubscriptionUserInfoUpdatePayload = {
  __typename?: 'SubscriptionUserInfoUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  subscription: PaymentSubscription;
};

/** Autogenerated input type of TrackMessageImpressions */
export type TrackMessageImpressionsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  messageIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of TrackMessageImpressions. */
export type TrackMessageImpressionsPayload = {
  __typename?: 'TrackMessageImpressionsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum TranscodingState {
  Completed = 'COMPLETED',
  Error = 'ERROR',
  Initial = 'INITIAL'
}

export type TranscriptChapter = {
  __typename?: 'TranscriptChapter';
  endMs: Scalars['Int']['output'];
  gist?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  startMs: Scalars['Int']['output'];
  summary?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of TriviaAttachmentCreate */
export type TriviaAttachmentCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  trivia: TriviaInput;
};

/** Autogenerated return type of TriviaAttachmentCreate. */
export type TriviaAttachmentCreatePayload = {
  __typename?: 'TriviaAttachmentCreatePayload';
  attachment: Attachment;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type TriviaGame = Node & {
  __typename?: 'TriviaGame';
  color?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  questions: Array<TriviaQuestion>;
  responseCount: Scalars['Int']['output'];
  sponsorship?: Maybe<Ad>;
  title: Scalars['String']['output'];
  viewerPosition?: Maybe<Scalars['Int']['output']>;
  viewerScore?: Maybe<Scalars['Int']['output']>;
  viewerTimeMs?: Maybe<Scalars['Int']['output']>;
};

export type TriviaGameResponse = Node & {
  __typename?: 'TriviaGameResponse';
  createdAt: Scalars['ISO8601DateTime']['output'];
  game: TriviaGame;
  id: Scalars['ID']['output'];
  score?: Maybe<Scalars['Int']['output']>;
  timeMs?: Maybe<Scalars['Int']['output']>;
  user: User;
};

/** The connection type for TriviaGameResponse. */
export type TriviaGameResponseConnection = {
  __typename?: 'TriviaGameResponseConnection';
  /** A list of edges. */
  edges: Array<TriviaGameResponseEdge>;
  /** A list of nodes. */
  nodes: Array<TriviaGameResponse>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TriviaGameResponseEdge = {
  __typename?: 'TriviaGameResponseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TriviaGameResponse;
};

export enum TriviaGenerationDifficulty {
  Easy = 'EASY',
  Hard = 'HARD',
  Medium = 'MEDIUM'
}

export enum TriviaGenerationStatus {
  Completed = 'COMPLETED',
  Error = 'ERROR',
  Pending = 'PENDING'
}

export type TriviaInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  questions: Array<TriviaQuestionInput>;
  title: Scalars['String']['input'];
};

export type TriviaOption = {
  __typename?: 'TriviaOption';
  correct: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  responseCount: Scalars['Int']['output'];
  text: Scalars['String']['output'];
};

export type TriviaOptionInput = {
  correct: Scalars['Boolean']['input'];
  text: Scalars['String']['input'];
};

export type TriviaQuestion = {
  __typename?: 'TriviaQuestion';
  id: Scalars['ID']['output'];
  options: Array<TriviaOption>;
  pointValue: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  viewerSelectedOptionId?: Maybe<Scalars['ID']['output']>;
};

export type TriviaQuestionInput = {
  options: Array<TriviaOptionInput>;
  pointValue: Scalars['Int']['input'];
  text: Scalars['String']['input'];
};

export type TriviaQuestionResponseInput = {
  optionId?: InputMaybe<Scalars['ID']['input']>;
  questionId: Scalars['ID']['input'];
  timeMs: Scalars['Int']['input'];
};

/** Autogenerated input type of TriviaQuestionsGenerate */
export type TriviaQuestionsGenerateInput = {
  channelId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  difficulty?: InputMaybe<TriviaGenerationDifficulty>;
  prompt: Scalars['String']['input'];
  /** Max of 20 */
  questionCount: Scalars['Int']['input'];
};

/** Autogenerated return type of TriviaQuestionsGenerate. */
export type TriviaQuestionsGeneratePayload = {
  __typename?: 'TriviaQuestionsGeneratePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  triviaGenerationId: Scalars['String']['output'];
};

/** Autogenerated input type of TriviaQuestionsRetrieve */
export type TriviaQuestionsRetrieveInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  triviaGenerationId: Scalars['ID']['input'];
};

/** Autogenerated return type of TriviaQuestionsRetrieve. */
export type TriviaQuestionsRetrievePayload = {
  __typename?: 'TriviaQuestionsRetrievePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  status: TriviaGenerationStatus;
  triviaGame?: Maybe<TriviaGame>;
};

/** Autogenerated input type of TriviaResponseCreate */
export type TriviaResponseCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  gameId: Scalars['ID']['input'];
  response: TriviaResponseInput;
};

/** Autogenerated return type of TriviaResponseCreate. */
export type TriviaResponseCreatePayload = {
  __typename?: 'TriviaResponseCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  game: TriviaGame;
};

/** Autogenerated input type of TriviaResponseDelete */
export type TriviaResponseDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  gameId: Scalars['ID']['input'];
};

/** Autogenerated return type of TriviaResponseDelete. */
export type TriviaResponseDeletePayload = {
  __typename?: 'TriviaResponseDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  game: TriviaGame;
};

export type TriviaResponseInput = {
  questionResponses: Array<TriviaQuestionResponseInput>;
};

/** Autogenerated return type of TriviaResults. */
export type TriviaResultsPayload = {
  __typename?: 'TriviaResultsPayload';
  gameUpdated?: Maybe<TriviaGame>;
};

/** Autogenerated return type of TypingIndication. */
export type TypingIndicationPayload = {
  __typename?: 'TypingIndicationPayload';
  activeAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  user?: Maybe<User>;
};

/** Autogenerated input type of UpdateRoomRankingMutation */
export type UpdateRoomRankingMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ranking?: InputMaybe<Scalars['Int']['input']>;
  roomId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateRoomRankingMutation. */
export type UpdateRoomRankingMutationPayload = {
  __typename?: 'UpdateRoomRankingMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  room: Room;
};

/** Autogenerated input type of UpdateStoreReviewPromptTimestamp */
export type UpdateStoreReviewPromptTimestampInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateStoreReviewPromptTimestamp. */
export type UpdateStoreReviewPromptTimestampPayload = {
  __typename?: 'UpdateStoreReviewPromptTimestampPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  storeReviewPrompt: StoreReviewPrompt;
};

/** Autogenerated input type of UploadPresign */
export type UploadPresignInput = {
  byteSize: Scalars['Int']['input'];
  checksum: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contentType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
};

/** Autogenerated return type of UploadPresign. */
export type UploadPresignPayload = {
  __typename?: 'UploadPresignPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  headers?: Maybe<Scalars['JSON']['output']>;
  signedId?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type User = Node & {
  __typename?: 'User';
  activeFollowerCount: Scalars['Int']['output'];
  activeFollowingCount: Scalars['Int']['output'];
  auraAccount?: Maybe<AuraAccount>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  bannedByUser?: Maybe<User>;
  bio?: Maybe<Scalars['String']['output']>;
  blockedUserIds?: Maybe<Array<Scalars['String']['output']>>;
  bluesky?: Maybe<Scalars['String']['output']>;
  canChangeUsername: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  directMessageRequestsCount: Scalars['Int']['output'];
  displayName: Scalars['String']['output'];
  /** @deprecated [1.0.19] Use display_name or username directly instead */
  displayOrUsername: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  /** Get users who are following a specific user */
  followers: UserConnection;
  /** Get users who are being followed by a specific user */
  following: UserConnection;
  hasAcceptedTerms?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  inAppBadgeNotificationsCount: Scalars['Int']['output'];
  inboxBadgeCount: Scalars['Int']['output'];
  inboxPendingPaidDmCount: Scalars['Int']['output'];
  instagram?: Maybe<Scalars['String']['output']>;
  isAdmin: Scalars['Boolean']['output'];
  isEnrolled?: Maybe<Scalars['Boolean']['output']>;
  isFollowingViewer: Scalars['Boolean']['output'];
  isOnboarded?: Maybe<Scalars['Boolean']['output']>;
  isViewerFollower: Scalars['Boolean']['output'];
  messageRequestSetting: MessageRequestSetting;
  netAuraLastMonth?: Maybe<Scalars['Int']['output']>;
  notificationConfig?: Maybe<NotificationConfig>;
  notificationSettingFor: NotificationConfigNotification;
  organization?: Maybe<Organization>;
  paidDmActive: Scalars['Boolean']['output'];
  paidDmEnabled: Scalars['Boolean']['output'];
  paidDmProduct?: Maybe<AuraProduct>;
  paidDmResponseWindowDays: Scalars['Int']['output'];
  paymentSubscriptions: Array<PaymentSubscription>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profileShowAura?: Maybe<Scalars['Boolean']['output']>;
  roomMembership?: Maybe<RoomMembership>;
  shortDisplayName: Scalars['String']['output'];
  showFullName: Scalars['Boolean']['output'];
  snapchat?: Maybe<Scalars['String']['output']>;
  storeReviewPrompt?: Maybe<StoreReviewPrompt>;
  systemBadgeNotificationsCount: Scalars['Int']['output'];
  tiktok?: Maybe<Scalars['String']['output']>;
  timezoneReference?: Maybe<Scalars['String']['output']>;
  userRole?: Maybe<UserRole>;
  userStatus: UserStatus;
  username: Scalars['String']['output'];
  verifiedAccount: Scalars['Boolean']['output'];
  viewerCanSuspend: AuthorizationResult;
  viewerCanViewEarnings: AuthorizationResult;
  viewerIsBlocking: Scalars['Boolean']['output'];
  waitlisted: Scalars['Boolean']['output'];
  webUrl?: Maybe<Scalars['String']['output']>;
  x?: Maybe<Scalars['String']['output']>;
};


export type UserFollowersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<FollowSort>;
};


export type UserFollowingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<FollowSort>;
};


export type UserNotificationSettingForArgs = {
  roomMembershipId?: InputMaybe<Scalars['String']['input']>;
  type: NotificationType;
};


export type UserRoomMembershipArgs = {
  roomId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated input type of UserBlockCreate */
export type UserBlockCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of UserBlockCreate. */
export type UserBlockCreatePayload = {
  __typename?: 'UserBlockCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  otherUser: User;
  viewer: User;
};

/** Autogenerated input type of UserBlockDelete */
export type UserBlockDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of UserBlockDelete. */
export type UserBlockDeletePayload = {
  __typename?: 'UserBlockDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  otherUser: User;
  viewer: User;
};

/** The connection type for User. */
export type UserConnection = {
  __typename?: 'UserConnection';
  /** A list of edges. */
  edges: Array<UserEdge>;
  /** A list of nodes. */
  nodes: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: User;
};

/** Autogenerated input type of UserFollow */
export type UserFollowInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  followedUserId: Scalars['ID']['input'];
  recaptchaToken?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UserFollow. */
export type UserFollowPayload = {
  __typename?: 'UserFollowPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  followedUser: User;
  user: User;
};

/** Autogenerated return type of UserInboxEvent. */
export type UserInboxEventPayload = {
  __typename?: 'UserInboxEventPayload';
  roomMessageCreated?: Maybe<InboxRoomUpdate>;
  roomMessageUpdated?: Maybe<InboxRoomUpdate>;
};

export type UserInput = {
  appLastOpenedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** signedId of a presigned uploaded image */
  avatar?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  bluesky?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fcmToken?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  messageRequestSetting?: InputMaybe<MessageRequestSetting>;
  paidDmProductId?: InputMaybe<Scalars['String']['input']>;
  snapchat?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  webUrl?: InputMaybe<Scalars['String']['input']>;
  x?: InputMaybe<Scalars['String']['input']>;
};

export type UserInputAdmin = {
  appLastOpenedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  bluesky?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fcmToken?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  messageRequestSetting?: InputMaybe<MessageRequestSetting>;
  paidDmEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  paidDmProductId?: InputMaybe<Scalars['ID']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  showFullName?: InputMaybe<Scalars['Boolean']['input']>;
  snapchat?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  userRole?: InputMaybe<UserRole>;
  username?: InputMaybe<Scalars['String']['input']>;
  verifiedAccount?: InputMaybe<Scalars['Boolean']['input']>;
  waitlisted?: InputMaybe<Scalars['Boolean']['input']>;
  webUrl?: InputMaybe<Scalars['String']['input']>;
  x?: InputMaybe<Scalars['String']['input']>;
};

export type UserModeration = Node & {
  __typename?: 'UserModeration';
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Admin/moderator who created this moderation */
  createdByUser?: Maybe<User>;
  id: Scalars['ID']['output'];
  /** Whether this restriction is currently active */
  isActive: Scalars['Boolean']['output'];
  /** Whether this is a global restriction (applies to all rooms) */
  isGlobal: Scalars['Boolean']['output'];
  /** Message that triggered the moderation */
  message?: Maybe<Message>;
  /** When the posting restriction expires */
  postingRestrictedUntil?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Room where moderation applies (null for global restrictions) */
  room?: Maybe<Room>;
  /** Custom message from moderator */
  warnMessage?: Maybe<Scalars['String']['output']>;
  /** Reason for the warning/restriction */
  warnReason?: Maybe<Scalars['String']['output']>;
};

/** The connection type for UserModeration. */
export type UserModerationConnection = {
  __typename?: 'UserModerationConnection';
  /** A list of edges. */
  edges: Array<UserModerationEdge>;
  /** A list of nodes. */
  nodes: Array<UserModeration>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserModerationEdge = {
  __typename?: 'UserModerationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: UserModeration;
};

/** Autogenerated input type of UserOnboard */
export type UserOnboardInput = {
  acceptTerms?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  completeOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  conversionTracking?: InputMaybe<AttributionDataInput>;
  id: Scalars['ID']['input'];
  recaptchaToken?: InputMaybe<Scalars['String']['input']>;
  referralRoomHandle?: InputMaybe<Scalars['String']['input']>;
  referralUsername?: InputMaybe<Scalars['String']['input']>;
  userInput?: InputMaybe<UserOnboardingInput>;
};

/** Autogenerated return type of UserOnboard. */
export type UserOnboardPayload = {
  __typename?: 'UserOnboardPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  invitationRoomIds: Array<Scalars['ID']['output']>;
  user: User;
};

export type UserOnboardingInput = {
  /** signedId of a presigned uploaded image */
  avatar?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
};

/** User role enum */
export enum UserRole {
  Default = 'DEFAULT',
  DemoAdmin = 'DEMO_ADMIN',
  SuperAdmin = 'SUPER_ADMIN',
  SystemAdmin = 'SYSTEM_ADMIN'
}

export type UserRoomBan = Node & {
  __typename?: 'UserRoomBan';
  bannedByUser: User;
  id: Scalars['ID']['output'];
  room: Room;
  user: User;
};

/** Autogenerated input type of UserRoomBanCreate */
export type UserRoomBanCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  roomId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of UserRoomBanCreate. */
export type UserRoomBanCreatePayload = {
  __typename?: 'UserRoomBanCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  userRoomBan: UserRoomBan;
};

/** Autogenerated input type of UserRoomBanRemove */
export type UserRoomBanRemoveInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  roomId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of UserRoomBanRemove. */
export type UserRoomBanRemovePayload = {
  __typename?: 'UserRoomBanRemovePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  userRoomBan: UserRoomBan;
};

export type UserRoomModerationStatus = Node & {
  __typename?: 'UserRoomModerationStatus';
  id: Scalars['ID']['output'];
  /** The message that triggered the most recent warning */
  latestWarnFlaggedMessage?: Maybe<Message>;
  /** The ID of the most recent warning */
  latestWarnId?: Maybe<Scalars['ID']['output']>;
  /** Message from moderator for most recent warning */
  latestWarnMessage?: Maybe<Scalars['String']['output']>;
  /** Reason for the most recent warning */
  latestWarnReason?: Maybe<Scalars['String']['output']>;
  /** When the user's posting restriction expires */
  postingRestrictedUntil?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Total number of warnings issued to this user across all rooms in the past 30 days */
  warnCount: Scalars['Int']['output'];
};

/** User sort type */
export enum UserSort {
  /** Sort users by aura balance descending, excluding zero balances (admin only) */
  AdminAuraDesc = 'ADMIN_AURA_DESC',
  /** Sort users by context room membership first */
  ContextRoomFirst = 'CONTEXT_ROOM_FIRST',
  /** @deprecated [1.0.6] prefer FOLLOWING sort by default */
  CurrentUserFirst = 'CURRENT_USER_FIRST',
  Following = 'FOLLOWING',
  SearchResults = 'SEARCH_RESULTS'
}

/** User status enum */
export enum UserStatus {
  Active = 'ACTIVE',
  Enrolling = 'ENROLLING',
  Onboarding = 'ONBOARDING',
  Suspended = 'SUSPENDED',
  Waitlisted = 'WAITLISTED'
}

/** Autogenerated input type of UserUnfollow */
export type UserUnfollowInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  followedUserId: Scalars['ID']['input'];
};

/** Autogenerated return type of UserUnfollow. */
export type UserUnfollowPayload = {
  __typename?: 'UserUnfollowPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  followedUser: User;
  user: User;
};

/** Autogenerated input type of UserUpdate */
export type UserUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  userInput: UserInput;
};

/** Autogenerated return type of UserUpdate. */
export type UserUpdatePayload = {
  __typename?: 'UserUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
};

/** Viewer channel membership filter enum - represents the viewer's membership status for filtering */
export enum ViewerChannelMembershipFilter {
  /** Only channels where viewer has an active membership */
  Member = 'MEMBER',
  /** Only channels where viewer has no active membership */
  NonMember = 'NON_MEMBER'
}

/** Autogenerated input type of WaitlistCodeCreate */
export type WaitlistCodeCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  roomId: Scalars['ID']['input'];
};

/** Autogenerated return type of WaitlistCodeCreate. */
export type WaitlistCodeCreatePayload = {
  __typename?: 'WaitlistCodeCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  roomWaitlistCode: RoomWaitlistCode;
};

/** Autogenerated input type of WaitlistCodeUpdate */
export type WaitlistCodeUpdateInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of WaitlistCodeUpdate. */
export type WaitlistCodeUpdatePayload = {
  __typename?: 'WaitlistCodeUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  roomWaitlistCode: RoomWaitlistCode;
};

export type AdminAdCreativeOptionsQueryVariables = Exact<{
  format?: InputMaybe<AdFormat>;
}>;


export type AdminAdCreativeOptionsQuery = { __typename?: 'Query', adminAdCreatives: Array<{ __typename?: 'AdminAdCreative', id: string, name: string, campaign: { __typename?: 'AdminAdCampaign', name: string, sponsor: { __typename?: 'AdminAdSponsor', displayName: string } } }> };

export type AdminAuraProductCreateMutationVariables = Exact<{
  input: AdminAuraProductCreateInput;
}>;


export type AdminAuraProductCreateMutation = { __typename?: 'Mutation', adminAuraProductCreate: { __typename?: 'AdminAuraProductCreatePayload', auraProduct: { __typename?: 'AuraProduct', id: string, internalName: string, storeProductIdentifier: string, store: StoreName, state: SubscriptionProductState, auraAmount: number, purchaseOnWalletScreen: boolean } } };

export type UserOverviewFragment = { __typename?: 'User', id: string, email?: string | null, username: string, displayOrUsername: string, userStatus: UserStatus, phoneNumber?: string | null, createdAt: string };

export type AdminUsersQueryVariables = Exact<{
  userRoles?: InputMaybe<Array<UserRole> | UserRole>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminUsersQuery = { __typename?: 'Query', users: { __typename?: 'UserConnection', totalCount: number, edges: Array<{ __typename?: 'UserEdge', node: { __typename?: 'User', id: string, email?: string | null, username: string, displayOrUsername: string, userStatus: UserStatus, phoneNumber?: string | null, createdAt: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type AdminAdCampaignFragment = { __typename?: 'AdminAdCampaign', id: string, name: string, active: boolean, startsAt?: string | null, endsAt?: string | null, creativesCount: number, sponsor: { __typename?: 'AdminAdSponsor', id: string, displayName: string } };

export type AdminAdCampaignSponsorOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminAdCampaignSponsorOptionsQuery = { __typename?: 'Query', adminAdSponsors: Array<{ __typename?: 'AdminAdSponsor', id: string, displayName: string }> };

export type AdminAdCampaignCreateMutationVariables = Exact<{
  input: AdminAdCampaignCreateInput;
}>;


export type AdminAdCampaignCreateMutation = { __typename?: 'Mutation', adminAdCampaignCreate: { __typename?: 'AdminAdCampaignCreatePayload', adCampaign: { __typename?: 'AdminAdCampaign', id: string, name: string, active: boolean, startsAt?: string | null, endsAt?: string | null, creativesCount: number, sponsor: { __typename?: 'AdminAdSponsor', id: string, displayName: string } } } };

export type AdminAdCampaignUpdateMutationVariables = Exact<{
  input: AdminAdCampaignUpdateInput;
}>;


export type AdminAdCampaignUpdateMutation = { __typename?: 'Mutation', adminAdCampaignUpdate: { __typename?: 'AdminAdCampaignUpdatePayload', adCampaign: { __typename?: 'AdminAdCampaign', id: string, name: string, active: boolean, startsAt?: string | null, endsAt?: string | null, creativesCount: number, sponsor: { __typename?: 'AdminAdSponsor', id: string, displayName: string } } } };

export type AdminAdCampaignsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminAdCampaignsQuery = { __typename?: 'Query', adminAdCampaigns: Array<{ __typename?: 'AdminAdCampaign', id: string, name: string, active: boolean, startsAt?: string | null, endsAt?: string | null, creativesCount: number, sponsor: { __typename?: 'AdminAdSponsor', id: string, displayName: string } }> };

export type AdminAdCampaignDeleteMutationVariables = Exact<{
  input: AdminAdCampaignDeleteInput;
}>;


export type AdminAdCampaignDeleteMutation = { __typename?: 'Mutation', adminAdCampaignDelete: { __typename?: 'AdminAdCampaignDeletePayload', success: boolean } };

export type AdminAdCreativeFragment = { __typename?: 'AdminAdCreative', id: string, name: string, format: AdFormat, ctaLink: string, ctaText?: string | null, labelText?: string | null, title?: string | null, body?: string | null, imageUrl?: string | null, imageWidth?: number | null, imageHeight?: number | null };

export type AdminAdCreativeCreateMutationVariables = Exact<{
  input: AdminAdCreativeCreateInput;
}>;


export type AdminAdCreativeCreateMutation = { __typename?: 'Mutation', adminAdCreativeCreate: { __typename?: 'AdminAdCreativeCreatePayload', adCreative: { __typename?: 'AdminAdCreative', id: string, name: string, format: AdFormat, ctaLink: string, ctaText?: string | null, labelText?: string | null, title?: string | null, body?: string | null, imageUrl?: string | null, imageWidth?: number | null, imageHeight?: number | null } } };

export type AdminAdCreativeUpdateMutationVariables = Exact<{
  input: AdminAdCreativeUpdateInput;
}>;


export type AdminAdCreativeUpdateMutation = { __typename?: 'Mutation', adminAdCreativeUpdate: { __typename?: 'AdminAdCreativeUpdatePayload', adCreative: { __typename?: 'AdminAdCreative', id: string, name: string, format: AdFormat, ctaLink: string, ctaText?: string | null, labelText?: string | null, title?: string | null, body?: string | null, imageUrl?: string | null, imageWidth?: number | null, imageHeight?: number | null } } };

export type AdminAdSponsorFragment = { __typename?: 'AdminAdSponsor', id: string, displayName: string, avatarUrl?: string | null, color?: string | null, campaignsCount: number, user?: { __typename?: 'User', id: string, displayName: string, username: string } | null };

export type AdminAdSponsorCreateMutationVariables = Exact<{
  input: AdminAdSponsorCreateInput;
}>;


export type AdminAdSponsorCreateMutation = { __typename?: 'Mutation', adminAdSponsorCreate: { __typename?: 'AdminAdSponsorCreatePayload', adSponsor: { __typename?: 'AdminAdSponsor', id: string, displayName: string, avatarUrl?: string | null, color?: string | null, campaignsCount: number, user?: { __typename?: 'User', id: string, displayName: string, username: string } | null } } };

export type AdminAdSponsorUpdateMutationVariables = Exact<{
  input: AdminAdSponsorUpdateInput;
}>;


export type AdminAdSponsorUpdateMutation = { __typename?: 'Mutation', adminAdSponsorUpdate: { __typename?: 'AdminAdSponsorUpdatePayload', adSponsor: { __typename?: 'AdminAdSponsor', id: string, displayName: string, avatarUrl?: string | null, color?: string | null, campaignsCount: number, user?: { __typename?: 'User', id: string, displayName: string, username: string } | null } } };

export type AdminAdSponsorsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminAdSponsorsQuery = { __typename?: 'Query', adminAdSponsors: Array<{ __typename?: 'AdminAdSponsor', id: string, displayName: string, avatarUrl?: string | null, color?: string | null, campaignsCount: number, user?: { __typename?: 'User', id: string, displayName: string, username: string } | null }> };

export type AdminAdSponsorDeleteMutationVariables = Exact<{
  input: AdminAdSponsorDeleteInput;
}>;


export type AdminAdSponsorDeleteMutation = { __typename?: 'Mutation', adminAdSponsorDelete: { __typename?: 'AdminAdSponsorDeletePayload', success: boolean } };

export type AdminAdCampaignQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AdminAdCampaignQuery = { __typename?: 'Query', adminAdCampaign: { __typename?: 'AdminAdCampaign', id: string, name: string, active: boolean, sponsor: { __typename?: 'AdminAdSponsor', id: string, displayName: string }, creatives: Array<{ __typename?: 'AdminAdCreative', id: string, name: string, format: AdFormat, ctaLink: string, ctaText?: string | null, labelText?: string | null, title?: string | null, body?: string | null, imageUrl?: string | null, imageWidth?: number | null, imageHeight?: number | null }> } };

export type AdminAdCreativeDeleteMutationVariables = Exact<{
  input: AdminAdCreativeDeleteInput;
}>;


export type AdminAdCreativeDeleteMutation = { __typename?: 'Mutation', adminAdCreativeDelete: { __typename?: 'AdminAdCreativeDeletePayload', success: boolean } };

export type AdminAuraCashOutHistoryQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminAuraCashOutHistoryQuery = { __typename?: 'Query', adminAuraCashOuts: { __typename?: 'AuraCashOutConnection', edges: Array<{ __typename?: 'AuraCashOutEdge', node: { __typename?: 'AuraCashOut', id: string, auraAmount: number, createdAt: string, admin: { __typename?: 'User', id: string, displayName: string, username: string } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } }, node?: { __typename?: 'Channel' } | { __typename?: 'ChannelMembership' } | { __typename?: 'Config' } | { __typename?: 'ContentReport' } | { __typename?: 'DemoWorkflow' } | { __typename?: 'Message' } | { __typename?: 'MessageLink' } | { __typename?: 'ModerationResponse' } | { __typename?: 'Notification' } | { __typename?: 'NotificationConfig' } | { __typename?: 'Organization' } | { __typename?: 'PaymentSubscription' } | { __typename?: 'Poll' } | { __typename?: 'PollOption' } | { __typename?: 'PredictionsGame' } | { __typename?: 'PredictionsGameGroup' } | { __typename?: 'PredictionsGameResponse' } | { __typename?: 'PredictionsSeason' } | { __typename?: 'ProductBenefit' } | { __typename?: 'Room' } | { __typename?: 'RoomInvitation' } | { __typename?: 'RoomInviter' } | { __typename?: 'RoomMembership' } | { __typename?: 'RoomWaitlistCode' } | { __typename?: 'StoreReviewPrompt' } | { __typename?: 'SubscriptionProduct' } | { __typename?: 'TriviaGame' } | { __typename?: 'TriviaGameResponse' } | { __typename?: 'User', id: string, displayName: string, username: string } | { __typename?: 'UserModeration' } | { __typename?: 'UserRoomBan' } | { __typename?: 'UserRoomModerationStatus' } | null };

export type CashOutUsersQueryVariables = Exact<{
  userSort?: InputMaybe<UserSort>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type CashOutUsersQuery = { __typename?: 'Query', users: { __typename?: 'UserConnection', edges: Array<{ __typename?: 'UserEdge', node: { __typename?: 'User', id: string, displayName: string, username: string, netAuraLastMonth?: number | null, auraAccount?: { __typename?: 'AuraAccount', balance: number } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type AuraProductsViewQueryVariables = Exact<{
  store?: InputMaybe<StoreName>;
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AuraProductsViewQuery = { __typename?: 'Query', auraProducts: { __typename?: 'AuraProductConnection', edges: Array<{ __typename?: 'AuraProductEdge', node: { __typename?: 'AuraProduct', id: string, internalName: string, storeProductIdentifier: string, store: StoreName, state: SubscriptionProductState, auraAmount: number, purchaseOnWalletScreen: boolean } }> } };

export type AdminAuraProductFragment = { __typename?: 'AuraProduct', id: string, internalName: string, storeProductIdentifier: string, store: StoreName, state: SubscriptionProductState, auraAmount: number, purchaseOnWalletScreen: boolean };

export type AdminAuraCashOutMutationVariables = Exact<{
  input: AdminAuraCashOutInput;
}>;


export type AdminAuraCashOutMutation = { __typename?: 'Mutation', adminAuraCashOut: { __typename?: 'AdminAuraCashOutPayload', cashOut: { __typename?: 'AuraCashOut', id: string, auraAmount: number }, user: { __typename?: 'User', id: string, auraAccount?: { __typename?: 'AuraAccount', balance: number } | null } } };

export type AdminCacheStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminCacheStatsQuery = { __typename?: 'Query', adminCacheStats: any };

export type AdminDemoRoomCreateMutationVariables = Exact<{
  roomName: Scalars['String']['input'];
  csvSignedId?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminDemoRoomCreateMutation = { __typename?: 'Mutation', adminDemoRoomCreate: { __typename?: 'AdminDemoRoomCreatePayload', room?: { __typename?: 'Room', id: string, name: string } | null, csvErrors?: Array<{ __typename?: 'DemoCsvRowError', rowNumber: number, errors: Array<string> }> | null } };

export type AdminGetRoomEditQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AdminGetRoomEditQuery = { __typename?: 'Query', room: { __typename?: 'Room', defaultAdCreativeId?: string | null, id: string, name: string, description?: string | null, roomStatus: RoomStatus, roomHandle?: string | null, webUrl?: string | null, createdAt: string, updatedAt: string, ranking?: number | null, vipName?: string | null, vipColor?: string | null, vipEnabled: boolean, vipBadgeUrl?: string | null, sharingEnabled: boolean, photoUrl?: string | null, welcomeMessage?: string | null, paymentSubscriptionsMode: PaymentSubscriptionsMode, appStoreSubscriptionGroupIdentifier?: string | null, playStoreSubscriptionGroupIdentifier?: string | null, openChatUntil?: string | null, eventLiveTimezonesDefault?: Array<string> | null, channels: Array<{ __typename?: 'Channel', id: string, name: string, mode: ChannelMode, postingPermission: ChannelPostingPermission, discardedAt?: string | null, ranking?: number | null, description?: string | null, webUrl?: string | null }>, rules: Array<{ __typename?: 'RoomRule', id: string, title: string, description?: string | null, ranking?: number | null }> } };

export type AdminRoomAutoJoinChannelsUpdateMutationVariables = Exact<{
  input: AdminRoomUpdateInput;
}>;


export type AdminRoomAutoJoinChannelsUpdateMutation = { __typename?: 'Mutation', adminRoomUpdate: { __typename?: 'AdminRoomUpdatePayload', room: { __typename?: 'Room', id: string, autoJoinChannelIds: Array<string>, defaultChannelId?: string | null } } };

export type AdminRoomUpdateMutationVariables = Exact<{
  input: AdminRoomUpdateInput;
}>;


export type AdminRoomUpdateMutation = { __typename?: 'Mutation', adminRoomUpdate: { __typename?: 'AdminRoomUpdatePayload', room: { __typename?: 'Room', id: string, name: string, description?: string | null, roomStatus: RoomStatus, roomHandle?: string | null, webUrl?: string | null, createdAt: string, updatedAt: string, ranking?: number | null, vipName?: string | null, vipColor?: string | null, vipEnabled: boolean, vipBadgeUrl?: string | null, sharingEnabled: boolean, photoUrl?: string | null, welcomeMessage?: string | null, paymentSubscriptionsMode: PaymentSubscriptionsMode, appStoreSubscriptionGroupIdentifier?: string | null, playStoreSubscriptionGroupIdentifier?: string | null, openChatUntil?: string | null, eventLiveTimezonesDefault?: Array<string> | null, channels: Array<{ __typename?: 'Channel', id: string, name: string, mode: ChannelMode, postingPermission: ChannelPostingPermission, discardedAt?: string | null, ranking?: number | null, description?: string | null, webUrl?: string | null }>, rules: Array<{ __typename?: 'RoomRule', id: string, title: string, description?: string | null, ranking?: number | null }> } } };

export type AdminGetUserEditQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AdminGetUserEditQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, username: string, displayName: string, email?: string | null, phoneNumber?: string | null, userStatus: UserStatus, userRole?: UserRole | null, createdAt: string, verifiedAccount: boolean, waitlisted: boolean, showFullName: boolean, bio?: string | null, webUrl?: string | null, avatarUrl?: string | null, activeFollowerCount: number, activeFollowingCount: number, paidDmEnabled: boolean, paidDmProduct?: { __typename?: 'AuraProduct', id: string, internalName: string, auraAmount: number } | null } };

export type AuraProductsForPaidDmQueryVariables = Exact<{ [key: string]: never; }>;


export type AuraProductsForPaidDmQuery = { __typename?: 'Query', auraProducts: { __typename?: 'AuraProductConnection', edges: Array<{ __typename?: 'AuraProductEdge', node: { __typename?: 'AuraProduct', id: string, internalName: string, auraAmount: number } }> } };

export type AdminUserUpdateMutationVariables = Exact<{
  input: AdminUserUpdateInput;
}>;


export type AdminUserUpdateMutation = { __typename?: 'Mutation', adminUserUpdate: { __typename?: 'AdminUserUpdatePayload', user: { __typename?: 'User', id: string, username: string, displayName: string, email?: string | null, phoneNumber?: string | null, userStatus: UserStatus, userRole?: UserRole | null, createdAt: string, verifiedAccount: boolean, waitlisted: boolean, showFullName: boolean, bio?: string | null, webUrl?: string | null, avatarUrl?: string | null, activeFollowerCount: number, activeFollowingCount: number, paidDmEnabled: boolean, paidDmProduct?: { __typename?: 'AuraProduct', id: string, internalName: string, auraAmount: number } | null } } };

export type AdminContentSuggestionsQueryVariables = Exact<{
  episodeId: Scalars['ID']['input'];
  contentType?: InputMaybe<ContentSuggestionType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminContentSuggestionsQuery = { __typename?: 'Query', adminContentSuggestions: { __typename?: 'AdminContentSuggestionConnection', totalCount: number, edges: Array<{ __typename?: 'AdminContentSuggestionEdge', node: { __typename?: 'AdminContentSuggestion', id: string, contentType: ContentSuggestionType, ranking: number, reasoning?: string | null, createdAt: string, content: any, selectedToPublish: boolean, message: { __typename?: 'Message', id: string, attachments: Array<{ __typename?: 'Attachment', id: string, attachmentType: AttachmentType, qAndAPrompt?: string | null, qAndAColor?: string | null, quoteText?: string | null, quoteAuthor?: string | null, poll?: { __typename?: 'Poll', id: string, title: string, pollOptions: Array<{ __typename?: 'PollOption', id: string, content: string }> } | null, trivia?: { __typename?: 'TriviaGame', id: string, title: string, questions: Array<{ __typename?: 'TriviaQuestion', id: string, text: string, options: Array<{ __typename?: 'TriviaOption', id: string, text: string, correct: boolean }> }> } | null }> } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type AdminEpisodeQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AdminEpisodeQuery = { __typename?: 'Query', adminEpisode: { __typename?: 'AdminEpisode', id: string, roomId: string, youtubeId: string, isYoutubeShort: boolean, url: string, title: string, description?: string | null, durationSeconds?: number | null, publishedAt?: string | null, thumbnailUrl?: string | null, liveStatus?: string | null, membersOnly: boolean, relevant?: boolean | null, transcriptionStatus: string, transcriptionError?: string | null, assemblyAiTranscriptId?: string | null, transcriptText?: string | null, transcriptWordCount?: number | null, transcriptAudioDurationSeconds?: number | null, transcriptConfidence?: number | null, transcriptLanguage?: string | null, reapTaskStatus: string, reapTaskError?: string | null, reapProjectId?: string | null, reapClipsCount: number, announcementPublishedAt?: string | null, announcementPublishable: boolean, announcementPublishCounts: any, detailsSyncedAt?: string | null, createdAt: string, updatedAt: string, transcriptChapters?: Array<{ __typename?: 'TranscriptChapter', startMs: number, endMs: number, headline?: string | null, gist?: string | null, summary?: string | null }> | null, transcriptUtterances?: Array<{ __typename?: 'AdminTranscriptUtterance', startMs: number, endMs: number, speaker?: string | null, confidence?: number | null, text: string }> | null, reapClips: Array<{ __typename?: 'AdminReapClip', id: string, reapProjectId: string, reapClipId: string, title?: string | null, viralScore?: number | null, viralPercent?: number | null, durationSeconds?: number | null, exportStatus: string, selectedToPublish: boolean, error?: string | null, createdAt: string, updatedAt: string, attachment?: { __typename?: 'Attachment', id: string, muxPlaybackId?: string | null, aspectRatio?: string | null } | null, episode?: { __typename?: 'AdminEpisodeVideo', id: string, title: string, url: string } | null }>, room: { __typename?: 'Room', homeChannelId?: string | null, channels: Array<{ __typename?: 'Channel', id: string, name: string }> }, youtubeSource: { __typename?: 'AdminYoutubeSource', id: string, name: string, handle?: string | null, url: string } } };

export type AdminGenerateContentFromVideoPageMutationVariables = Exact<{
  input: AdminEpisodeGenerateContentInput;
}>;


export type AdminGenerateContentFromVideoPageMutation = { __typename?: 'Mutation', adminEpisodeGenerateContent: { __typename?: 'AdminEpisodeGenerateContentPayload', episode: { __typename?: 'AdminEpisode', id: string, transcriptionStatus: string, transcriptionError?: string | null, reapTaskStatus: string, reapProjectId?: string | null, reapTaskError?: string | null } } };

export type AdminReapClipFragment = { __typename?: 'AdminReapClip', id: string, reapProjectId: string, reapClipId: string, title?: string | null, viralScore?: number | null, viralPercent?: number | null, durationSeconds?: number | null, exportStatus: string, selectedToPublish: boolean, error?: string | null, createdAt: string, updatedAt: string, attachment?: { __typename?: 'Attachment', id: string, muxPlaybackId?: string | null, aspectRatio?: string | null } | null, episode?: { __typename?: 'AdminEpisodeVideo', id: string, title: string, url: string } | null };

export type AdminContentSuggestionFragment = { __typename?: 'AdminContentSuggestion', id: string, contentType: ContentSuggestionType, ranking: number, reasoning?: string | null, createdAt: string, content: any, selectedToPublish: boolean, message: { __typename?: 'Message', id: string, attachments: Array<{ __typename?: 'Attachment', id: string, attachmentType: AttachmentType, qAndAPrompt?: string | null, qAndAColor?: string | null, quoteText?: string | null, quoteAuthor?: string | null, poll?: { __typename?: 'Poll', id: string, title: string, pollOptions: Array<{ __typename?: 'PollOption', id: string, content: string }> } | null, trivia?: { __typename?: 'TriviaGame', id: string, title: string, questions: Array<{ __typename?: 'TriviaQuestion', id: string, text: string, options: Array<{ __typename?: 'TriviaOption', id: string, text: string, correct: boolean }> }> } | null }> } };

export type ContentSuggestionAttachmentFragment = { __typename?: 'Attachment', id: string, attachmentType: AttachmentType, qAndAPrompt?: string | null, qAndAColor?: string | null, quoteText?: string | null, quoteAuthor?: string | null, poll?: { __typename?: 'Poll', id: string, title: string, pollOptions: Array<{ __typename?: 'PollOption', id: string, content: string }> } | null, trivia?: { __typename?: 'TriviaGame', id: string, title: string, questions: Array<{ __typename?: 'TriviaQuestion', id: string, text: string, options: Array<{ __typename?: 'TriviaOption', id: string, text: string, correct: boolean }> }> } | null };

export type AdminEpisodePublishAnnouncementMutationVariables = Exact<{
  input: AdminEpisodePublishAnnouncementInput;
}>;


export type AdminEpisodePublishAnnouncementMutation = { __typename?: 'Mutation', adminEpisodePublishAnnouncement: { __typename?: 'AdminEpisodePublishAnnouncementPayload', episode: { __typename?: 'AdminEpisode', id: string, announcementPublishedAt?: string | null, announcementPublishable: boolean, announcementPublishCounts: any } } };

export type AdminContentSuggestionToggleSelectedMutationVariables = Exact<{
  input: AdminContentSuggestionToggleSelectedInput;
}>;


export type AdminContentSuggestionToggleSelectedMutation = { __typename?: 'Mutation', adminContentSuggestionToggleSelected: { __typename?: 'AdminContentSuggestionToggleSelectedPayload', contentSuggestion?: { __typename?: 'AdminContentSuggestion', id: string, selectedToPublish: boolean } | null, reapClip?: { __typename?: 'AdminReapClip', id: string, selectedToPublish: boolean } | null, episode: { __typename?: 'AdminEpisode', id: string, announcementPublishable: boolean, announcementPublishCounts: any } } };

export type AdminContentSuggestionCountsQueryVariables = Exact<{
  episodeId: Scalars['ID']['input'];
}>;


export type AdminContentSuggestionCountsQuery = { __typename?: 'Query', polls: { __typename?: 'AdminContentSuggestionConnection', totalCount: number }, trivia: { __typename?: 'AdminContentSuggestionConnection', totalCount: number }, quotes: { __typename?: 'AdminContentSuggestionConnection', totalCount: number }, questions: { __typename?: 'AdminContentSuggestionConnection', totalCount: number } };

export type AdminEventFormEventQueryVariables = Exact<{
  eventId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AdminEventFormEventQuery = { __typename?: 'Query', event?: { __typename?: 'Event', id: string, title: string, description?: string | null, link?: string | null, startsAt: string, endsAt?: string | null, playbackEnabled: boolean, liveTimezones?: Array<string> | null, pinUntilEnd: boolean, autoPin: boolean } | null };

export type AdminEventUpdateMutationVariables = Exact<{
  input: EventUpdateInput;
}>;


export type AdminEventUpdateMutation = { __typename?: 'Mutation', eventUpdate: { __typename?: 'EventUpdatePayload', event: { __typename?: 'Event', id: string } } };

export type AdminEventFormDeleteMutationVariables = Exact<{
  input: EventDeleteInput;
}>;


export type AdminEventFormDeleteMutation = { __typename?: 'Mutation', eventDelete: { __typename?: 'EventDeletePayload', event: { __typename?: 'Event', id: string } } };

export type AdminEventsCreateChannelsQueryVariables = Exact<{
  roomId: Scalars['ID']['input'];
}>;


export type AdminEventsCreateChannelsQuery = { __typename?: 'Query', room: { __typename?: 'Room', id: string, eventLiveTimezonesDefault?: Array<string> | null, channels: Array<{ __typename?: 'Channel', id: string, name: string, mode: ChannelMode }> } };

export type AdminEventsCreateDuplicateQueryVariables = Exact<{
  eventId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AdminEventsCreateDuplicateQuery = { __typename?: 'Query', event?: { __typename?: 'Event', id: string, title: string, description?: string | null, link?: string | null, startsAt: string, endsAt?: string | null, playbackEnabled: boolean, liveTimezones?: Array<string> | null } | null };

export type AdminEventsCreateMutationVariables = Exact<{
  input: EventsCreateInput;
}>;


export type AdminEventsCreateMutation = { __typename?: 'Mutation', eventsCreate: { __typename?: 'EventsCreatePayload', skippedCount: number, events: Array<{ __typename?: 'Event', id: string }> } };

export type AdminLoadSheddingStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminLoadSheddingStatsQuery = { __typename?: 'Query', adminLoadSheddingStats: any };

export type AdminMessageDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AdminMessageDetailQuery = { __typename?: 'Query', adminMessage: { __typename?: 'Message', id: string, adminTextContent?: string | null, discardedAt?: string | null, createdAt: string, room: { __typename?: 'Room', id: string, name: string }, user?: { __typename?: 'User', id: string, displayOrUsername: string } | null, moderationResponse?: { __typename?: 'ModerationResponse', id: string, textResult?: ModerationResult | null, textResponseReport?: string | null, visualResult?: ModerationResult | null, visualResponseReport?: string | null, adminPermitted?: boolean | null } | null, contentReports: Array<{ __typename?: 'ContentReport', id: string, description?: string | null }>, attachments: Array<{ __typename?: 'Attachment', id: string, attachmentType: AttachmentType, contentType?: string | null, height?: number | null, width?: number | null, playbackUrl?: string | null, voiceNoteUrl?: string | null, imageUrl?: string | null, moderationImageUrl?: string | null, muxPlaybackId?: string | null, aspectRatio?: string | null, transcodingState: TranscodingState }> } };

export type ModeratedMessageItemFragment = { __typename?: 'Message', id: string, adminTextContent?: string | null, discardedAt?: string | null, createdAt: string, user?: { __typename?: 'User', id: string, displayOrUsername: string } | null, moderationResponse?: { __typename?: 'ModerationResponse', id: string, textResult?: ModerationResult | null, textResponseReport?: string | null, visualResult?: ModerationResult | null, visualResponseReport?: string | null, adminPermitted?: boolean | null } | null, contentReports: Array<{ __typename?: 'ContentReport', id: string, description?: string | null }>, attachments: Array<{ __typename?: 'Attachment', id: string, attachmentType: AttachmentType, contentType?: string | null, height?: number | null, width?: number | null, playbackUrl?: string | null, voiceNoteUrl?: string | null, imageUrl?: string | null, moderationImageUrl?: string | null, muxPlaybackId?: string | null, aspectRatio?: string | null, transcodingState: TranscodingState }> };

export type AdminModeratedMessagesQueryVariables = Exact<{
  moderationResult: ModerationResult;
  includeUserContentReports?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminModeratedMessagesQuery = { __typename?: 'Query', adminModeratedMessages: { __typename?: 'MessageConnection', edges: Array<{ __typename?: 'MessageEdge', node: { __typename?: 'Message', id: string, adminTextContent?: string | null, discardedAt?: string | null, createdAt: string, user?: { __typename?: 'User', id: string, displayOrUsername: string } | null, moderationResponse?: { __typename?: 'ModerationResponse', id: string, textResult?: ModerationResult | null, textResponseReport?: string | null, visualResult?: ModerationResult | null, visualResponseReport?: string | null, adminPermitted?: boolean | null } | null, contentReports: Array<{ __typename?: 'ContentReport', id: string, description?: string | null }>, attachments: Array<{ __typename?: 'Attachment', id: string, attachmentType: AttachmentType, contentType?: string | null, height?: number | null, width?: number | null, playbackUrl?: string | null, voiceNoteUrl?: string | null, imageUrl?: string | null, moderationImageUrl?: string | null, muxPlaybackId?: string | null, aspectRatio?: string | null, transcodingState: TranscodingState }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type UserModerationItemFragment = { __typename?: 'AdminUser', id: string, timeZone?: string | null, reportedMessagesCount: number, blockedByCount: number, postingRestrictionsCount: number, roomBansCount: number, dmAcceptedAllCount: number, dmAcceptedCount: number, dmRoomsMutuallyAcceptedCount: number, activeFollowingVerifiedCount: number, activeFollowingNonVerifiedCount: number, activeRoomFollowsCount: number, llmRecommendation: string, user: { __typename?: 'User', id: string, createdAt: string, userStatus: UserStatus, displayName: string, username: string, bio?: string | null, avatarUrl?: string | null, verifiedAccount: boolean }, recentMessages: Array<{ __typename?: 'Message', id: string, textContent?: string | null }> };

export type AdminModeratedUsersQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<AdminModeratedUsersFilter>;
  createdWithinDays?: InputMaybe<Scalars['Int']['input']>;
  excludeInvitedUsers?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AdminModeratedUsersQuery = { __typename?: 'Query', adminModeratedUsers: { __typename?: 'AdminUserConnection', edges: Array<{ __typename?: 'AdminUserEdge', node: { __typename?: 'AdminUser', id: string, timeZone?: string | null, reportedMessagesCount: number, blockedByCount: number, postingRestrictionsCount: number, roomBansCount: number, dmAcceptedAllCount: number, dmAcceptedCount: number, dmRoomsMutuallyAcceptedCount: number, activeFollowingVerifiedCount: number, activeFollowingNonVerifiedCount: number, activeRoomFollowsCount: number, llmRecommendation: string, user: { __typename?: 'User', id: string, createdAt: string, userStatus: UserStatus, displayName: string, username: string, bio?: string | null, avatarUrl?: string | null, verifiedAccount: boolean }, recentMessages: Array<{ __typename?: 'Message', id: string, textContent?: string | null }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type AdminModerateMessageMutationVariables = Exact<{
  input: AdminModerateMessageInput;
}>;


export type AdminModerateMessageMutation = { __typename?: 'Mutation', adminModerateMessage: { __typename?: 'AdminModerateMessagePayload', message: { __typename?: 'Message', id: string, adminTextContent?: string | null, discardedAt?: string | null, createdAt: string, user?: { __typename?: 'User', id: string, displayOrUsername: string } | null, moderationResponse?: { __typename?: 'ModerationResponse', id: string, textResult?: ModerationResult | null, textResponseReport?: string | null, visualResult?: ModerationResult | null, visualResponseReport?: string | null, adminPermitted?: boolean | null } | null, contentReports: Array<{ __typename?: 'ContentReport', id: string, description?: string | null }>, attachments: Array<{ __typename?: 'Attachment', id: string, attachmentType: AttachmentType, contentType?: string | null, height?: number | null, width?: number | null, playbackUrl?: string | null, voiceNoteUrl?: string | null, imageUrl?: string | null, moderationImageUrl?: string | null, muxPlaybackId?: string | null, aspectRatio?: string | null, transcodingState: TranscodingState }> } } };

export type AdminUserCreateMutationVariables = Exact<{
  input: AdminUserCreateInput;
}>;


export type AdminUserCreateMutation = { __typename?: 'Mutation', adminUserCreate: { __typename?: 'AdminUserCreatePayload', user: { __typename?: 'User', id: string } } };

export type AdminNewMemberStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminNewMemberStatsQuery = { __typename?: 'Query', adminNewMemberStats: Array<{ __typename?: 'AdminNewMemberStats', roomId: string, roomName: string, hostNames: Array<string>, monthlyStats: Array<{ __typename?: 'MonthlyNewMemberStats', month: string, count: number }> }> };

export type AdminYoutubeSourceCreateMutationVariables = Exact<{
  input: AdminYoutubeSourceCreateInput;
}>;


export type AdminYoutubeSourceCreateMutation = { __typename?: 'Mutation', adminYoutubeSourceCreate: { __typename?: 'AdminYoutubeSourceCreatePayload', youtubeSource: { __typename?: 'AdminYoutubeSource', id: string, name: string, handle?: string | null, url: string, description?: string | null, lastSyncedAt?: string | null, createdAt: string } } };

export type AdminEpisodesQueryVariables = Exact<{
  roomId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminEpisodesQuery = { __typename?: 'Query', adminEpisodes: { __typename?: 'AdminEpisodeConnection', totalCount: number, edges: Array<{ __typename?: 'AdminEpisodeEdge', node: { __typename?: 'AdminEpisode', id: string, youtubeId: string, isYoutubeShort: boolean, url: string, title: string, durationSeconds?: number | null, publishedAt?: string | null, thumbnailUrl?: string | null, liveStatus?: string | null, membersOnly: boolean, relevant?: boolean | null, transcriptionStatus: string, reapTaskStatus: string, detailsSyncedAt?: string | null, createdAt: string, updatedAt: string, youtubeSource: { __typename?: 'AdminYoutubeSource', id: string, name: string, handle?: string | null, url: string } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type AdminYoutubeHeaderCountsQueryVariables = Exact<{
  roomId: Scalars['ID']['input'];
}>;


export type AdminYoutubeHeaderCountsQuery = { __typename?: 'Query', episodesCount: { __typename?: 'AdminEpisodeConnection', totalCount: number }, sourcesCount: { __typename?: 'AdminRoomYoutubeSourceConnection', totalCount: number } };

export type AdminYoutubeSourcesQueryVariables = Exact<{
  roomId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminYoutubeSourcesQuery = { __typename?: 'Query', adminYoutubeSources: { __typename?: 'AdminRoomYoutubeSourceConnection', totalCount: number, edges: Array<{ __typename?: 'AdminRoomYoutubeSourceEdge', node: { __typename?: 'AdminRoomYoutubeSource', id: string, episodesCount: number, source: { __typename?: 'AdminYoutubeSource', id: string, name: string, handle?: string | null, url: string, description?: string | null, lastSyncedAt?: string | null, createdAt: string } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type AdminEpisodeFragment = { __typename?: 'AdminEpisode', id: string, youtubeId: string, isYoutubeShort: boolean, url: string, title: string, durationSeconds?: number | null, publishedAt?: string | null, thumbnailUrl?: string | null, liveStatus?: string | null, membersOnly: boolean, relevant?: boolean | null, transcriptionStatus: string, reapTaskStatus: string, detailsSyncedAt?: string | null, createdAt: string, updatedAt: string, youtubeSource: { __typename?: 'AdminYoutubeSource', id: string, name: string, handle?: string | null, url: string } };

export type AdminYoutubeSourceFragment = { __typename?: 'AdminYoutubeSource', id: string, name: string, handle?: string | null, url: string, description?: string | null, lastSyncedAt?: string | null, createdAt: string };

export type AdminRoomYoutubeSourceFragment = { __typename?: 'AdminRoomYoutubeSource', id: string, episodesCount: number, source: { __typename?: 'AdminYoutubeSource', id: string, name: string, handle?: string | null, url: string, description?: string | null, lastSyncedAt?: string | null, createdAt: string } };

export type AdminRoomEventsQueryVariables = Exact<{
  roomId: Scalars['ID']['input'];
  filter?: InputMaybe<EventsFilter>;
}>;


export type AdminRoomEventsQuery = { __typename?: 'Query', events: Array<{ __typename?: 'Event', id: string, title: string, startsAt: string, endsAt?: string | null }> };

export type AdminEventDeleteMutationVariables = Exact<{
  input: EventDeleteInput;
}>;


export type AdminEventDeleteMutation = { __typename?: 'Mutation', eventDelete: { __typename?: 'EventDeletePayload', event: { __typename?: 'Event', id: string } } };

export type AdminRoomHostStatsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AdminRoomHostStatsQuery = { __typename?: 'Query', adminRoom: { __typename?: 'Room', id: string, name: string, adminRoomHostStats?: Array<{ __typename?: 'AdminRoomHostStats', id: string, daysSinceOnboarded: number, daysWithAtLeastOneMessageAllTime: number, daysWithAtLeastOneMessageThisMonth: number, daysWithAtLeastOneMessageLastMonth: number, numberMessagesThisMonth: number, numberMessagesLastMonth: number, numberMessagesAllTime: number, referralCountAllTime: number, referralCountThisMonth: number, referralCountLastMonth: number, netAuraThisMonth: number, netAuraLastMonth: number, netAuraAllTime: number, user: { __typename?: 'User', id: string, displayName: string, username: string } }> | null } };

export type AdminChatbccScheduledMessagesQueryVariables = Exact<{
  roomId: Scalars['ID']['input'];
}>;


export type AdminChatbccScheduledMessagesQuery = { __typename?: 'Query', room: { __typename?: 'Room', id: string, adminChatbccScheduledMessages: { __typename?: 'MessageConnection', edges: Array<{ __typename?: 'MessageEdge', node: { __typename?: 'Message', id: string, textContent?: string | null, sendAt?: string | null, channel: { __typename?: 'Channel', id: string, name: string } } }> } } };

export type AdminUpdateScheduledMessageMutationVariables = Exact<{
  input: MessageUpdateInput;
}>;


export type AdminUpdateScheduledMessageMutation = { __typename?: 'Mutation', messageUpdate: { __typename?: 'MessageUpdatePayload', message: { __typename?: 'Message', id: string, textContent?: string | null } } };

export type AdminSendScheduledMessageNowMutationVariables = Exact<{
  input: SendScheduledMessageInput;
}>;


export type AdminSendScheduledMessageNowMutation = { __typename?: 'Mutation', sendScheduledMessage: { __typename?: 'SendScheduledMessagePayload', message: { __typename?: 'Message', id: string } } };

export type AdminRoomQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  waitlistCodesFirst?: InputMaybe<Scalars['Int']['input']>;
  waitlistCodesAfter?: InputMaybe<Scalars['String']['input']>;
  roomInvitersFirst?: InputMaybe<Scalars['Int']['input']>;
  roomInvitersAfter?: InputMaybe<Scalars['String']['input']>;
  invitationType?: InputMaybe<InvitationType>;
}>;


export type AdminRoomQuery = { __typename?: 'Query', adminRoom: { __typename?: 'Room', activeRoomMembershipsCount: number, isViewerMember: boolean, bountyChannelId?: string | null, defaultChannelId?: string | null, autoJoinChannelIds: Array<string>, id: string, name: string, description?: string | null, roomStatus: RoomStatus, roomHandle?: string | null, webUrl?: string | null, createdAt: string, updatedAt: string, ranking?: number | null, vipName?: string | null, vipColor?: string | null, vipEnabled: boolean, vipBadgeUrl?: string | null, sharingEnabled: boolean, photoUrl?: string | null, welcomeMessage?: string | null, paymentSubscriptionsMode: PaymentSubscriptionsMode, appStoreSubscriptionGroupIdentifier?: string | null, playStoreSubscriptionGroupIdentifier?: string | null, openChatUntil?: string | null, eventLiveTimezonesDefault?: Array<string> | null, defaultAdCreative?: { __typename?: 'AdminAdCreative', id: string, name: string } | null, eventsOverview: { __typename?: 'RoomEventsOverview', upcomingCount: number, hasEvent: boolean }, adminChatbccScheduledMessages: { __typename?: 'MessageConnection', totalCount: number }, adminDemoWorkflow?: { __typename?: 'DemoWorkflow', id: string, currentWorkflowState: DemoWorkflowState, allWorkflowStates: Array<DemoWorkflowState>, stepCompletionPercentage: number, error?: string | null } | null, subscriptionProducts: Array<{ __typename?: 'SubscriptionProduct', id: string, internalName: string, displayName: string, storeProductIdentifier: string, store: StoreName, state: SubscriptionProductState, position: number, createdAt: string, descriptionBullets: Array<string>, color: AppHexColor, permitsSubscriberOnlyMessages: boolean, permitsPromotedComments: boolean, collectUserEmail: boolean, collectUserPostalCode: boolean, subscriberBadgeUrl?: string | null, productBenefits: Array<{ __typename?: 'ProductBenefit', id: string, title: string, description: string }>, permittedChannels: Array<{ __typename?: 'Channel', id: string, name: string }> }>, adminPaymentSubscriptions: { __typename?: 'PaymentSubscriptionConnection', totalCount: number }, vipUsers: { __typename?: 'UserConnection', totalCount: number }, roomMembershipsPreview: Array<{ __typename?: 'RoomMembership', id: string, role: RoomMembershipRole, user: { __typename?: 'User', id: string, username: string, displayName: string, avatarUrl?: string | null } }>, roomWaitlistCodes: { __typename?: 'RoomWaitlistCodeConnection', totalCount: number, edges: Array<{ __typename?: 'RoomWaitlistCodeEdge', node: { __typename?: 'RoomWaitlistCode', id: string, code: string, archived?: boolean | null, createdAt: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } }, roomInviters: { __typename?: 'RoomInviterConnection', totalCount: number, edges: Array<{ __typename?: 'RoomInviterEdge', node: { __typename?: 'RoomInviter', id: string, username: string, displayName: string, count: number } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } }, channels: Array<{ __typename?: 'Channel', id: string, name: string, mode: ChannelMode, postingPermission: ChannelPostingPermission, discardedAt?: string | null, ranking?: number | null, description?: string | null, webUrl?: string | null }>, rules: Array<{ __typename?: 'RoomRule', id: string, title: string, description?: string | null, ranking?: number | null }> } };

export type AdminRoomToggleBountiesMutationVariables = Exact<{
  roomId: Scalars['ID']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type AdminRoomToggleBountiesMutation = { __typename?: 'Mutation', adminRoomToggleBounties: { __typename?: 'AdminRoomToggleBountiesPayload', room: { __typename?: 'Room', id: string, bountyChannelId?: string | null } } };

export type ChannelDiscardMutationVariables = Exact<{
  input: ChannelDiscardInput;
}>;


export type ChannelDiscardMutation = { __typename?: 'Mutation', channelDiscard: { __typename?: 'ChannelDiscardPayload', channel: { __typename?: 'Channel', id: string, name: string, description?: string | null, webUrl?: string | null, mode: ChannelMode, postingPermission: ChannelPostingPermission, ranking?: number | null, discardedAt?: string | null }, room: { __typename?: 'Room', id: string, channels: Array<{ __typename?: 'Channel', id: string, name: string, mode: ChannelMode, postingPermission: ChannelPostingPermission, ranking?: number | null, discardedAt?: string | null }> } } };

export type ChannelCreateMutationVariables = Exact<{
  input: ChannelCreateInput;
}>;


export type ChannelCreateMutation = { __typename?: 'Mutation', channelCreate: { __typename?: 'ChannelCreatePayload', channel: { __typename?: 'Channel', id: string, name: string, description?: string | null, webUrl?: string | null, mode: ChannelMode, postingPermission: ChannelPostingPermission, ranking?: number | null, discardedAt?: string | null }, room: { __typename?: 'Room', id: string, channels: Array<{ __typename?: 'Channel', id: string, name: string, description?: string | null, webUrl?: string | null, mode: ChannelMode, postingPermission: ChannelPostingPermission, ranking?: number | null, discardedAt?: string | null }> } } };

export type RoomRuleCreateMutationVariables = Exact<{
  input: RoomRuleCreateInput;
}>;


export type RoomRuleCreateMutation = { __typename?: 'Mutation', roomRuleCreate: { __typename?: 'RoomRuleCreatePayload', roomRule: { __typename?: 'RoomRule', id: string, title: string, description?: string | null, ranking?: number | null }, room: { __typename?: 'Room', id: string, rules: Array<{ __typename?: 'RoomRule', id: string, title: string, description?: string | null, ranking?: number | null }> } } };

export type RoomDemoWorkflowFragment = { __typename?: 'DemoWorkflow', id: string, currentWorkflowState: DemoWorkflowState, allWorkflowStates: Array<DemoWorkflowState>, stepCompletionPercentage: number, error?: string | null };

export type AdminDemoRoomRetryMutationVariables = Exact<{
  input: AdminDemoRoomRetryInput;
}>;


export type AdminDemoRoomRetryMutation = { __typename?: 'Mutation', adminDemoRoomRetry: { __typename?: 'AdminDemoRoomRetryPayload', room?: { __typename?: 'Room', id: string, adminDemoWorkflow?: { __typename?: 'DemoWorkflow', id: string, currentWorkflowState: DemoWorkflowState, allWorkflowStates: Array<DemoWorkflowState>, stepCompletionPercentage: number, error?: string | null } | null } | null } };

export type GetDemoWorkflowStatusQueryVariables = Exact<{
  roomId: Scalars['ID']['input'];
}>;


export type GetDemoWorkflowStatusQuery = { __typename?: 'Query', room: { __typename?: 'Room', id: string, adminDemoWorkflow?: { __typename?: 'DemoWorkflow', id: string, currentWorkflowState: DemoWorkflowState, allWorkflowStates: Array<DemoWorkflowState>, stepCompletionPercentage: number, error?: string | null } | null } };

export type Channel_EditChannelFragment = { __typename?: 'Channel', id: string, name: string, description?: string | null, webUrl?: string | null, mode: ChannelMode, postingPermission: ChannelPostingPermission, ranking?: number | null, discardedAt?: string | null };

export type ChannelUpdateMutationVariables = Exact<{
  input: ChannelUpdateInput;
}>;


export type ChannelUpdateMutation = { __typename?: 'Mutation', channelUpdate: { __typename?: 'ChannelUpdatePayload', channel: { __typename?: 'Channel', id: string, name: string, description?: string | null, webUrl?: string | null, mode: ChannelMode, postingPermission: ChannelPostingPermission, ranking?: number | null, discardedAt?: string | null } } };

export type RoomRuleUpdateMutationVariables = Exact<{
  input: RoomRuleUpdateInput;
}>;


export type RoomRuleUpdateMutation = { __typename?: 'Mutation', roomRuleUpdate: { __typename?: 'RoomRuleUpdatePayload', roomRule: { __typename?: 'RoomRule', id: string, title: string, description?: string | null, ranking?: number | null }, room: { __typename?: 'Room', id: string, rules: Array<{ __typename?: 'RoomRule', id: string, title: string, description?: string | null, ranking?: number | null }> } } };

export type BaseRoomInviterFragment = { __typename?: 'RoomInviter', id: string, username: string, displayName: string, count: number };

export type RoomMembershipPreviewFragment = { __typename?: 'RoomMembership', id: string, role: RoomMembershipRole, user: { __typename?: 'User', id: string, username: string, displayName: string, avatarUrl?: string | null } };

export type RoomJoinMutationVariables = Exact<{
  roomId: Scalars['ID']['input'];
}>;


export type RoomJoinMutation = { __typename?: 'Mutation', roomJoin: { __typename?: 'RoomJoinPayload', room: { __typename?: 'Room', id: string, isViewerMember: boolean } } };

export type RoomRuleDeleteMutationVariables = Exact<{
  input: RoomRuleDeleteInput;
}>;


export type RoomRuleDeleteMutation = { __typename?: 'Mutation', roomRuleDelete: { __typename?: 'RoomRuleDeletePayload', roomRule: { __typename?: 'RoomRule', id: string, title: string, description?: string | null, ranking?: number | null }, room: { __typename?: 'Room', id: string, rules: Array<{ __typename?: 'RoomRule', id: string, title: string, description?: string | null, ranking?: number | null }> } } };

export type WaitlistCodeCreateMutationVariables = Exact<{
  input: WaitlistCodeCreateInput;
}>;


export type WaitlistCodeCreateMutation = { __typename?: 'Mutation', waitlistCodeCreate: { __typename?: 'WaitlistCodeCreatePayload', roomWaitlistCode: { __typename?: 'RoomWaitlistCode', id: string, code: string, archived?: boolean | null, createdAt: string } } };

export type WaitlistCodeUpdateMutationVariables = Exact<{
  input: WaitlistCodeUpdateInput;
}>;


export type WaitlistCodeUpdateMutation = { __typename?: 'Mutation', waitlistCodeUpdate: { __typename?: 'WaitlistCodeUpdatePayload', roomWaitlistCode: { __typename?: 'RoomWaitlistCode', id: string, code: string, archived?: boolean | null, createdAt: string } } };

export type BaseRoomWaitlistCodeFragment = { __typename?: 'RoomWaitlistCode', id: string, code: string, archived?: boolean | null, createdAt: string };

export type AdminSubscriptionProductCreateMutationVariables = Exact<{
  input: AdminSubscriptionProductCreateInput;
}>;


export type AdminSubscriptionProductCreateMutation = { __typename?: 'Mutation', adminSubscriptionProductCreate: { __typename?: 'AdminSubscriptionProductCreatePayload', subscriptionProduct: { __typename?: 'SubscriptionProduct', id: string, internalName: string, displayName: string, storeProductIdentifier: string, store: StoreName, state: SubscriptionProductState, position: number, createdAt: string, descriptionBullets: Array<string>, color: AppHexColor, permitsSubscriberOnlyMessages: boolean, permitsPromotedComments: boolean, collectUserEmail: boolean, collectUserPostalCode: boolean, subscriberBadgeUrl?: string | null, productBenefits: Array<{ __typename?: 'ProductBenefit', id: string, title: string, description: string }>, permittedChannels: Array<{ __typename?: 'Channel', id: string, name: string }> } } };

export type AdminSubscriptionProductFragment = { __typename?: 'SubscriptionProduct', id: string, internalName: string, displayName: string, storeProductIdentifier: string, store: StoreName, state: SubscriptionProductState, position: number, createdAt: string, descriptionBullets: Array<string>, color: AppHexColor, permitsSubscriberOnlyMessages: boolean, permitsPromotedComments: boolean, collectUserEmail: boolean, collectUserPostalCode: boolean, subscriberBadgeUrl?: string | null, productBenefits: Array<{ __typename?: 'ProductBenefit', id: string, title: string, description: string }>, permittedChannels: Array<{ __typename?: 'Channel', id: string, name: string }> };

export type AdminSubscriptionProductsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AdminSubscriptionProductsQuery = { __typename?: 'Query', adminRoom: { __typename?: 'Room', id: string, name: string, description?: string | null, roomStatus: RoomStatus, roomHandle?: string | null, webUrl?: string | null, createdAt: string, updatedAt: string, ranking?: number | null, vipName?: string | null, vipColor?: string | null, vipEnabled: boolean, vipBadgeUrl?: string | null, sharingEnabled: boolean, photoUrl?: string | null, welcomeMessage?: string | null, paymentSubscriptionsMode: PaymentSubscriptionsMode, appStoreSubscriptionGroupIdentifier?: string | null, playStoreSubscriptionGroupIdentifier?: string | null, openChatUntil?: string | null, eventLiveTimezonesDefault?: Array<string> | null, subscriptionProducts: Array<{ __typename?: 'SubscriptionProduct', id: string, internalName: string, displayName: string, storeProductIdentifier: string, store: StoreName, state: SubscriptionProductState, position: number, createdAt: string, descriptionBullets: Array<string>, color: AppHexColor, permitsSubscriberOnlyMessages: boolean, permitsPromotedComments: boolean, collectUserEmail: boolean, collectUserPostalCode: boolean, subscriberBadgeUrl?: string | null, productBenefits: Array<{ __typename?: 'ProductBenefit', id: string, title: string, description: string }>, permittedChannels: Array<{ __typename?: 'Channel', id: string, name: string }> }>, channels: Array<{ __typename?: 'Channel', id: string, name: string, mode: ChannelMode, postingPermission: ChannelPostingPermission, discardedAt?: string | null, ranking?: number | null, description?: string | null, webUrl?: string | null }>, rules: Array<{ __typename?: 'RoomRule', id: string, title: string, description?: string | null, ranking?: number | null }> } };

export type AdminSubscriptionProductRepositionMutationVariables = Exact<{
  input: AdminSubscriptionProductRepositionInput;
}>;


export type AdminSubscriptionProductRepositionMutation = { __typename?: 'Mutation', adminSubscriptionProductReposition: { __typename?: 'AdminSubscriptionProductRepositionPayload', subscriptionProducts: Array<{ __typename?: 'SubscriptionProduct', id: string, position: number }> } };

export type AdminSubscriptionProductUpdateMutationVariables = Exact<{
  input: AdminSubscriptionProductUpdateInput;
}>;


export type AdminSubscriptionProductUpdateMutation = { __typename?: 'Mutation', adminSubscriptionProductUpdate: { __typename?: 'AdminSubscriptionProductUpdatePayload', subscriptionProduct?: { __typename?: 'SubscriptionProduct', id: string, internalName: string, displayName: string, storeProductIdentifier: string, store: StoreName, state: SubscriptionProductState, position: number, createdAt: string, descriptionBullets: Array<string>, color: AppHexColor, permitsSubscriberOnlyMessages: boolean, permitsPromotedComments: boolean, collectUserEmail: boolean, collectUserPostalCode: boolean, subscriberBadgeUrl?: string | null, productBenefits: Array<{ __typename?: 'ProductBenefit', id: string, title: string, description: string }>, permittedChannels: Array<{ __typename?: 'Channel', id: string, name: string }> } | null } };

export type AdminRoomSubscriptionsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminRoomSubscriptionsQuery = { __typename?: 'Query', adminRoom: { __typename?: 'Room', id: string, name: string, adminPaymentSubscriptions: { __typename?: 'PaymentSubscriptionConnection', totalCount: number, edges: Array<{ __typename?: 'PaymentSubscriptionEdge', node: { __typename?: 'PaymentSubscription', id: string, status: PaymentSubscriptionStatus, autoRenewalStatus: PaymentSubscriptionAutoRenewalStatus, periodEndsAt: string, recordType: SubscriptionRecord, product?: { __typename?: 'SubscriptionProduct', id: string, internalName: string } | null, user?: { __typename?: 'User', id: string, displayOrUsername: string } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } } };

export type RoomTopMessagesQueryVariables = Exact<{
  roomId: Scalars['ID']['input'];
  start?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  end?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}>;


export type RoomTopMessagesQuery = { __typename?: 'Query', room: { __typename?: 'Room', defaultChannel?: { __typename?: 'Channel', topMessages: { __typename?: 'MessageConnection', nodes: Array<{ __typename?: 'Message', id: string, adminTextContent?: string | null, reactionsCount: number, childMessagesCount: number, createdAt: string, user?: { __typename?: 'User', id: string, displayOrUsername: string } | null, room: { __typename?: 'Room', id: string, roomHandle?: string | null } }> } } | null } };

export type TopMessagePreviewFragment = { __typename?: 'Message', id: string, adminTextContent?: string | null, reactionsCount: number, childMessagesCount: number, createdAt: string, user?: { __typename?: 'User', id: string, displayOrUsername: string } | null, room: { __typename?: 'Room', id: string, roomHandle?: string | null } };

export type RoomVipUsersQueryVariables = Exact<{
  roomId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type RoomVipUsersQuery = { __typename?: 'Query', adminRoom: { __typename?: 'Room', id: string, name: string, vipUsers: { __typename?: 'UserConnection', totalCount: number, edges: Array<{ __typename?: 'UserEdge', node: { __typename?: 'User', id: string, username: string, displayName: string, createdAt: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } } };

export type AdminRoomsUpdateRankingMutationVariables = Exact<{
  roomId: Scalars['ID']['input'];
  ranking?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AdminRoomsUpdateRankingMutation = { __typename?: 'Mutation', updateRoomRanking: { __typename?: 'UpdateRoomRankingMutationPayload', room: { __typename?: 'Room', id: string, ranking?: number | null } } };

export type BaseRoomFragment = { __typename?: 'Room', id: string, name: string, description?: string | null, roomStatus: RoomStatus, roomHandle?: string | null, webUrl?: string | null, createdAt: string, updatedAt: string, ranking?: number | null, vipName?: string | null, vipColor?: string | null, vipEnabled: boolean, vipBadgeUrl?: string | null, sharingEnabled: boolean, photoUrl?: string | null, welcomeMessage?: string | null, paymentSubscriptionsMode: PaymentSubscriptionsMode, appStoreSubscriptionGroupIdentifier?: string | null, playStoreSubscriptionGroupIdentifier?: string | null, openChatUntil?: string | null, eventLiveTimezonesDefault?: Array<string> | null, channels: Array<{ __typename?: 'Channel', id: string, name: string, mode: ChannelMode, postingPermission: ChannelPostingPermission, discardedAt?: string | null, ranking?: number | null, description?: string | null, webUrl?: string | null }>, rules: Array<{ __typename?: 'RoomRule', id: string, title: string, description?: string | null, ranking?: number | null }> };

export type AdminRoomsQueryVariables = Exact<{
  roomStatus?: InputMaybe<RoomStatus>;
  search?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminRoomsQuery = { __typename?: 'Query', adminRooms: { __typename?: 'RoomConnection', totalCount: number, edges: Array<{ __typename?: 'RoomEdge', node: { __typename?: 'Room', id: string, name: string, description?: string | null, roomStatus: RoomStatus, roomHandle?: string | null, webUrl?: string | null, createdAt: string, updatedAt: string, ranking?: number | null, vipName?: string | null, vipColor?: string | null, vipEnabled: boolean, vipBadgeUrl?: string | null, sharingEnabled: boolean, photoUrl?: string | null, welcomeMessage?: string | null, paymentSubscriptionsMode: PaymentSubscriptionsMode, appStoreSubscriptionGroupIdentifier?: string | null, playStoreSubscriptionGroupIdentifier?: string | null, openChatUntil?: string | null, eventLiveTimezonesDefault?: Array<string> | null, channels: Array<{ __typename?: 'Channel', id: string, name: string, mode: ChannelMode, postingPermission: ChannelPostingPermission, discardedAt?: string | null, ranking?: number | null, description?: string | null, webUrl?: string | null }>, rules: Array<{ __typename?: 'RoomRule', id: string, title: string, description?: string | null, ranking?: number | null }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type UserDetailFragment = { __typename?: 'User', id: string, username: string, displayName: string, email?: string | null, phoneNumber?: string | null, userStatus: UserStatus, userRole?: UserRole | null, createdAt: string, verifiedAccount: boolean, waitlisted: boolean, showFullName: boolean, bio?: string | null, webUrl?: string | null, avatarUrl?: string | null, activeFollowerCount: number, activeFollowingCount: number, paidDmEnabled: boolean, paidDmProduct?: { __typename?: 'AuraProduct', id: string, internalName: string, auraAmount: number } | null };

export type AdminUserDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AdminUserDetailQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, username: string, displayName: string, email?: string | null, phoneNumber?: string | null, userStatus: UserStatus, userRole?: UserRole | null, createdAt: string, verifiedAccount: boolean, waitlisted: boolean, showFullName: boolean, bio?: string | null, webUrl?: string | null, avatarUrl?: string | null, activeFollowerCount: number, activeFollowingCount: number, paidDmEnabled: boolean, paidDmProduct?: { __typename?: 'AuraProduct', id: string, internalName: string, auraAmount: number } | null } };

export type AdminUserDetailsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  contentReportsFirst?: InputMaybe<Scalars['Int']['input']>;
  recentMessagesLimit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AdminUserDetailsQuery = { __typename?: 'Query', adminUserDetails: { __typename?: 'AdminUser', timeZone?: string | null, llmRecommendation: string, activeFollowingVerifiedCount: number, activeRoomFollowsCount: number, dmAcceptedAllCount: number, dmRoomsAcceptedCount: number, dmRoomsPendingCount: number, dmRoomsDeclinedCount: number, dmRoomsMutuallyAcceptedCount: number, recentMessages: Array<{ __typename?: 'Message', id: string, adminTextContent?: string | null, createdAt: string, room: { __typename?: 'Room', id: string, viewerRoomName: string }, contentReports: Array<{ __typename?: 'ContentReport', id: string, description?: string | null }> }>, userContentReports: { __typename?: 'MessageConnection', totalCount: number, edges: Array<{ __typename?: 'MessageEdge', node: { __typename?: 'Message', id: string, adminTextContent?: string | null, createdAt: string, room: { __typename?: 'Room', id: string, viewerRoomName: string }, contentReports: Array<{ __typename?: 'ContentReport', id: string, description?: string | null }> } }> } } };

export type AdminUserFollowedRoomsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type AdminUserFollowedRoomsQuery = { __typename?: 'Query', adminUserDetails: { __typename?: 'AdminUser', followedRooms: Array<{ __typename?: 'Room', id: string, name: string, activeRoomMembershipsCount: number, activeRoomFollowsCount: number }> } };

export type UserDetailsMessagePreviewFragment = { __typename?: 'Message', id: string, adminTextContent?: string | null, createdAt: string, room: { __typename?: 'Room', id: string, viewerRoomName: string }, contentReports: Array<{ __typename?: 'ContentReport', id: string, description?: string | null }> };

export type UserModerationFragmentFragment = { __typename?: 'UserModeration', id: string, warnReason?: string | null, warnMessage?: string | null, postingRestrictedUntil?: string | null, createdAt: string, isActive: boolean, isGlobal: boolean, room?: { __typename?: 'Room', id: string, name: string } | null, message?: { __typename?: 'Message', id: string, textContent?: string | null } | null, createdByUser?: { __typename?: 'User', id: string, username: string, displayName: string } | null };

export type AdminUserModerationsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  daysBack?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AdminUserModerationsQuery = { __typename?: 'Query', adminUserModerations: { __typename?: 'UserModerationConnection', totalCount: number, edges: Array<{ __typename?: 'UserModerationEdge', node: { __typename?: 'UserModeration', id: string, warnReason?: string | null, warnMessage?: string | null, postingRestrictedUntil?: string | null, createdAt: string, isActive: boolean, isGlobal: boolean, room?: { __typename?: 'Room', id: string, name: string } | null, message?: { __typename?: 'Message', id: string, textContent?: string | null } | null, createdByUser?: { __typename?: 'User', id: string, username: string, displayName: string } | null } }> } };

export type AdminUserModerationCreateMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  roomId?: InputMaybe<Scalars['ID']['input']>;
  warnReason: Scalars['String']['input'];
  warnMessage?: InputMaybe<Scalars['String']['input']>;
  postingRestrictedUntil?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}>;


export type AdminUserModerationCreateMutation = { __typename?: 'Mutation', adminUserModerationCreate: { __typename?: 'AdminUserModerationCreatePayload', userModeration: { __typename?: 'UserModeration', id: string, warnReason?: string | null, warnMessage?: string | null, postingRestrictedUntil?: string | null, createdAt: string, isActive: boolean, isGlobal: boolean, room?: { __typename?: 'Room', id: string, name: string } | null, message?: { __typename?: 'Message', id: string, textContent?: string | null } | null, createdByUser?: { __typename?: 'User', id: string, username: string, displayName: string } | null }, user: { __typename?: 'User', id: string } } };

export type AdminUserModerationUpdateMutationVariables = Exact<{
  moderationId: Scalars['ID']['input'];
  warnReason?: InputMaybe<Scalars['String']['input']>;
  warnMessage?: InputMaybe<Scalars['String']['input']>;
  postingRestrictedUntil?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}>;


export type AdminUserModerationUpdateMutation = { __typename?: 'Mutation', adminUserModerationUpdate: { __typename?: 'AdminUserModerationUpdatePayload', userModeration: { __typename?: 'UserModeration', id: string, warnReason?: string | null, warnMessage?: string | null, postingRestrictedUntil?: string | null, createdAt: string, isActive: boolean, isGlobal: boolean, room?: { __typename?: 'Room', id: string, name: string } | null, message?: { __typename?: 'Message', id: string, textContent?: string | null } | null, createdByUser?: { __typename?: 'User', id: string, username: string, displayName: string } | null }, user: { __typename?: 'User', id: string } } };

export type AdminUserModerationDeleteMutationVariables = Exact<{
  moderationId: Scalars['ID']['input'];
}>;


export type AdminUserModerationDeleteMutation = { __typename?: 'Mutation', adminUserModerationDelete: { __typename?: 'AdminUserModerationDeletePayload', success: boolean, user: { __typename?: 'User', id: string } } };

export type UserEarningsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  withEarningsStart?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  withEarningsEnd?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}>;


export type UserEarningsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, displayOrUsername: string }, earningsScreen: { __typename?: 'EarningsScreen', amountEarned: number, auraAmountEarned: number, plans: { __typename?: 'EarningsPlanConnection', edges: Array<{ __typename?: 'EarningsPlanEdge', node: { __typename?: 'EarningsPlan', id: string, name: string, room: { __typename?: 'Room', id: string, name: string }, planItems: Array<{ __typename?: 'EarningsPlanItem', id: string, itemType: EarningsPlanItemType, name: string, amount: number, limitAmount?: number | null, limitTimeFrame?: EarningsPlanItemLimitTimeFrame | null, amountEarned: number, amountEarnedTowardsLimit?: number | null }> } }> } } };

export type AdminUserPreviewFragment = { __typename?: 'User', id: string, displayName: string, username: string, bio?: string | null, avatarUrl?: string | null, verifiedAccount: boolean };

export type AdminAllUsersQueryVariables = Exact<{
  userRoles?: InputMaybe<Array<UserRole> | UserRole>;
  after?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminAllUsersQuery = { __typename?: 'Query', users: { __typename?: 'UserConnection', totalCount: number, edges: Array<{ __typename?: 'UserEdge', node: { __typename?: 'User', id: string, email?: string | null, username: string, displayOrUsername: string, userStatus: UserStatus, phoneNumber?: string | null, createdAt: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type AdminEarningsPlanCreateMutationVariables = Exact<{
  input: AdminEarningsPlanCreateInput;
}>;


export type AdminEarningsPlanCreateMutation = { __typename?: 'Mutation', adminEarningsPlanCreate: { __typename?: 'AdminEarningsPlanCreatePayload', earningsPlan: { __typename?: 'EarningsPlan', id: string } } };

export type AdminEarningsPlanCloneQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AdminEarningsPlanCloneQuery = { __typename?: 'Query', adminEarningsPlan: { __typename?: 'EarningsPlan', id: string, roomId: string, name: string, notes?: string | null, startsAt: string, endsAt: string, createdAt: string, planItems: Array<{ __typename?: 'EarningsPlanItem', id: string, itemType: EarningsPlanItemType, name: string, internalDescription?: string | null, amount: number, limitAmount?: number | null, limitTimeFrame?: EarningsPlanItemLimitTimeFrame | null, messagesRequired?: number | null }>, room: { __typename?: 'Room', id: string, name: string }, users: Array<{ __typename?: 'User', id: string, displayName: string, username: string, displayOrUsername: string }> } };

export type AdminAuraEarningsEventsQueryVariables = Exact<{
  earningsPlanId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminAuraEarningsEventsQuery = { __typename?: 'Query', adminEarningsPlan: { __typename?: 'EarningsPlan', id: string, name: string }, earningsScreen: { __typename?: 'EarningsScreen', earningsEvents: { __typename?: 'AuraEarningsEventConnection', edges: Array<{ __typename?: 'AuraEarningsEventEdge', node: { __typename?: 'AuraEarningsEvent', id: string, itemType: EarningsPlanItemType, amount: number, occurredAt: string, user: { __typename?: 'User', id: string, displayName: string, username: string, displayOrUsername: string }, earningsPlanItem: { __typename?: 'EarningsPlanItem', id: string, name: string } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } } };

export type AdminEarningsPlanQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AdminEarningsPlanQuery = { __typename?: 'Query', adminEarningsPlan: { __typename?: 'EarningsPlan', id: string, roomId: string, name: string, notes?: string | null, startsAt: string, endsAt: string, createdAt: string, planItems: Array<{ __typename?: 'EarningsPlanItem', id: string, itemType: EarningsPlanItemType, name: string, internalDescription?: string | null, amount: number, limitAmount?: number | null, limitTimeFrame?: EarningsPlanItemLimitTimeFrame | null, messagesRequired?: number | null }>, room: { __typename?: 'Room', id: string, name: string }, users: Array<{ __typename?: 'User', id: string, displayName: string, username: string, displayOrUsername: string }> } };

export type EarningsPlansQueryVariables = Exact<{
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type EarningsPlansQuery = { __typename?: 'Query', earningsScreen: { __typename?: 'EarningsScreen', plans: { __typename?: 'EarningsPlanConnection', edges: Array<{ __typename?: 'EarningsPlanEdge', node: { __typename?: 'EarningsPlan', id: string, roomId: string, name: string, notes?: string | null, startsAt: string, endsAt: string, createdAt: string, room: { __typename?: 'Room', id: string, name: string }, users: Array<{ __typename?: 'User', id: string, displayName: string, username: string, displayOrUsername: string }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } } };

export type AdminEarningsPlanEditQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AdminEarningsPlanEditQuery = { __typename?: 'Query', adminEarningsPlan: { __typename?: 'EarningsPlan', id: string, roomId: string, name: string, notes?: string | null, startsAt: string, endsAt: string, users: Array<{ __typename?: 'User', id: string, displayName: string, username: string, displayOrUsername: string }> } };

export type AdminEarningsPlanUpdateMutationVariables = Exact<{
  input: AdminEarningsPlanUpdateInput;
}>;


export type AdminEarningsPlanUpdateMutation = { __typename?: 'Mutation', adminEarningsPlanUpdate: { __typename?: 'AdminEarningsPlanUpdatePayload', earningsPlan: { __typename?: 'EarningsPlan', id: string } } };

export type AllRoomMembersQueryVariables = Exact<{
  membershipRoomId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AllRoomMembersQuery = { __typename?: 'Query', users: { __typename?: 'UserConnection', edges: Array<{ __typename?: 'UserEdge', node: { __typename?: 'User', id: string, displayName: string, username: string } }> } };

export type AdminEarningsPlanItemFragment = { __typename?: 'EarningsPlanItem', id: string, itemType: EarningsPlanItemType, name: string, internalDescription?: string | null, amount: number, limitAmount?: number | null, limitTimeFrame?: EarningsPlanItemLimitTimeFrame | null, messagesRequired?: number | null };

export type AdminEarningsPlanFragment = { __typename?: 'EarningsPlan', id: string, roomId: string, name: string, notes?: string | null, startsAt: string, endsAt: string, createdAt: string, room: { __typename?: 'Room', id: string, name: string }, users: Array<{ __typename?: 'User', id: string, displayName: string, username: string, displayOrUsername: string }> };

export type AdminAuraProductUpdateMutationVariables = Exact<{
  input: AdminAuraProductUpdateInput;
}>;


export type AdminAuraProductUpdateMutation = { __typename?: 'Mutation', adminAuraProductUpdate: { __typename?: 'AdminAuraProductUpdatePayload', auraProduct: { __typename?: 'AuraProduct', id: string, internalName: string, storeProductIdentifier: string, store: StoreName, state: SubscriptionProductState, auraAmount: number, purchaseOnWalletScreen: boolean } } };

export type AdminPredictionsGroupCreateMutationVariables = Exact<{
  input: AdminPredictionsGroupCreateInput;
}>;


export type AdminPredictionsGroupCreateMutation = { __typename?: 'Mutation', adminPredictionsGroupCreate: { __typename?: 'AdminPredictionsGroupCreatePayload', gameGroup: { __typename?: 'PredictionsGameGroup', id: string } } };

export type AdminPredictionGroupForResultsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AdminPredictionGroupForResultsQuery = { __typename?: 'Query', adminPredictionGroup: { __typename?: 'PredictionsGameGroup', id: string, resultsMessageText?: string | null, resultsScheduledAt?: string | null, templateGame?: { __typename?: 'PredictionsGame', id: string, title: string, endsAt: string, resultsInputAt?: string | null, questions: Array<{ __typename?: 'PredictionsQuestion', id: string, text: string, options: Array<{ __typename?: 'PredictionsOption', id: string, text: string, correct: boolean }> }> } | null } };

export type AdminPredictionsInputResultsMutationVariables = Exact<{
  input: AdminPredictionsInputResultsInput;
}>;


export type AdminPredictionsInputResultsMutation = { __typename?: 'Mutation', adminPredictionsInputResults: { __typename?: 'AdminPredictionsInputResultsPayload', gameGroup: { __typename?: 'PredictionsGameGroup', id: string } } };

export type AdminPredictionGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminPredictionGroupsQuery = { __typename?: 'Query', adminPredictionGroups: { __typename?: 'PredictionsGameGroupConnection', edges: Array<{ __typename?: 'PredictionsGameGroupEdge', node: { __typename?: 'PredictionsGameGroup', id: string, startsAt: string, gameCount: number, pinStartingMessage: boolean, resultsScheduledAt?: string | null, games: Array<{ __typename?: 'PredictionsGame', channel?: { __typename?: 'Channel', room: { __typename?: 'Room', name: string } } | null }>, templateGame?: { __typename?: 'PredictionsGame', id: string, title: string, endsAt: string, resultsInputAt?: string | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type AdminPredictionsGroupUpdateMutationVariables = Exact<{
  input: AdminPredictionsGroupUpdateInput;
}>;


export type AdminPredictionsGroupUpdateMutation = { __typename?: 'Mutation', adminPredictionsGroupUpdate: { __typename?: 'AdminPredictionsGroupUpdatePayload', gameGroup: { __typename?: 'PredictionsGameGroup', id: string } } };

export type AdminPredictionGroupQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AdminPredictionGroupQuery = { __typename?: 'Query', adminPredictionGroup: { __typename?: 'PredictionsGameGroup', id: string, startsAt: string, launchMessageText?: string | null, pinStartingMessage: boolean, templateGame?: { __typename?: 'PredictionsGame', id: string, title: string, endsAt: string, adCreativeId?: string | null, resultsInputAt?: string | null, questions: Array<{ __typename?: 'PredictionsQuestion', id: string, text: string, pointValue: number, options: Array<{ __typename?: 'PredictionsOption', id: string, text: string, correct: boolean }> }> } | null, games: Array<{ __typename?: 'PredictionsGame', id: string, responseCount: number, channel?: { __typename?: 'Channel', id: string, name: string, membershipsCount: number, room: { __typename?: 'Room', id: string, name: string } } | null }> } };

export type CachedViewerContextFragment = { __typename?: 'User', id: string, userRole?: UserRole | null, avatarUrl?: string | null, displayOrUsername: string, isAdmin: boolean };

export type LogoutMutationVariables = Exact<{
  input: LogoutInput;
}>;


export type LogoutMutation = { __typename?: 'Mutation', logout: { __typename?: 'LogoutPayload', success: boolean } };

export type ViewerQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', id: string, userRole?: UserRole | null, avatarUrl?: string | null, displayOrUsername: string, isAdmin: boolean } | null };

export type AdminUserArchiveMutationVariables = Exact<{
  input: AdminUserUpdateInput;
}>;


export type AdminUserArchiveMutation = { __typename?: 'Mutation', adminUserUpdate: { __typename?: 'AdminUserUpdatePayload', user: { __typename?: 'User', id: string, email?: string | null, username: string, displayOrUsername: string, userStatus: UserStatus, phoneNumber?: string | null, createdAt: string } } };

export type User_AvatarFragment = { __typename?: 'User', id: string, avatarUrl?: string | null, displayOrUsername: string };

export type PublishRoomMutationVariables = Exact<{
  input: RoomPublishInput;
}>;


export type PublishRoomMutation = { __typename?: 'Mutation', roomPublish: { __typename?: 'RoomPublishPayload', room: { __typename?: 'Room', id: string, name: string, description?: string | null, roomStatus: RoomStatus, roomHandle?: string | null, webUrl?: string | null, createdAt: string, updatedAt: string, ranking?: number | null, vipName?: string | null, vipColor?: string | null, vipEnabled: boolean, vipBadgeUrl?: string | null, sharingEnabled: boolean, photoUrl?: string | null, welcomeMessage?: string | null, paymentSubscriptionsMode: PaymentSubscriptionsMode, appStoreSubscriptionGroupIdentifier?: string | null, playStoreSubscriptionGroupIdentifier?: string | null, openChatUntil?: string | null, eventLiveTimezonesDefault?: Array<string> | null, channels: Array<{ __typename?: 'Channel', id: string, name: string, mode: ChannelMode, postingPermission: ChannelPostingPermission, discardedAt?: string | null, ranking?: number | null, description?: string | null, webUrl?: string | null }>, rules: Array<{ __typename?: 'RoomRule', id: string, title: string, description?: string | null, ranking?: number | null }> } } };

export type AdminUserSuspendMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  suspend: Scalars['Boolean']['input'];
  annotateRecaptcha?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AdminUserSuspendMutation = { __typename?: 'Mutation', adminUserSuspend: { __typename?: 'AdminUserSuspendPayload', user: { __typename?: 'User', id: string, email?: string | null, username: string, displayOrUsername: string, userStatus: UserStatus, phoneNumber?: string | null, createdAt: string } } };

export type AdminRoomsSearchQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminRoomsSearchQuery = { __typename?: 'Query', adminRooms: { __typename?: 'RoomConnection', edges: Array<{ __typename?: 'RoomEdge', node: { __typename?: 'Room', id: string, name: string, roomHandle?: string | null, activeRoomFollowsCount: number, activeRoomMembershipsCount: number, channels: Array<{ __typename?: 'Channel', id: string, name: string, membershipsCount: number }> } }> } };

export type AdminRoomsSearchFieldQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminRoomsSearchFieldQuery = { __typename?: 'Query', adminRooms: { __typename?: 'RoomConnection', edges: Array<{ __typename?: 'RoomEdge', node: { __typename?: 'Room', id: string, name: string, roomHandle?: string | null, activeRoomMembershipsCount: number } }> } };

export type RoomMembersSearchQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  membershipRoomId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type RoomMembersSearchQuery = { __typename?: 'Query', users: { __typename?: 'UserConnection', edges: Array<{ __typename?: 'UserEdge', node: { __typename?: 'User', id: string, displayName: string, username: string } }> } };

export type UserSearchFieldQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type UserSearchFieldQuery = { __typename?: 'Query', users: { __typename?: 'UserConnection', edges: Array<{ __typename?: 'UserEdge', node: { __typename?: 'User', id: string, displayName: string, username: string } }> } };

export type UploadPresign_MutationMutationVariables = Exact<{
  input: UploadPresignInput;
}>;


export type UploadPresign_MutationMutation = { __typename?: 'Mutation', uploadPresign: { __typename?: 'UploadPresignPayload', url?: string | null, headers?: any | null, signedId?: string | null } };

export type SendDownloadAppLinkMutationVariables = Exact<{
  input: SendDownloadAppLinkInput;
}>;


export type SendDownloadAppLinkMutation = { __typename?: 'Mutation', sendDownloadAppLink: { __typename?: 'SendDownloadAppLinkPayload', success: boolean, errors?: Array<string> | null } };

export type SendFriendInviteLinkMutationVariables = Exact<{
  input: SendFriendInviteLinkInput;
}>;


export type SendFriendInviteLinkMutation = { __typename?: 'Mutation', sendFriendInviteLink: { __typename?: 'SendFriendInviteLinkPayload', success: boolean, errors?: Array<string> | null } };

export type SendRoomShareLinkMutationVariables = Exact<{
  input: SendRoomShareLinkInput;
}>;


export type SendRoomShareLinkMutation = { __typename?: 'Mutation', sendRoomShareLink: { __typename?: 'SendRoomShareLinkPayload', success: boolean, errors?: Array<string> | null } };

export type LoginMutationVariables = Exact<{
  input: CredentialsUserAuthInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'CredentialsUserAuthPayload', user?: { __typename?: 'User', id: string } | null } };

export type EmailTokenAuthMutationVariables = Exact<{
  input: EmailTokenUserAuthInput;
}>;


export type EmailTokenAuthMutation = { __typename?: 'Mutation', emailTokenUserAuth: { __typename?: 'EmailTokenUserAuthPayload', success: boolean, csrfToken: string } };

export type EmailAuthChallengeMutationVariables = Exact<{
  input: EmailUserAuthChallengeInput;
}>;


export type EmailAuthChallengeMutation = { __typename?: 'Mutation', emailUserAuthChallenge: { __typename?: 'EmailUserAuthChallengePayload', success: boolean } };

export type UpdateProfileMutationVariables = Exact<{
  input: UserUpdateInput;
}>;


export type UpdateProfileMutation = { __typename?: 'Mutation', userUpdate: { __typename?: 'UserUpdatePayload', user: { __typename?: 'User', id: string } } };

export type ShareAttachmentFragment = { __typename?: 'Attachment', attachmentType: AttachmentType, imageUrl?: string | null, width?: number | null, height?: number | null, contentType?: string | null, giphy?: any | null, qAndAPrompt?: string | null, qAndAColor?: string | null, muxPlaybackId?: string | null, poll?: { __typename?: 'Poll', id: string, title: string, pollOptions: Array<{ __typename?: 'PollOption', id: string, content: string, pollVotesCount: number }> } | null, trivia?: { __typename?: 'TriviaGame', id: string, title: string, color?: string | null, responseCount: number } | null, liveSession?: { __typename?: 'LiveSession', id: string, title: string, status: LiveSessionStatus, startedAt?: string | null, endedAt?: string | null, muxPlaybackId?: string | null, replayPlaybackId?: string | null, participantsOnstageCount: number, viewerCount: number, viewCount: number, participantsOnstagePreview: Array<{ __typename?: 'User', id: string, avatarUrl?: string | null, displayName: string }> } | null };

export type ShareMessageFragment = { __typename?: 'Message', id: string, createdAt: string, childMessagesCount: number, textContent?: string | null, room: { __typename?: 'Room', id: string }, reactionGroups: Array<{ __typename?: 'ReactionGroup', emoji: string, reactionCount: number }>, childMessageUsers: Array<{ __typename?: 'User', avatarUrl?: string | null, shortDisplayName: string }>, quotedMessage?: { __typename?: 'Message', textContent?: string | null, user?: { __typename?: 'User', id: string, username: string, displayOrUsername: string, shortDisplayName: string, avatarUrl?: string | null, activeFollowerCount: number, verifiedAccount: boolean } | null, attachments: Array<{ __typename?: 'Attachment', attachmentType: AttachmentType, imageUrl?: string | null, width?: number | null, height?: number | null, contentType?: string | null, giphy?: any | null, qAndAPrompt?: string | null, qAndAColor?: string | null, muxPlaybackId?: string | null, poll?: { __typename?: 'Poll', id: string, title: string, pollOptions: Array<{ __typename?: 'PollOption', id: string, content: string, pollVotesCount: number }> } | null, trivia?: { __typename?: 'TriviaGame', id: string, title: string, color?: string | null, responseCount: number } | null, liveSession?: { __typename?: 'LiveSession', id: string, title: string, status: LiveSessionStatus, startedAt?: string | null, endedAt?: string | null, muxPlaybackId?: string | null, replayPlaybackId?: string | null, participantsOnstageCount: number, viewerCount: number, viewCount: number, participantsOnstagePreview: Array<{ __typename?: 'User', id: string, avatarUrl?: string | null, displayName: string }> } | null }> } | null, user?: { __typename?: 'User', id: string, username: string, displayOrUsername: string, shortDisplayName: string, avatarUrl?: string | null, activeFollowerCount: number, verifiedAccount: boolean } | null, attachments: Array<{ __typename?: 'Attachment', attachmentType: AttachmentType, imageUrl?: string | null, width?: number | null, height?: number | null, contentType?: string | null, giphy?: any | null, qAndAPrompt?: string | null, qAndAColor?: string | null, muxPlaybackId?: string | null, poll?: { __typename?: 'Poll', id: string, title: string, pollOptions: Array<{ __typename?: 'PollOption', id: string, content: string, pollVotesCount: number }> } | null, trivia?: { __typename?: 'TriviaGame', id: string, title: string, color?: string | null, responseCount: number } | null, liveSession?: { __typename?: 'LiveSession', id: string, title: string, status: LiveSessionStatus, startedAt?: string | null, endedAt?: string | null, muxPlaybackId?: string | null, replayPlaybackId?: string | null, participantsOnstageCount: number, viewerCount: number, viewCount: number, participantsOnstagePreview: Array<{ __typename?: 'User', id: string, avatarUrl?: string | null, displayName: string }> } | null }> };

export type ShareMessageContentFragment = { __typename?: 'Message', textContent?: string | null, user?: { __typename?: 'User', id: string, username: string, displayOrUsername: string, shortDisplayName: string, avatarUrl?: string | null, activeFollowerCount: number, verifiedAccount: boolean } | null, attachments: Array<{ __typename?: 'Attachment', attachmentType: AttachmentType, imageUrl?: string | null, width?: number | null, height?: number | null, contentType?: string | null, giphy?: any | null, qAndAPrompt?: string | null, qAndAColor?: string | null, muxPlaybackId?: string | null, poll?: { __typename?: 'Poll', id: string, title: string, pollOptions: Array<{ __typename?: 'PollOption', id: string, content: string, pollVotesCount: number }> } | null, trivia?: { __typename?: 'TriviaGame', id: string, title: string, color?: string | null, responseCount: number } | null, liveSession?: { __typename?: 'LiveSession', id: string, title: string, status: LiveSessionStatus, startedAt?: string | null, endedAt?: string | null, muxPlaybackId?: string | null, replayPlaybackId?: string | null, participantsOnstageCount: number, viewerCount: number, viewCount: number, participantsOnstagePreview: Array<{ __typename?: 'User', id: string, avatarUrl?: string | null, displayName: string }> } | null }> };

export type ShareReactionGroupFragment = { __typename?: 'ReactionGroup', emoji: string, reactionCount: number };

export type ShareRoomMemberFragment = { __typename?: 'User', id: string, username: string, displayOrUsername: string, shortDisplayName: string, avatarUrl?: string | null, activeFollowerCount: number, verifiedAccount: boolean };

export type ShareRoomFragment = { __typename?: 'Room', id: string, name: string, description?: string | null, roomStatus: RoomStatus, roomHandle?: string | null, activeRoomFollowsCount: number, activeRoomMembershipsCount: number, photoUrl?: string | null, defaultChannelId?: string | null, roomMembershipsPreview: Array<{ __typename?: 'RoomMembership', user: { __typename?: 'User', id: string, username: string, displayOrUsername: string, shortDisplayName: string, avatarUrl?: string | null, activeFollowerCount: number, verifiedAccount: boolean } }> };

export type LocationQueryVariables = Exact<{ [key: string]: never; }>;


export type LocationQuery = { __typename?: 'Query', location?: { __typename?: 'LocationResponse', ipGeolocation?: { __typename?: 'IpGeolocation', countryCode?: string | null } | null } | null };

export type UserDetailsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UserDetailsQuery = { __typename?: 'Query', node?: { __typename?: 'Channel' } | { __typename?: 'ChannelMembership' } | { __typename?: 'Config' } | { __typename?: 'ContentReport' } | { __typename?: 'DemoWorkflow' } | { __typename?: 'Message' } | { __typename?: 'MessageLink' } | { __typename?: 'ModerationResponse' } | { __typename?: 'Notification' } | { __typename?: 'NotificationConfig' } | { __typename?: 'Organization' } | { __typename?: 'PaymentSubscription' } | { __typename?: 'Poll' } | { __typename?: 'PollOption' } | { __typename?: 'PredictionsGame' } | { __typename?: 'PredictionsGameGroup' } | { __typename?: 'PredictionsGameResponse' } | { __typename?: 'PredictionsSeason' } | { __typename?: 'ProductBenefit' } | { __typename?: 'Room' } | { __typename?: 'RoomInvitation' } | { __typename?: 'RoomInviter' } | { __typename?: 'RoomMembership' } | { __typename?: 'RoomWaitlistCode' } | { __typename?: 'StoreReviewPrompt' } | { __typename?: 'SubscriptionProduct' } | { __typename?: 'TriviaGame' } | { __typename?: 'TriviaGameResponse' } | { __typename?: 'User', id: string, userRole?: UserRole | null } | { __typename?: 'UserModeration' } | { __typename?: 'UserRoomBan' } | { __typename?: 'UserRoomModerationStatus' } | null };

export const UserOverviewFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserOverview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"displayOrUsername"}},{"kind":"Field","name":{"kind":"Name","value":"userStatus"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]} as unknown as DocumentNode<UserOverviewFragment, unknown>;
export const AdminAdCampaignFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminAdCampaign"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AdminAdCampaign"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"startsAt"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"creativesCount"}},{"kind":"Field","name":{"kind":"Name","value":"sponsor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]} as unknown as DocumentNode<AdminAdCampaignFragment, unknown>;
export const AdminAdCreativeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminAdCreative"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AdminAdCreative"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"ctaLink"}},{"kind":"Field","name":{"kind":"Name","value":"ctaText"}},{"kind":"Field","name":{"kind":"Name","value":"labelText"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"imageWidth"}},{"kind":"Field","name":{"kind":"Name","value":"imageHeight"}}]}}]} as unknown as DocumentNode<AdminAdCreativeFragment, unknown>;
export const AdminAdSponsorFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminAdSponsor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AdminAdSponsor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"campaignsCount"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]}}]} as unknown as DocumentNode<AdminAdSponsorFragment, unknown>;
export const AdminAuraProductFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminAuraProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AuraProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}},{"kind":"Field","name":{"kind":"Name","value":"storeProductIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"store"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"auraAmount"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseOnWalletScreen"}}]}}]} as unknown as DocumentNode<AdminAuraProductFragment, unknown>;
export const AdminReapClipFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminReapClip"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AdminReapClip"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reapProjectId"}},{"kind":"Field","name":{"kind":"Name","value":"reapClipId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"viralScore"}},{"kind":"Field","name":{"kind":"Name","value":"viralPercent"}},{"kind":"Field","name":{"kind":"Name","value":"durationSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"exportStatus"}},{"kind":"Field","name":{"kind":"Name","value":"selectedToPublish"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"attachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"muxPlaybackId"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}}]}},{"kind":"Field","name":{"kind":"Name","value":"episode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<AdminReapClipFragment, unknown>;
export const ContentSuggestionAttachmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContentSuggestionAttachment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Attachment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentType"}},{"kind":"Field","name":{"kind":"Name","value":"qAndAPrompt"}},{"kind":"Field","name":{"kind":"Name","value":"qAndAColor"}},{"kind":"Field","name":{"kind":"Name","value":"quoteText"}},{"kind":"Field","name":{"kind":"Name","value":"quoteAuthor"}},{"kind":"Field","name":{"kind":"Name","value":"poll"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"pollOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"trivia"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"correct"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ContentSuggestionAttachmentFragment, unknown>;
export const AdminContentSuggestionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminContentSuggestion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AdminContentSuggestion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"}},{"kind":"Field","name":{"kind":"Name","value":"reasoning"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"selectedToPublish"}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContentSuggestionAttachment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContentSuggestionAttachment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Attachment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentType"}},{"kind":"Field","name":{"kind":"Name","value":"qAndAPrompt"}},{"kind":"Field","name":{"kind":"Name","value":"qAndAColor"}},{"kind":"Field","name":{"kind":"Name","value":"quoteText"}},{"kind":"Field","name":{"kind":"Name","value":"quoteAuthor"}},{"kind":"Field","name":{"kind":"Name","value":"poll"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"pollOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"trivia"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"correct"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AdminContentSuggestionFragment, unknown>;
export const ModeratedMessageItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModeratedMessageItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Message"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"adminTextContent"}},{"kind":"Field","name":{"kind":"Name","value":"discardedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayOrUsername"}}]}},{"kind":"Field","name":{"kind":"Name","value":"moderationResponse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"textResult"}},{"kind":"Field","name":{"kind":"Name","value":"textResponseReport"}},{"kind":"Field","name":{"kind":"Name","value":"visualResult"}},{"kind":"Field","name":{"kind":"Name","value":"visualResponseReport"}},{"kind":"Field","name":{"kind":"Name","value":"adminPermitted"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contentReports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentType"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"playbackUrl"}},{"kind":"Field","name":{"kind":"Name","value":"voiceNoteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"moderationImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"muxPlaybackId"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}},{"kind":"Field","name":{"kind":"Name","value":"transcodingState"}}]}}]}}]} as unknown as DocumentNode<ModeratedMessageItemFragment, unknown>;
export const AdminUserPreviewFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminUserPreview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedAccount"}}]}}]} as unknown as DocumentNode<AdminUserPreviewFragment, unknown>;
export const UserModerationItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserModerationItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AdminUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"userStatus"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdminUserPreview"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recentMessages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"2"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"textContent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"reportedMessagesCount"}},{"kind":"Field","name":{"kind":"Name","value":"blockedByCount"}},{"kind":"Field","name":{"kind":"Name","value":"postingRestrictionsCount"}},{"kind":"Field","name":{"kind":"Name","value":"roomBansCount"}},{"kind":"Field","name":{"kind":"Name","value":"dmAcceptedAllCount"}},{"kind":"Field","name":{"kind":"Name","value":"dmAcceptedCount"}},{"kind":"Field","name":{"kind":"Name","value":"dmRoomsMutuallyAcceptedCount"}},{"kind":"Field","name":{"kind":"Name","value":"activeFollowingVerifiedCount"}},{"kind":"Field","name":{"kind":"Name","value":"activeFollowingNonVerifiedCount"}},{"kind":"Field","name":{"kind":"Name","value":"activeRoomFollowsCount"}},{"kind":"Field","name":{"kind":"Name","value":"llmRecommendation"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminUserPreview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedAccount"}}]}}]} as unknown as DocumentNode<UserModerationItemFragment, unknown>;
export const AdminEpisodeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminEpisode"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AdminEpisode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"youtubeId"}},{"kind":"Field","name":{"kind":"Name","value":"isYoutubeShort"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"durationSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"liveStatus"}},{"kind":"Field","name":{"kind":"Name","value":"membersOnly"}},{"kind":"Field","name":{"kind":"Name","value":"relevant"}},{"kind":"Field","name":{"kind":"Name","value":"transcriptionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"reapTaskStatus"}},{"kind":"Field","name":{"kind":"Name","value":"detailsSyncedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"youtubeSource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<AdminEpisodeFragment, unknown>;
export const AdminYoutubeSourceFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminYoutubeSource"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AdminYoutubeSource"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"lastSyncedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]} as unknown as DocumentNode<AdminYoutubeSourceFragment, unknown>;
export const AdminRoomYoutubeSourceFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminRoomYoutubeSource"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AdminRoomYoutubeSource"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"episodesCount"}},{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdminYoutubeSource"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminYoutubeSource"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AdminYoutubeSource"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"lastSyncedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]} as unknown as DocumentNode<AdminRoomYoutubeSourceFragment, unknown>;
export const RoomDemoWorkflowFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoomDemoWorkflow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DemoWorkflow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currentWorkflowState"}},{"kind":"Field","name":{"kind":"Name","value":"allWorkflowStates"}},{"kind":"Field","name":{"kind":"Name","value":"stepCompletionPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]} as unknown as DocumentNode<RoomDemoWorkflowFragment, unknown>;
export const BaseRoomInviterFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseRoomInviter"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoomInviter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]} as unknown as DocumentNode<BaseRoomInviterFragment, unknown>;
export const RoomMembershipPreviewFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoomMembershipPreview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoomMembership"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}}]}}]} as unknown as DocumentNode<RoomMembershipPreviewFragment, unknown>;
export const BaseRoomWaitlistCodeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseRoomWaitlistCode"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoomWaitlistCode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]} as unknown as DocumentNode<BaseRoomWaitlistCodeFragment, unknown>;
export const AdminSubscriptionProductFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminSubscriptionProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SubscriptionProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"storeProductIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"store"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionBullets"}},{"kind":"Field","name":{"kind":"Name","value":"productBenefits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"permitsSubscriberOnlyMessages"}},{"kind":"Field","name":{"kind":"Name","value":"permitsPromotedComments"}},{"kind":"Field","name":{"kind":"Name","value":"collectUserEmail"}},{"kind":"Field","name":{"kind":"Name","value":"collectUserPostalCode"}},{"kind":"Field","name":{"kind":"Name","value":"subscriberBadgeUrl"}},{"kind":"Field","name":{"kind":"Name","value":"permittedChannels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<AdminSubscriptionProductFragment, unknown>;
export const TopMessagePreviewFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TopMessagePreview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Message"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"adminTextContent"}},{"kind":"Field","name":{"kind":"Name","value":"reactionsCount"}},{"kind":"Field","name":{"kind":"Name","value":"childMessagesCount"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayOrUsername"}}]}},{"kind":"Field","name":{"kind":"Name","value":"room"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"roomHandle"}}]}}]}}]} as unknown as DocumentNode<TopMessagePreviewFragment, unknown>;
export const Channel_EditChannelFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Channel_EditChannel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Channel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"webUrl"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"postingPermission"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"}},{"kind":"Field","name":{"kind":"Name","value":"discardedAt"}}]}}]} as unknown as DocumentNode<Channel_EditChannelFragment, unknown>;
export const BaseRoomFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseRoom"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Room"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"roomStatus"}},{"kind":"Field","name":{"kind":"Name","value":"roomHandle"}},{"kind":"Field","name":{"kind":"Name","value":"webUrl"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"}},{"kind":"Field","name":{"kind":"Name","value":"vipName"}},{"kind":"Field","name":{"kind":"Name","value":"vipColor"}},{"kind":"Field","name":{"kind":"Name","value":"vipEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"vipBadgeUrl"}},{"kind":"Field","name":{"kind":"Name","value":"sharingEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"photoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"welcomeMessage"}},{"kind":"Field","name":{"kind":"Name","value":"paymentSubscriptionsMode"}},{"kind":"Field","name":{"kind":"Name","value":"appStoreSubscriptionGroupIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"playStoreSubscriptionGroupIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"openChatUntil"}},{"kind":"Field","name":{"kind":"Name","value":"eventLiveTimezonesDefault"}},{"kind":"Field","name":{"kind":"Name","value":"channels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includeDiscarded"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"postingPermission"}},{"kind":"Field","name":{"kind":"Name","value":"discardedAt"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Channel_EditChannel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Channel_EditChannel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Channel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"webUrl"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"postingPermission"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"}},{"kind":"Field","name":{"kind":"Name","value":"discardedAt"}}]}}]} as unknown as DocumentNode<BaseRoomFragment, unknown>;
export const UserDetailFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"userStatus"}},{"kind":"Field","name":{"kind":"Name","value":"userRole"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedAccount"}},{"kind":"Field","name":{"kind":"Name","value":"waitlisted"}},{"kind":"Field","name":{"kind":"Name","value":"showFullName"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"webUrl"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"activeFollowerCount"}},{"kind":"Field","name":{"kind":"Name","value":"activeFollowingCount"}},{"kind":"Field","name":{"kind":"Name","value":"paidDmEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"paidDmProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}},{"kind":"Field","name":{"kind":"Name","value":"auraAmount"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdminUserPreview"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminUserPreview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedAccount"}}]}}]} as unknown as DocumentNode<UserDetailFragment, unknown>;
export const UserDetailsMessagePreviewFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserDetailsMessagePreview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Message"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"adminTextContent"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"room"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"viewerRoomName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contentReports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<UserDetailsMessagePreviewFragment, unknown>;
export const UserModerationFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserModerationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserModeration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"warnReason"}},{"kind":"Field","name":{"kind":"Name","value":"warnMessage"}},{"kind":"Field","name":{"kind":"Name","value":"postingRestrictedUntil"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"isGlobal"}},{"kind":"Field","name":{"kind":"Name","value":"room"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"textContent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]} as unknown as DocumentNode<UserModerationFragmentFragment, unknown>;
export const AdminEarningsPlanItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminEarningsPlanItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EarningsPlanItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"itemType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"internalDescription"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"limitAmount"}},{"kind":"Field","name":{"kind":"Name","value":"limitTimeFrame"}},{"kind":"Field","name":{"kind":"Name","value":"messagesRequired"}}]}}]} as unknown as DocumentNode<AdminEarningsPlanItemFragment, unknown>;
export const AdminEarningsPlanFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminEarningsPlan"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EarningsPlan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"roomId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"room"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"startsAt"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"displayOrUsername"}}]}}]}}]} as unknown as DocumentNode<AdminEarningsPlanFragment, unknown>;
export const CachedViewerContextFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CachedViewerContext"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userRole"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"displayOrUsername"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}}]}}]} as unknown as DocumentNode<CachedViewerContextFragment, unknown>;
export const User_AvatarFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"User_Avatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"displayOrUsername"}}]}}]} as unknown as DocumentNode<User_AvatarFragment, unknown>;
export const ShareReactionGroupFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShareReactionGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReactionGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emoji"}},{"kind":"Field","name":{"kind":"Name","value":"reactionCount"}}]}}]} as unknown as DocumentNode<ShareReactionGroupFragment, unknown>;
export const ShareRoomMemberFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShareRoomMember"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"displayOrUsername"}},{"kind":"Field","name":{"kind":"Name","value":"shortDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"activeFollowerCount"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedAccount"}}]}}]} as unknown as DocumentNode<ShareRoomMemberFragment, unknown>;
export const ShareAttachmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShareAttachment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Attachment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attachmentType"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"giphy"}},{"kind":"Field","name":{"kind":"Name","value":"poll"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"pollOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"pollVotesCount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"qAndAPrompt"}},{"kind":"Field","name":{"kind":"Name","value":"qAndAColor"}},{"kind":"Field","name":{"kind":"Name","value":"muxPlaybackId"}},{"kind":"Field","name":{"kind":"Name","value":"trivia"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"responseCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"liveSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"endedAt"}},{"kind":"Field","name":{"kind":"Name","value":"muxPlaybackId"}},{"kind":"Field","name":{"kind":"Name","value":"replayPlaybackId"}},{"kind":"Field","name":{"kind":"Name","value":"participantsOnstagePreview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"4"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"participantsOnstageCount"}},{"kind":"Field","name":{"kind":"Name","value":"viewerCount"}},{"kind":"Field","name":{"kind":"Name","value":"viewCount"}}]}}]}}]} as unknown as DocumentNode<ShareAttachmentFragment, unknown>;
export const ShareMessageContentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShareMessageContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Message"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"textContent"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShareRoomMember"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShareAttachment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShareRoomMember"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"displayOrUsername"}},{"kind":"Field","name":{"kind":"Name","value":"shortDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"activeFollowerCount"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedAccount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShareAttachment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Attachment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attachmentType"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"giphy"}},{"kind":"Field","name":{"kind":"Name","value":"poll"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"pollOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"pollVotesCount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"qAndAPrompt"}},{"kind":"Field","name":{"kind":"Name","value":"qAndAColor"}},{"kind":"Field","name":{"kind":"Name","value":"muxPlaybackId"}},{"kind":"Field","name":{"kind":"Name","value":"trivia"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"responseCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"liveSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"endedAt"}},{"kind":"Field","name":{"kind":"Name","value":"muxPlaybackId"}},{"kind":"Field","name":{"kind":"Name","value":"replayPlaybackId"}},{"kind":"Field","name":{"kind":"Name","value":"participantsOnstagePreview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"4"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"participantsOnstageCount"}},{"kind":"Field","name":{"kind":"Name","value":"viewerCount"}},{"kind":"Field","name":{"kind":"Name","value":"viewCount"}}]}}]}}]} as unknown as DocumentNode<ShareMessageContentFragment, unknown>;
export const ShareMessageFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShareMessage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Message"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"room"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"reactionGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShareReactionGroup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"childMessagesCount"}},{"kind":"Field","name":{"kind":"Name","value":"childMessageUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"shortDisplayName"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShareMessageContent"}},{"kind":"Field","name":{"kind":"Name","value":"quotedMessage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShareMessageContent"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShareRoomMember"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"displayOrUsername"}},{"kind":"Field","name":{"kind":"Name","value":"shortDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"activeFollowerCount"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedAccount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShareAttachment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Attachment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attachmentType"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"giphy"}},{"kind":"Field","name":{"kind":"Name","value":"poll"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"pollOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"pollVotesCount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"qAndAPrompt"}},{"kind":"Field","name":{"kind":"Name","value":"qAndAColor"}},{"kind":"Field","name":{"kind":"Name","value":"muxPlaybackId"}},{"kind":"Field","name":{"kind":"Name","value":"trivia"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"responseCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"liveSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"endedAt"}},{"kind":"Field","name":{"kind":"Name","value":"muxPlaybackId"}},{"kind":"Field","name":{"kind":"Name","value":"replayPlaybackId"}},{"kind":"Field","name":{"kind":"Name","value":"participantsOnstagePreview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"4"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"participantsOnstageCount"}},{"kind":"Field","name":{"kind":"Name","value":"viewerCount"}},{"kind":"Field","name":{"kind":"Name","value":"viewCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShareReactionGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReactionGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emoji"}},{"kind":"Field","name":{"kind":"Name","value":"reactionCount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShareMessageContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Message"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"textContent"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShareRoomMember"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShareAttachment"}}]}}]}}]} as unknown as DocumentNode<ShareMessageFragment, unknown>;
export const ShareRoomFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShareRoom"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Room"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"roomStatus"}},{"kind":"Field","name":{"kind":"Name","value":"roomHandle"}},{"kind":"Field","name":{"kind":"Name","value":"activeRoomFollowsCount"}},{"kind":"Field","name":{"kind":"Name","value":"activeRoomMembershipsCount"}},{"kind":"Field","name":{"kind":"Name","value":"photoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"defaultChannelId"}},{"kind":"Field","name":{"kind":"Name","value":"roomMembershipsPreview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShareRoomMember"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShareRoomMember"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"displayOrUsername"}},{"kind":"Field","name":{"kind":"Name","value":"shortDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"activeFollowerCount"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedAccount"}}]}}]} as unknown as DocumentNode<ShareRoomFragment, unknown>;
export const AdminAdCreativeOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminAdCreativeOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"format"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AdFormat"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminAdCreatives"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"Variable","name":{"kind":"Name","value":"format"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"campaign"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sponsor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AdminAdCreativeOptionsQuery, AdminAdCreativeOptionsQueryVariables>;
export const AdminAuraProductCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminAuraProductCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AdminAuraProductCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminAuraProductCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auraProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdminAuraProduct"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminAuraProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AuraProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}},{"kind":"Field","name":{"kind":"Name","value":"storeProductIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"store"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"auraAmount"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseOnWalletScreen"}}]}}]} as unknown as DocumentNode<AdminAuraProductCreateMutation, AdminAuraProductCreateMutationVariables>;
export const AdminUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userRoles"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserRole"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userRoles"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userRoles"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserOverview"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserOverview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"displayOrUsername"}},{"kind":"Field","name":{"kind":"Name","value":"userStatus"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]} as unknown as DocumentNode<AdminUsersQuery, AdminUsersQueryVariables>;
export const AdminAdCampaignSponsorOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminAdCampaignSponsorOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminAdSponsors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]} as unknown as DocumentNode<AdminAdCampaignSponsorOptionsQuery, AdminAdCampaignSponsorOptionsQueryVariables>;
export const AdminAdCampaignCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminAdCampaignCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AdminAdCampaignCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminAdCampaignCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adCampaign"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdminAdCampaign"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminAdCampaign"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AdminAdCampaign"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"startsAt"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"creativesCount"}},{"kind":"Field","name":{"kind":"Name","value":"sponsor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]} as unknown as DocumentNode<AdminAdCampaignCreateMutation, AdminAdCampaignCreateMutationVariables>;
export const AdminAdCampaignUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminAdCampaignUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AdminAdCampaignUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminAdCampaignUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adCampaign"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdminAdCampaign"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminAdCampaign"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AdminAdCampaign"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"startsAt"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"creativesCount"}},{"kind":"Field","name":{"kind":"Name","value":"sponsor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]} as unknown as DocumentNode<AdminAdCampaignUpdateMutation, AdminAdCampaignUpdateMutationVariables>;
export const AdminAdCampaignsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminAdCampaigns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminAdCampaigns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdminAdCampaign"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminAdCampaign"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AdminAdCampaign"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"startsAt"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"creativesCount"}},{"kind":"Field","name":{"kind":"Name","value":"sponsor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]} as unknown as DocumentNode<AdminAdCampaignsQuery, AdminAdCampaignsQueryVariables>;
export const AdminAdCampaignDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminAdCampaignDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AdminAdCampaignDeleteInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminAdCampaignDelete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<AdminAdCampaignDeleteMutation, AdminAdCampaignDeleteMutationVariables>;
export const AdminAdCreativeCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminAdCreativeCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AdminAdCreativeCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminAdCreativeCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adCreative"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdminAdCreative"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminAdCreative"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AdminAdCreative"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"ctaLink"}},{"kind":"Field","name":{"kind":"Name","value":"ctaText"}},{"kind":"Field","name":{"kind":"Name","value":"labelText"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"imageWidth"}},{"kind":"Field","name":{"kind":"Name","value":"imageHeight"}}]}}]} as unknown as DocumentNode<AdminAdCreativeCreateMutation, AdminAdCreativeCreateMutationVariables>;
export const AdminAdCreativeUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminAdCreativeUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AdminAdCreativeUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminAdCreativeUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adCreative"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdminAdCreative"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminAdCreative"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AdminAdCreative"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"ctaLink"}},{"kind":"Field","name":{"kind":"Name","value":"ctaText"}},{"kind":"Field","name":{"kind":"Name","value":"labelText"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"imageWidth"}},{"kind":"Field","name":{"kind":"Name","value":"imageHeight"}}]}}]} as unknown as DocumentNode<AdminAdCreativeUpdateMutation, AdminAdCreativeUpdateMutationVariables>;
export const AdminAdSponsorCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminAdSponsorCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AdminAdSponsorCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminAdSponsorCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adSponsor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdminAdSponsor"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminAdSponsor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AdminAdSponsor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"campaignsCount"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]}}]} as unknown as DocumentNode<AdminAdSponsorCreateMutation, AdminAdSponsorCreateMutationVariables>;
export const AdminAdSponsorUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminAdSponsorUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AdminAdSponsorUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminAdSponsorUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adSponsor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdminAdSponsor"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminAdSponsor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AdminAdSponsor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"campaignsCount"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]}}]} as unknown as DocumentNode<AdminAdSponsorUpdateMutation, AdminAdSponsorUpdateMutationVariables>;
export const AdminAdSponsorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminAdSponsors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminAdSponsors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdminAdSponsor"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminAdSponsor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AdminAdSponsor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"campaignsCount"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]}}]} as unknown as DocumentNode<AdminAdSponsorsQuery, AdminAdSponsorsQueryVariables>;
export const AdminAdSponsorDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminAdSponsorDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AdminAdSponsorDeleteInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminAdSponsorDelete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<AdminAdSponsorDeleteMutation, AdminAdSponsorDeleteMutationVariables>;
export const AdminAdCampaignDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminAdCampaign"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminAdCampaign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"sponsor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creatives"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdminAdCreative"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminAdCreative"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AdminAdCreative"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"ctaLink"}},{"kind":"Field","name":{"kind":"Name","value":"ctaText"}},{"kind":"Field","name":{"kind":"Name","value":"labelText"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"imageWidth"}},{"kind":"Field","name":{"kind":"Name","value":"imageHeight"}}]}}]} as unknown as DocumentNode<AdminAdCampaignQuery, AdminAdCampaignQueryVariables>;
export const AdminAdCreativeDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminAdCreativeDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AdminAdCreativeDeleteInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminAdCreativeDelete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<AdminAdCreativeDeleteMutation, AdminAdCreativeDeleteMutationVariables>;
export const AdminAuraCashOutHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminAuraCashOutHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminAuraCashOuts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"auraAmount"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"admin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]}}]}}]} as unknown as DocumentNode<AdminAuraCashOutHistoryQuery, AdminAuraCashOutHistoryQueryVariables>;
export const CashOutUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CashOutUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userSort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserSort"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userSort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userSort"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"StringValue","value":"","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"auraAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"balance"}}]}},{"kind":"Field","name":{"kind":"Name","value":"netAuraLastMonth"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<CashOutUsersQuery, CashOutUsersQueryVariables>;
export const AuraProductsViewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AuraProductsView"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"store"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StoreName"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeDisabled"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auraProducts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"store"},"value":{"kind":"Variable","name":{"kind":"Name","value":"store"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeDisabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeDisabled"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdminAuraProduct"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminAuraProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AuraProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}},{"kind":"Field","name":{"kind":"Name","value":"storeProductIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"store"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"auraAmount"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseOnWalletScreen"}}]}}]} as unknown as DocumentNode<AuraProductsViewQuery, AuraProductsViewQueryVariables>;
export const AdminAuraCashOutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminAuraCashOut"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AdminAuraCashOutInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminAuraCashOut"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cashOut"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"auraAmount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"auraAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"balance"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AdminAuraCashOutMutation, AdminAuraCashOutMutationVariables>;
export const AdminCacheStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminCacheStats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminCacheStats"}}]}}]} as unknown as DocumentNode<AdminCacheStatsQuery, AdminCacheStatsQueryVariables>;
export const AdminDemoRoomCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminDemoRoomCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roomName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"csvSignedId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminDemoRoomCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"roomName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roomName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"csvSignedId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"csvSignedId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"room"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"csvErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowNumber"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]}}]} as unknown as DocumentNode<AdminDemoRoomCreateMutation, AdminDemoRoomCreateMutationVariables>;
export const AdminGetRoomEditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminGetRoomEdit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"room"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseRoom"}},{"kind":"Field","name":{"kind":"Name","value":"defaultAdCreativeId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Channel_EditChannel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Channel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"webUrl"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"postingPermission"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"}},{"kind":"Field","name":{"kind":"Name","value":"discardedAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseRoom"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Room"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"roomStatus"}},{"kind":"Field","name":{"kind":"Name","value":"roomHandle"}},{"kind":"Field","name":{"kind":"Name","value":"webUrl"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"}},{"kind":"Field","name":{"kind":"Name","value":"vipName"}},{"kind":"Field","name":{"kind":"Name","value":"vipColor"}},{"kind":"Field","name":{"kind":"Name","value":"vipEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"vipBadgeUrl"}},{"kind":"Field","name":{"kind":"Name","value":"sharingEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"photoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"welcomeMessage"}},{"kind":"Field","name":{"kind":"Name","value":"paymentSubscriptionsMode"}},{"kind":"Field","name":{"kind":"Name","value":"appStoreSubscriptionGroupIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"playStoreSubscriptionGroupIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"openChatUntil"}},{"kind":"Field","name":{"kind":"Name","value":"eventLiveTimezonesDefault"}},{"kind":"Field","name":{"kind":"Name","value":"channels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includeDiscarded"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"postingPermission"}},{"kind":"Field","name":{"kind":"Name","value":"discardedAt"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Channel_EditChannel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"}}]}}]}}]} as unknown as DocumentNode<AdminGetRoomEditQuery, AdminGetRoomEditQueryVariables>;
export const AdminRoomAutoJoinChannelsUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminRoomAutoJoinChannelsUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AdminRoomUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminRoomUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"room"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"autoJoinChannelIds"}},{"kind":"Field","name":{"kind":"Name","value":"defaultChannelId"}}]}}]}}]}}]} as unknown as DocumentNode<AdminRoomAutoJoinChannelsUpdateMutation, AdminRoomAutoJoinChannelsUpdateMutationVariables>;
export const AdminRoomUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminRoomUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AdminRoomUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminRoomUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"room"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseRoom"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Channel_EditChannel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Channel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"webUrl"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"postingPermission"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"}},{"kind":"Field","name":{"kind":"Name","value":"discardedAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseRoom"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Room"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"roomStatus"}},{"kind":"Field","name":{"kind":"Name","value":"roomHandle"}},{"kind":"Field","name":{"kind":"Name","value":"webUrl"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"}},{"kind":"Field","name":{"kind":"Name","value":"vipName"}},{"kind":"Field","name":{"kind":"Name","value":"vipColor"}},{"kind":"Field","name":{"kind":"Name","value":"vipEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"vipBadgeUrl"}},{"kind":"Field","name":{"kind":"Name","value":"sharingEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"photoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"welcomeMessage"}},{"kind":"Field","name":{"kind":"Name","value":"paymentSubscriptionsMode"}},{"kind":"Field","name":{"kind":"Name","value":"appStoreSubscriptionGroupIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"playStoreSubscriptionGroupIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"openChatUntil"}},{"kind":"Field","name":{"kind":"Name","value":"eventLiveTimezonesDefault"}},{"kind":"Field","name":{"kind":"Name","value":"channels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includeDiscarded"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"postingPermission"}},{"kind":"Field","name":{"kind":"Name","value":"discardedAt"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Channel_EditChannel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"}}]}}]}}]} as unknown as DocumentNode<AdminRoomUpdateMutation, AdminRoomUpdateMutationVariables>;
export const AdminGetUserEditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminGetUserEdit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserDetail"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminUserPreview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedAccount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"userStatus"}},{"kind":"Field","name":{"kind":"Name","value":"userRole"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedAccount"}},{"kind":"Field","name":{"kind":"Name","value":"waitlisted"}},{"kind":"Field","name":{"kind":"Name","value":"showFullName"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"webUrl"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"activeFollowerCount"}},{"kind":"Field","name":{"kind":"Name","value":"activeFollowingCount"}},{"kind":"Field","name":{"kind":"Name","value":"paidDmEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"paidDmProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}},{"kind":"Field","name":{"kind":"Name","value":"auraAmount"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdminUserPreview"}}]}}]} as unknown as DocumentNode<AdminGetUserEditQuery, AdminGetUserEditQueryVariables>;
export const AuraProductsForPaidDmDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AuraProductsForPaidDm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auraProducts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"includeDisabled"},"value":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}},{"kind":"Field","name":{"kind":"Name","value":"auraAmount"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AuraProductsForPaidDmQuery, AuraProductsForPaidDmQueryVariables>;
export const AdminUserUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminUserUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AdminUserUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminUserUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserDetail"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminUserPreview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedAccount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"userStatus"}},{"kind":"Field","name":{"kind":"Name","value":"userRole"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedAccount"}},{"kind":"Field","name":{"kind":"Name","value":"waitlisted"}},{"kind":"Field","name":{"kind":"Name","value":"showFullName"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"webUrl"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"activeFollowerCount"}},{"kind":"Field","name":{"kind":"Name","value":"activeFollowingCount"}},{"kind":"Field","name":{"kind":"Name","value":"paidDmEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"paidDmProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}},{"kind":"Field","name":{"kind":"Name","value":"auraAmount"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdminUserPreview"}}]}}]} as unknown as DocumentNode<AdminUserUpdateMutation, AdminUserUpdateMutationVariables>;
export const AdminContentSuggestionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminContentSuggestions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"episodeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contentType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContentSuggestionType"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminContentSuggestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"episodeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"episodeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"contentType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contentType"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdminContentSuggestion"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContentSuggestionAttachment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Attachment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentType"}},{"kind":"Field","name":{"kind":"Name","value":"qAndAPrompt"}},{"kind":"Field","name":{"kind":"Name","value":"qAndAColor"}},{"kind":"Field","name":{"kind":"Name","value":"quoteText"}},{"kind":"Field","name":{"kind":"Name","value":"quoteAuthor"}},{"kind":"Field","name":{"kind":"Name","value":"poll"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"pollOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"trivia"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"correct"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminContentSuggestion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AdminContentSuggestion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"}},{"kind":"Field","name":{"kind":"Name","value":"reasoning"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"selectedToPublish"}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContentSuggestionAttachment"}}]}}]}}]}}]} as unknown as DocumentNode<AdminContentSuggestionsQuery, AdminContentSuggestionsQueryVariables>;
export const AdminEpisodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminEpisode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminEpisode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"roomId"}},{"kind":"Field","name":{"kind":"Name","value":"youtubeId"}},{"kind":"Field","name":{"kind":"Name","value":"isYoutubeShort"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"durationSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"liveStatus"}},{"kind":"Field","name":{"kind":"Name","value":"membersOnly"}},{"kind":"Field","name":{"kind":"Name","value":"relevant"}},{"kind":"Field","name":{"kind":"Name","value":"transcriptionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"transcriptionError"}},{"kind":"Field","name":{"kind":"Name","value":"assemblyAiTranscriptId"}},{"kind":"Field","name":{"kind":"Name","value":"transcriptText"}},{"kind":"Field","name":{"kind":"Name","value":"transcriptWordCount"}},{"kind":"Field","name":{"kind":"Name","value":"transcriptAudioDurationSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"transcriptConfidence"}},{"kind":"Field","name":{"kind":"Name","value":"transcriptLanguage"}},{"kind":"Field","name":{"kind":"Name","value":"transcriptChapters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startMs"}},{"kind":"Field","name":{"kind":"Name","value":"endMs"}},{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"gist"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"transcriptUtterances"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startMs"}},{"kind":"Field","name":{"kind":"Name","value":"endMs"}},{"kind":"Field","name":{"kind":"Name","value":"speaker"}},{"kind":"Field","name":{"kind":"Name","value":"confidence"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reapTaskStatus"}},{"kind":"Field","name":{"kind":"Name","value":"reapTaskError"}},{"kind":"Field","name":{"kind":"Name","value":"reapProjectId"}},{"kind":"Field","name":{"kind":"Name","value":"reapClipsCount"}},{"kind":"Field","name":{"kind":"Name","value":"reapClips"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdminReapClip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"announcementPublishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"announcementPublishable"}},{"kind":"Field","name":{"kind":"Name","value":"announcementPublishCounts"}},{"kind":"Field","name":{"kind":"Name","value":"room"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"homeChannelId"}},{"kind":"Field","name":{"kind":"Name","value":"channels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"detailsSyncedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"youtubeSource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminReapClip"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AdminReapClip"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reapProjectId"}},{"kind":"Field","name":{"kind":"Name","value":"reapClipId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"viralScore"}},{"kind":"Field","name":{"kind":"Name","value":"viralPercent"}},{"kind":"Field","name":{"kind":"Name","value":"durationSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"exportStatus"}},{"kind":"Field","name":{"kind":"Name","value":"selectedToPublish"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"attachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"muxPlaybackId"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}}]}},{"kind":"Field","name":{"kind":"Name","value":"episode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<AdminEpisodeQuery, AdminEpisodeQueryVariables>;
export const AdminGenerateContentFromVideoPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminGenerateContentFromVideoPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AdminEpisodeGenerateContentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminEpisodeGenerateContent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"episode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"transcriptionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"transcriptionError"}},{"kind":"Field","name":{"kind":"Name","value":"reapTaskStatus"}},{"kind":"Field","name":{"kind":"Name","value":"reapProjectId"}},{"kind":"Field","name":{"kind":"Name","value":"reapTaskError"}}]}}]}}]}}]} as unknown as DocumentNode<AdminGenerateContentFromVideoPageMutation, AdminGenerateContentFromVideoPageMutationVariables>;
export const AdminEpisodePublishAnnouncementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminEpisodePublishAnnouncement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AdminEpisodePublishAnnouncementInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminEpisodePublishAnnouncement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"episode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"announcementPublishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"announcementPublishable"}},{"kind":"Field","name":{"kind":"Name","value":"announcementPublishCounts"}}]}}]}}]}}]} as unknown as DocumentNode<AdminEpisodePublishAnnouncementMutation, AdminEpisodePublishAnnouncementMutationVariables>;
export const AdminContentSuggestionToggleSelectedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminContentSuggestionToggleSelected"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AdminContentSuggestionToggleSelectedInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminContentSuggestionToggleSelected"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentSuggestion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"selectedToPublish"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reapClip"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"selectedToPublish"}}]}},{"kind":"Field","name":{"kind":"Name","value":"episode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"announcementPublishable"}},{"kind":"Field","name":{"kind":"Name","value":"announcementPublishCounts"}}]}}]}}]}}]} as unknown as DocumentNode<AdminContentSuggestionToggleSelectedMutation, AdminContentSuggestionToggleSelectedMutationVariables>;
export const AdminContentSuggestionCountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminContentSuggestionCounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"episodeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"polls"},"name":{"kind":"Name","value":"adminContentSuggestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"episodeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"episodeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"contentType"},"value":{"kind":"EnumValue","value":"poll"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"0"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"trivia"},"name":{"kind":"Name","value":"adminContentSuggestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"episodeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"episodeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"contentType"},"value":{"kind":"EnumValue","value":"trivia_question"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"0"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"quotes"},"name":{"kind":"Name","value":"adminContentSuggestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"episodeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"episodeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"contentType"},"value":{"kind":"EnumValue","value":"quote"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"0"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"questions"},"name":{"kind":"Name","value":"adminContentSuggestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"episodeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"episodeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"contentType"},"value":{"kind":"EnumValue","value":"discussion_question"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"0"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<AdminContentSuggestionCountsQuery, AdminContentSuggestionCountsQueryVariables>;
export const AdminEventFormEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminEventFormEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"startsAt"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"playbackEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"liveTimezones"}},{"kind":"Field","name":{"kind":"Name","value":"pinUntilEnd"}},{"kind":"Field","name":{"kind":"Name","value":"autoPin"}}]}}]}}]} as unknown as DocumentNode<AdminEventFormEventQuery, AdminEventFormEventQueryVariables>;
export const AdminEventUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminEventUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<AdminEventUpdateMutation, AdminEventUpdateMutationVariables>;
export const AdminEventFormDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminEventFormDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventDeleteInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventDelete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<AdminEventFormDeleteMutation, AdminEventFormDeleteMutationVariables>;
export const AdminEventsCreateChannelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminEventsCreateChannels"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roomId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"room"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roomId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventLiveTimezonesDefault"}},{"kind":"Field","name":{"kind":"Name","value":"channels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}}]}}]}}]}}]} as unknown as DocumentNode<AdminEventsCreateChannelsQuery, AdminEventsCreateChannelsQueryVariables>;
export const AdminEventsCreateDuplicateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminEventsCreateDuplicate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"startsAt"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"playbackEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"liveTimezones"}}]}}]}}]} as unknown as DocumentNode<AdminEventsCreateDuplicateQuery, AdminEventsCreateDuplicateQueryVariables>;
export const AdminEventsCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminEventsCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventsCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventsCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"skippedCount"}}]}}]}}]} as unknown as DocumentNode<AdminEventsCreateMutation, AdminEventsCreateMutationVariables>;
export const AdminLoadSheddingStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminLoadSheddingStats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminLoadSheddingStats"}}]}}]} as unknown as DocumentNode<AdminLoadSheddingStatsQuery, AdminLoadSheddingStatsQueryVariables>;
export const AdminMessageDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminMessageDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ModeratedMessageItem"}},{"kind":"Field","name":{"kind":"Name","value":"room"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModeratedMessageItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Message"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"adminTextContent"}},{"kind":"Field","name":{"kind":"Name","value":"discardedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayOrUsername"}}]}},{"kind":"Field","name":{"kind":"Name","value":"moderationResponse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"textResult"}},{"kind":"Field","name":{"kind":"Name","value":"textResponseReport"}},{"kind":"Field","name":{"kind":"Name","value":"visualResult"}},{"kind":"Field","name":{"kind":"Name","value":"visualResponseReport"}},{"kind":"Field","name":{"kind":"Name","value":"adminPermitted"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contentReports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentType"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"playbackUrl"}},{"kind":"Field","name":{"kind":"Name","value":"voiceNoteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"moderationImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"muxPlaybackId"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}},{"kind":"Field","name":{"kind":"Name","value":"transcodingState"}}]}}]}}]} as unknown as DocumentNode<AdminMessageDetailQuery, AdminMessageDetailQueryVariables>;
export const AdminModeratedMessagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminModeratedMessages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"moderationResult"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ModerationResult"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeUserContentReports"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminModeratedMessages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"moderationResult"},"value":{"kind":"Variable","name":{"kind":"Name","value":"moderationResult"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeUserContentReports"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeUserContentReports"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ModeratedMessageItem"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModeratedMessageItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Message"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"adminTextContent"}},{"kind":"Field","name":{"kind":"Name","value":"discardedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayOrUsername"}}]}},{"kind":"Field","name":{"kind":"Name","value":"moderationResponse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"textResult"}},{"kind":"Field","name":{"kind":"Name","value":"textResponseReport"}},{"kind":"Field","name":{"kind":"Name","value":"visualResult"}},{"kind":"Field","name":{"kind":"Name","value":"visualResponseReport"}},{"kind":"Field","name":{"kind":"Name","value":"adminPermitted"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contentReports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentType"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"playbackUrl"}},{"kind":"Field","name":{"kind":"Name","value":"voiceNoteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"moderationImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"muxPlaybackId"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}},{"kind":"Field","name":{"kind":"Name","value":"transcodingState"}}]}}]}}]} as unknown as DocumentNode<AdminModeratedMessagesQuery, AdminModeratedMessagesQueryVariables>;
export const AdminModeratedUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminModeratedUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AdminModeratedUsersFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdWithinDays"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludeInvitedUsers"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminModeratedUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"createdWithinDays"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdWithinDays"}}},{"kind":"Argument","name":{"kind":"Name","value":"excludeInvitedUsers"},"value":{"kind":"Variable","name":{"kind":"Name","value":"excludeInvitedUsers"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserModerationItem"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminUserPreview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedAccount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserModerationItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AdminUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"userStatus"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdminUserPreview"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recentMessages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"2"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"textContent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"reportedMessagesCount"}},{"kind":"Field","name":{"kind":"Name","value":"blockedByCount"}},{"kind":"Field","name":{"kind":"Name","value":"postingRestrictionsCount"}},{"kind":"Field","name":{"kind":"Name","value":"roomBansCount"}},{"kind":"Field","name":{"kind":"Name","value":"dmAcceptedAllCount"}},{"kind":"Field","name":{"kind":"Name","value":"dmAcceptedCount"}},{"kind":"Field","name":{"kind":"Name","value":"dmRoomsMutuallyAcceptedCount"}},{"kind":"Field","name":{"kind":"Name","value":"activeFollowingVerifiedCount"}},{"kind":"Field","name":{"kind":"Name","value":"activeFollowingNonVerifiedCount"}},{"kind":"Field","name":{"kind":"Name","value":"activeRoomFollowsCount"}},{"kind":"Field","name":{"kind":"Name","value":"llmRecommendation"}}]}}]} as unknown as DocumentNode<AdminModeratedUsersQuery, AdminModeratedUsersQueryVariables>;
export const AdminModerateMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminModerateMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AdminModerateMessageInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminModerateMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ModeratedMessageItem"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModeratedMessageItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Message"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"adminTextContent"}},{"kind":"Field","name":{"kind":"Name","value":"discardedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayOrUsername"}}]}},{"kind":"Field","name":{"kind":"Name","value":"moderationResponse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"textResult"}},{"kind":"Field","name":{"kind":"Name","value":"textResponseReport"}},{"kind":"Field","name":{"kind":"Name","value":"visualResult"}},{"kind":"Field","name":{"kind":"Name","value":"visualResponseReport"}},{"kind":"Field","name":{"kind":"Name","value":"adminPermitted"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contentReports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentType"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"playbackUrl"}},{"kind":"Field","name":{"kind":"Name","value":"voiceNoteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"moderationImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"muxPlaybackId"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}},{"kind":"Field","name":{"kind":"Name","value":"transcodingState"}}]}}]}}]} as unknown as DocumentNode<AdminModerateMessageMutation, AdminModerateMessageMutationVariables>;
export const AdminUserCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminUserCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AdminUserCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminUserCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<AdminUserCreateMutation, AdminUserCreateMutationVariables>;
export const AdminNewMemberStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminNewMemberStats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminNewMemberStats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roomId"}},{"kind":"Field","name":{"kind":"Name","value":"roomName"}},{"kind":"Field","name":{"kind":"Name","value":"hostNames"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyStats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<AdminNewMemberStatsQuery, AdminNewMemberStatsQueryVariables>;
export const AdminYoutubeSourceCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminYoutubeSourceCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AdminYoutubeSourceCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminYoutubeSourceCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"youtubeSource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdminYoutubeSource"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminYoutubeSource"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AdminYoutubeSource"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"lastSyncedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]} as unknown as DocumentNode<AdminYoutubeSourceCreateMutation, AdminYoutubeSourceCreateMutationVariables>;
export const AdminEpisodesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminEpisodes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roomId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminEpisodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"roomId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roomId"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdminEpisode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminEpisode"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AdminEpisode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"youtubeId"}},{"kind":"Field","name":{"kind":"Name","value":"isYoutubeShort"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"durationSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"liveStatus"}},{"kind":"Field","name":{"kind":"Name","value":"membersOnly"}},{"kind":"Field","name":{"kind":"Name","value":"relevant"}},{"kind":"Field","name":{"kind":"Name","value":"transcriptionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"reapTaskStatus"}},{"kind":"Field","name":{"kind":"Name","value":"detailsSyncedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"youtubeSource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<AdminEpisodesQuery, AdminEpisodesQueryVariables>;
export const AdminYoutubeHeaderCountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminYoutubeHeaderCounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roomId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"episodesCount"},"name":{"kind":"Name","value":"adminEpisodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"roomId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roomId"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"0"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"sourcesCount"},"name":{"kind":"Name","value":"adminYoutubeSources"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"roomId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roomId"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"0"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<AdminYoutubeHeaderCountsQuery, AdminYoutubeHeaderCountsQueryVariables>;
export const AdminYoutubeSourcesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminYoutubeSources"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roomId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminYoutubeSources"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"roomId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roomId"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdminRoomYoutubeSource"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminYoutubeSource"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AdminYoutubeSource"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"lastSyncedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminRoomYoutubeSource"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AdminRoomYoutubeSource"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"episodesCount"}},{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdminYoutubeSource"}}]}}]}}]} as unknown as DocumentNode<AdminYoutubeSourcesQuery, AdminYoutubeSourcesQueryVariables>;
export const AdminRoomEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminRoomEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roomId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EventsFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"roomId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roomId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"startsAt"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}}]}}]}}]} as unknown as DocumentNode<AdminRoomEventsQuery, AdminRoomEventsQueryVariables>;
export const AdminEventDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminEventDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventDeleteInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventDelete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<AdminEventDeleteMutation, AdminEventDeleteMutationVariables>;
export const AdminRoomHostStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminRoomHostStats"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminRoom"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"adminRoomHostStats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}},{"kind":"Field","name":{"kind":"Name","value":"daysSinceOnboarded"}},{"kind":"Field","name":{"kind":"Name","value":"daysWithAtLeastOneMessageAllTime"}},{"kind":"Field","name":{"kind":"Name","value":"daysWithAtLeastOneMessageThisMonth"}},{"kind":"Field","name":{"kind":"Name","value":"daysWithAtLeastOneMessageLastMonth"}},{"kind":"Field","name":{"kind":"Name","value":"numberMessagesThisMonth"}},{"kind":"Field","name":{"kind":"Name","value":"numberMessagesLastMonth"}},{"kind":"Field","name":{"kind":"Name","value":"numberMessagesAllTime"}},{"kind":"Field","name":{"kind":"Name","value":"referralCountAllTime"}},{"kind":"Field","name":{"kind":"Name","value":"referralCountThisMonth"}},{"kind":"Field","name":{"kind":"Name","value":"referralCountLastMonth"}},{"kind":"Field","name":{"kind":"Name","value":"netAuraThisMonth"}},{"kind":"Field","name":{"kind":"Name","value":"netAuraLastMonth"}},{"kind":"Field","name":{"kind":"Name","value":"netAuraAllTime"}}]}}]}}]}}]} as unknown as DocumentNode<AdminRoomHostStatsQuery, AdminRoomHostStatsQueryVariables>;
export const AdminChatbccScheduledMessagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminChatbccScheduledMessages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roomId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"room"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roomId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"adminChatbccScheduledMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"textContent"}},{"kind":"Field","name":{"kind":"Name","value":"sendAt"}},{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AdminChatbccScheduledMessagesQuery, AdminChatbccScheduledMessagesQueryVariables>;
export const AdminUpdateScheduledMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminUpdateScheduledMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MessageUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"messageUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"textContent"}}]}}]}}]}}]} as unknown as DocumentNode<AdminUpdateScheduledMessageMutation, AdminUpdateScheduledMessageMutationVariables>;
export const AdminSendScheduledMessageNowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminSendScheduledMessageNow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SendScheduledMessageInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendScheduledMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<AdminSendScheduledMessageNowMutation, AdminSendScheduledMessageNowMutationVariables>;
export const AdminRoomDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminRoom"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"waitlistCodesFirst"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"waitlistCodesAfter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roomInvitersFirst"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roomInvitersAfter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invitationType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"InvitationType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminRoom"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseRoom"}},{"kind":"Field","name":{"kind":"Name","value":"activeRoomMembershipsCount"}},{"kind":"Field","name":{"kind":"Name","value":"isViewerMember"}},{"kind":"Field","name":{"kind":"Name","value":"bountyChannelId"}},{"kind":"Field","name":{"kind":"Name","value":"defaultAdCreative"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventsOverview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upcomingCount"}},{"kind":"Field","name":{"kind":"Name","value":"hasEvent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"adminChatbccScheduledMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultChannelId"}},{"kind":"Field","name":{"kind":"Name","value":"autoJoinChannelIds"}},{"kind":"Field","name":{"kind":"Name","value":"adminDemoWorkflow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RoomDemoWorkflow"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdminSubscriptionProduct"}}]}},{"kind":"Field","name":{"kind":"Name","value":"adminPaymentSubscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vipUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roomMembershipsPreview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RoomMembershipPreview"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roomWaitlistCodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"waitlistCodesFirst"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"waitlistCodesAfter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseRoomWaitlistCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roomInviters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"invitationType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invitationType"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roomInvitersFirst"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roomInvitersAfter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseRoomInviter"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Channel_EditChannel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Channel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"webUrl"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"postingPermission"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"}},{"kind":"Field","name":{"kind":"Name","value":"discardedAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseRoom"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Room"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"roomStatus"}},{"kind":"Field","name":{"kind":"Name","value":"roomHandle"}},{"kind":"Field","name":{"kind":"Name","value":"webUrl"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"}},{"kind":"Field","name":{"kind":"Name","value":"vipName"}},{"kind":"Field","name":{"kind":"Name","value":"vipColor"}},{"kind":"Field","name":{"kind":"Name","value":"vipEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"vipBadgeUrl"}},{"kind":"Field","name":{"kind":"Name","value":"sharingEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"photoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"welcomeMessage"}},{"kind":"Field","name":{"kind":"Name","value":"paymentSubscriptionsMode"}},{"kind":"Field","name":{"kind":"Name","value":"appStoreSubscriptionGroupIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"playStoreSubscriptionGroupIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"openChatUntil"}},{"kind":"Field","name":{"kind":"Name","value":"eventLiveTimezonesDefault"}},{"kind":"Field","name":{"kind":"Name","value":"channels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includeDiscarded"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"postingPermission"}},{"kind":"Field","name":{"kind":"Name","value":"discardedAt"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Channel_EditChannel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoomDemoWorkflow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DemoWorkflow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currentWorkflowState"}},{"kind":"Field","name":{"kind":"Name","value":"allWorkflowStates"}},{"kind":"Field","name":{"kind":"Name","value":"stepCompletionPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminSubscriptionProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SubscriptionProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"storeProductIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"store"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionBullets"}},{"kind":"Field","name":{"kind":"Name","value":"productBenefits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"permitsSubscriberOnlyMessages"}},{"kind":"Field","name":{"kind":"Name","value":"permitsPromotedComments"}},{"kind":"Field","name":{"kind":"Name","value":"collectUserEmail"}},{"kind":"Field","name":{"kind":"Name","value":"collectUserPostalCode"}},{"kind":"Field","name":{"kind":"Name","value":"subscriberBadgeUrl"}},{"kind":"Field","name":{"kind":"Name","value":"permittedChannels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoomMembershipPreview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoomMembership"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseRoomWaitlistCode"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoomWaitlistCode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseRoomInviter"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoomInviter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]} as unknown as DocumentNode<AdminRoomQuery, AdminRoomQueryVariables>;
export const AdminRoomToggleBountiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminRoomToggleBounties"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roomId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enabled"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminRoomToggleBounties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"roomId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roomId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"enabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enabled"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"room"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bountyChannelId"}}]}}]}}]}}]} as unknown as DocumentNode<AdminRoomToggleBountiesMutation, AdminRoomToggleBountiesMutationVariables>;
export const ChannelDiscardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChannelDiscard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChannelDiscardInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelDiscard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"webUrl"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"postingPermission"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"}},{"kind":"Field","name":{"kind":"Name","value":"discardedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"room"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"channels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includeDiscarded"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"postingPermission"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"}},{"kind":"Field","name":{"kind":"Name","value":"discardedAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ChannelDiscardMutation, ChannelDiscardMutationVariables>;
export const ChannelCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChannelCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChannelCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"webUrl"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"postingPermission"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"}},{"kind":"Field","name":{"kind":"Name","value":"discardedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"room"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"channels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includeDiscarded"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"webUrl"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"postingPermission"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"}},{"kind":"Field","name":{"kind":"Name","value":"discardedAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ChannelCreateMutation, ChannelCreateMutationVariables>;
export const RoomRuleCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RoomRuleCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RoomRuleCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roomRuleCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roomRule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"}}]}},{"kind":"Field","name":{"kind":"Name","value":"room"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RoomRuleCreateMutation, RoomRuleCreateMutationVariables>;
export const AdminDemoRoomRetryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminDemoRoomRetry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AdminDemoRoomRetryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminDemoRoomRetry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"room"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"adminDemoWorkflow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RoomDemoWorkflow"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoomDemoWorkflow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DemoWorkflow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currentWorkflowState"}},{"kind":"Field","name":{"kind":"Name","value":"allWorkflowStates"}},{"kind":"Field","name":{"kind":"Name","value":"stepCompletionPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]} as unknown as DocumentNode<AdminDemoRoomRetryMutation, AdminDemoRoomRetryMutationVariables>;
export const GetDemoWorkflowStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDemoWorkflowStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roomId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"room"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roomId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"adminDemoWorkflow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RoomDemoWorkflow"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoomDemoWorkflow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DemoWorkflow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currentWorkflowState"}},{"kind":"Field","name":{"kind":"Name","value":"allWorkflowStates"}},{"kind":"Field","name":{"kind":"Name","value":"stepCompletionPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]} as unknown as DocumentNode<GetDemoWorkflowStatusQuery, GetDemoWorkflowStatusQueryVariables>;
export const ChannelUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChannelUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChannelUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Channel_EditChannel"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Channel_EditChannel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Channel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"webUrl"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"postingPermission"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"}},{"kind":"Field","name":{"kind":"Name","value":"discardedAt"}}]}}]} as unknown as DocumentNode<ChannelUpdateMutation, ChannelUpdateMutationVariables>;
export const RoomRuleUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RoomRuleUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RoomRuleUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roomRuleUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roomRule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"}}]}},{"kind":"Field","name":{"kind":"Name","value":"room"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RoomRuleUpdateMutation, RoomRuleUpdateMutationVariables>;
export const RoomJoinDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RoomJoin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roomId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roomJoin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"roomId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roomId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"room"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isViewerMember"}}]}}]}}]}}]} as unknown as DocumentNode<RoomJoinMutation, RoomJoinMutationVariables>;
export const RoomRuleDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RoomRuleDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RoomRuleDeleteInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roomRuleDelete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roomRule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"}}]}},{"kind":"Field","name":{"kind":"Name","value":"room"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RoomRuleDeleteMutation, RoomRuleDeleteMutationVariables>;
export const WaitlistCodeCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"WaitlistCodeCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WaitlistCodeCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"waitlistCodeCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roomWaitlistCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseRoomWaitlistCode"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseRoomWaitlistCode"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoomWaitlistCode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]} as unknown as DocumentNode<WaitlistCodeCreateMutation, WaitlistCodeCreateMutationVariables>;
export const WaitlistCodeUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"WaitlistCodeUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WaitlistCodeUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"waitlistCodeUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roomWaitlistCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseRoomWaitlistCode"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseRoomWaitlistCode"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoomWaitlistCode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]} as unknown as DocumentNode<WaitlistCodeUpdateMutation, WaitlistCodeUpdateMutationVariables>;
export const AdminSubscriptionProductCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminSubscriptionProductCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AdminSubscriptionProductCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminSubscriptionProductCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptionProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdminSubscriptionProduct"}},{"kind":"Field","name":{"kind":"Name","value":"productBenefits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminSubscriptionProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SubscriptionProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"storeProductIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"store"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionBullets"}},{"kind":"Field","name":{"kind":"Name","value":"productBenefits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"permitsSubscriberOnlyMessages"}},{"kind":"Field","name":{"kind":"Name","value":"permitsPromotedComments"}},{"kind":"Field","name":{"kind":"Name","value":"collectUserEmail"}},{"kind":"Field","name":{"kind":"Name","value":"collectUserPostalCode"}},{"kind":"Field","name":{"kind":"Name","value":"subscriberBadgeUrl"}},{"kind":"Field","name":{"kind":"Name","value":"permittedChannels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<AdminSubscriptionProductCreateMutation, AdminSubscriptionProductCreateMutationVariables>;
export const AdminSubscriptionProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminSubscriptionProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminRoom"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseRoom"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionProducts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"includeDisabled"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdminSubscriptionProduct"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Channel_EditChannel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Channel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"webUrl"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"postingPermission"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"}},{"kind":"Field","name":{"kind":"Name","value":"discardedAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseRoom"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Room"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"roomStatus"}},{"kind":"Field","name":{"kind":"Name","value":"roomHandle"}},{"kind":"Field","name":{"kind":"Name","value":"webUrl"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"}},{"kind":"Field","name":{"kind":"Name","value":"vipName"}},{"kind":"Field","name":{"kind":"Name","value":"vipColor"}},{"kind":"Field","name":{"kind":"Name","value":"vipEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"vipBadgeUrl"}},{"kind":"Field","name":{"kind":"Name","value":"sharingEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"photoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"welcomeMessage"}},{"kind":"Field","name":{"kind":"Name","value":"paymentSubscriptionsMode"}},{"kind":"Field","name":{"kind":"Name","value":"appStoreSubscriptionGroupIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"playStoreSubscriptionGroupIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"openChatUntil"}},{"kind":"Field","name":{"kind":"Name","value":"eventLiveTimezonesDefault"}},{"kind":"Field","name":{"kind":"Name","value":"channels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includeDiscarded"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"postingPermission"}},{"kind":"Field","name":{"kind":"Name","value":"discardedAt"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Channel_EditChannel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminSubscriptionProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SubscriptionProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"storeProductIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"store"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionBullets"}},{"kind":"Field","name":{"kind":"Name","value":"productBenefits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"permitsSubscriberOnlyMessages"}},{"kind":"Field","name":{"kind":"Name","value":"permitsPromotedComments"}},{"kind":"Field","name":{"kind":"Name","value":"collectUserEmail"}},{"kind":"Field","name":{"kind":"Name","value":"collectUserPostalCode"}},{"kind":"Field","name":{"kind":"Name","value":"subscriberBadgeUrl"}},{"kind":"Field","name":{"kind":"Name","value":"permittedChannels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<AdminSubscriptionProductsQuery, AdminSubscriptionProductsQueryVariables>;
export const AdminSubscriptionProductRepositionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminSubscriptionProductReposition"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AdminSubscriptionProductRepositionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminSubscriptionProductReposition"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptionProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}}]}}]}}]} as unknown as DocumentNode<AdminSubscriptionProductRepositionMutation, AdminSubscriptionProductRepositionMutationVariables>;
export const AdminSubscriptionProductUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminSubscriptionProductUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AdminSubscriptionProductUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminSubscriptionProductUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptionProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdminSubscriptionProduct"}},{"kind":"Field","name":{"kind":"Name","value":"productBenefits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminSubscriptionProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SubscriptionProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"storeProductIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"store"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionBullets"}},{"kind":"Field","name":{"kind":"Name","value":"productBenefits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"permitsSubscriberOnlyMessages"}},{"kind":"Field","name":{"kind":"Name","value":"permitsPromotedComments"}},{"kind":"Field","name":{"kind":"Name","value":"collectUserEmail"}},{"kind":"Field","name":{"kind":"Name","value":"collectUserPostalCode"}},{"kind":"Field","name":{"kind":"Name","value":"subscriberBadgeUrl"}},{"kind":"Field","name":{"kind":"Name","value":"permittedChannels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<AdminSubscriptionProductUpdateMutation, AdminSubscriptionProductUpdateMutationVariables>;
export const AdminRoomSubscriptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminRoomSubscriptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminRoom"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"adminPaymentSubscriptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"autoRenewalStatus"}},{"kind":"Field","name":{"kind":"Name","value":"periodEndsAt"}},{"kind":"Field","name":{"kind":"Name","value":"recordType"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayOrUsername"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AdminRoomSubscriptionsQuery, AdminRoomSubscriptionsQueryVariables>;
export const RoomTopMessagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RoomTopMessages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roomId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ISO8601DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ISO8601DateTime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"room"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roomId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaultChannel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"topMessages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"Argument","name":{"kind":"Name","value":"end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"5"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TopMessagePreview"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TopMessagePreview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Message"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"adminTextContent"}},{"kind":"Field","name":{"kind":"Name","value":"reactionsCount"}},{"kind":"Field","name":{"kind":"Name","value":"childMessagesCount"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayOrUsername"}}]}},{"kind":"Field","name":{"kind":"Name","value":"room"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"roomHandle"}}]}}]}}]} as unknown as DocumentNode<RoomTopMessagesQuery, RoomTopMessagesQueryVariables>;
export const RoomVipUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RoomVipUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roomId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminRoom"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roomId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"vipUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RoomVipUsersQuery, RoomVipUsersQueryVariables>;
export const AdminRoomsUpdateRankingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminRoomsUpdateRanking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roomId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ranking"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateRoomRanking"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"roomId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roomId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ranking"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ranking"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"room"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"}}]}}]}}]}}]} as unknown as DocumentNode<AdminRoomsUpdateRankingMutation, AdminRoomsUpdateRankingMutationVariables>;
export const AdminRoomsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminRooms"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roomStatus"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RoomStatus"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminRooms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"roomStatus"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roomStatus"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseRoom"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Channel_EditChannel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Channel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"webUrl"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"postingPermission"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"}},{"kind":"Field","name":{"kind":"Name","value":"discardedAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseRoom"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Room"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"roomStatus"}},{"kind":"Field","name":{"kind":"Name","value":"roomHandle"}},{"kind":"Field","name":{"kind":"Name","value":"webUrl"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"}},{"kind":"Field","name":{"kind":"Name","value":"vipName"}},{"kind":"Field","name":{"kind":"Name","value":"vipColor"}},{"kind":"Field","name":{"kind":"Name","value":"vipEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"vipBadgeUrl"}},{"kind":"Field","name":{"kind":"Name","value":"sharingEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"photoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"welcomeMessage"}},{"kind":"Field","name":{"kind":"Name","value":"paymentSubscriptionsMode"}},{"kind":"Field","name":{"kind":"Name","value":"appStoreSubscriptionGroupIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"playStoreSubscriptionGroupIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"openChatUntil"}},{"kind":"Field","name":{"kind":"Name","value":"eventLiveTimezonesDefault"}},{"kind":"Field","name":{"kind":"Name","value":"channels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includeDiscarded"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"postingPermission"}},{"kind":"Field","name":{"kind":"Name","value":"discardedAt"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Channel_EditChannel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"}}]}}]}}]} as unknown as DocumentNode<AdminRoomsQuery, AdminRoomsQueryVariables>;
export const AdminUserDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminUserDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserDetail"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminUserPreview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedAccount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"userStatus"}},{"kind":"Field","name":{"kind":"Name","value":"userRole"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedAccount"}},{"kind":"Field","name":{"kind":"Name","value":"waitlisted"}},{"kind":"Field","name":{"kind":"Name","value":"showFullName"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"webUrl"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"activeFollowerCount"}},{"kind":"Field","name":{"kind":"Name","value":"activeFollowingCount"}},{"kind":"Field","name":{"kind":"Name","value":"paidDmEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"paidDmProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}},{"kind":"Field","name":{"kind":"Name","value":"auraAmount"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdminUserPreview"}}]}}]} as unknown as DocumentNode<AdminUserDetailQuery, AdminUserDetailQueryVariables>;
export const AdminUserDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminUserDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contentReportsFirst"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"recentMessagesLimit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminUserDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"llmRecommendation"}},{"kind":"Field","name":{"kind":"Name","value":"activeFollowingVerifiedCount"}},{"kind":"Field","name":{"kind":"Name","value":"activeRoomFollowsCount"}},{"kind":"Field","name":{"kind":"Name","value":"dmAcceptedAllCount"}},{"kind":"Field","name":{"kind":"Name","value":"dmRoomsAcceptedCount"}},{"kind":"Field","name":{"kind":"Name","value":"dmRoomsPendingCount"}},{"kind":"Field","name":{"kind":"Name","value":"dmRoomsDeclinedCount"}},{"kind":"Field","name":{"kind":"Name","value":"dmRoomsMutuallyAcceptedCount"}},{"kind":"Field","name":{"kind":"Name","value":"recentMessages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recentMessagesLimit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserDetailsMessagePreview"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userContentReports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contentReportsFirst"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserDetailsMessagePreview"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserDetailsMessagePreview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Message"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"adminTextContent"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"room"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"viewerRoomName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contentReports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<AdminUserDetailsQuery, AdminUserDetailsQueryVariables>;
export const AdminUserFollowedRoomsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminUserFollowedRooms"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminUserDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"followedRooms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"activeRoomMembershipsCount"}},{"kind":"Field","name":{"kind":"Name","value":"activeRoomFollowsCount"}}]}}]}}]}}]} as unknown as DocumentNode<AdminUserFollowedRoomsQuery, AdminUserFollowedRoomsQueryVariables>;
export const AdminUserModerationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminUserModerations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"daysBack"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminUserModerations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"daysBack"},"value":{"kind":"Variable","name":{"kind":"Name","value":"daysBack"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserModerationFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserModerationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserModeration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"warnReason"}},{"kind":"Field","name":{"kind":"Name","value":"warnMessage"}},{"kind":"Field","name":{"kind":"Name","value":"postingRestrictedUntil"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"isGlobal"}},{"kind":"Field","name":{"kind":"Name","value":"room"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"textContent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]} as unknown as DocumentNode<AdminUserModerationsQuery, AdminUserModerationsQueryVariables>;
export const AdminUserModerationCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminUserModerationCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roomId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"warnReason"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"warnMessage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postingRestrictedUntil"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ISO8601DateTime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminUserModerationCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"roomId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roomId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"warnReason"},"value":{"kind":"Variable","name":{"kind":"Name","value":"warnReason"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"warnMessage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"warnMessage"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"postingRestrictedUntil"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postingRestrictedUntil"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userModeration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserModerationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserModerationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserModeration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"warnReason"}},{"kind":"Field","name":{"kind":"Name","value":"warnMessage"}},{"kind":"Field","name":{"kind":"Name","value":"postingRestrictedUntil"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"isGlobal"}},{"kind":"Field","name":{"kind":"Name","value":"room"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"textContent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]} as unknown as DocumentNode<AdminUserModerationCreateMutation, AdminUserModerationCreateMutationVariables>;
export const AdminUserModerationUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminUserModerationUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"moderationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"warnReason"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"warnMessage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postingRestrictedUntil"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ISO8601DateTime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminUserModerationUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"moderationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"moderationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"warnReason"},"value":{"kind":"Variable","name":{"kind":"Name","value":"warnReason"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"warnMessage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"warnMessage"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"postingRestrictedUntil"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postingRestrictedUntil"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userModeration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserModerationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserModerationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserModeration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"warnReason"}},{"kind":"Field","name":{"kind":"Name","value":"warnMessage"}},{"kind":"Field","name":{"kind":"Name","value":"postingRestrictedUntil"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"isGlobal"}},{"kind":"Field","name":{"kind":"Name","value":"room"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"textContent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]} as unknown as DocumentNode<AdminUserModerationUpdateMutation, AdminUserModerationUpdateMutationVariables>;
export const AdminUserModerationDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminUserModerationDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"moderationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminUserModerationDelete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"moderationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"moderationId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<AdminUserModerationDeleteMutation, AdminUserModerationDeleteMutationVariables>;
export const UserEarningsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserEarnings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"withEarningsStart"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ISO8601DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"withEarningsEnd"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ISO8601DateTime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayOrUsername"}}]}},{"kind":"Field","name":{"kind":"Name","value":"earningsScreen"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amountEarned"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"withEarningsStart"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withEarningsStart"}}},{"kind":"Argument","name":{"kind":"Name","value":"withEarningsEnd"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withEarningsEnd"}}}]},{"kind":"Field","name":{"kind":"Name","value":"auraAmountEarned"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"withEarningsStart"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withEarningsStart"}}},{"kind":"Argument","name":{"kind":"Name","value":"withEarningsEnd"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withEarningsEnd"}}}]},{"kind":"Field","name":{"kind":"Name","value":"plans"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"withEarningsStart"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withEarningsStart"}}},{"kind":"Argument","name":{"kind":"Name","value":"withEarningsEnd"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withEarningsEnd"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"room"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"planItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"itemType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"limitAmount"}},{"kind":"Field","name":{"kind":"Name","value":"limitTimeFrame"}},{"kind":"Field","name":{"kind":"Name","value":"amountEarned"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"withEarningsStart"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withEarningsStart"}}},{"kind":"Argument","name":{"kind":"Name","value":"withEarningsEnd"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withEarningsEnd"}}}]},{"kind":"Field","name":{"kind":"Name","value":"amountEarnedTowardsLimit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserEarningsQuery, UserEarningsQueryVariables>;
export const AdminAllUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminAllUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userRoles"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserRole"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userRoles"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userRoles"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}},{"kind":"Argument","name":{"kind":"Name","value":"excludeDemoUsers"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserOverview"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserOverview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"displayOrUsername"}},{"kind":"Field","name":{"kind":"Name","value":"userStatus"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]} as unknown as DocumentNode<AdminAllUsersQuery, AdminAllUsersQueryVariables>;
export const AdminEarningsPlanCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminEarningsPlanCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AdminEarningsPlanCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminEarningsPlanCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"earningsPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<AdminEarningsPlanCreateMutation, AdminEarningsPlanCreateMutationVariables>;
export const AdminEarningsPlanCloneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminEarningsPlanClone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminEarningsPlan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdminEarningsPlan"}},{"kind":"Field","name":{"kind":"Name","value":"planItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdminEarningsPlanItem"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminEarningsPlan"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EarningsPlan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"roomId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"room"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"startsAt"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"displayOrUsername"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminEarningsPlanItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EarningsPlanItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"itemType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"internalDescription"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"limitAmount"}},{"kind":"Field","name":{"kind":"Name","value":"limitTimeFrame"}},{"kind":"Field","name":{"kind":"Name","value":"messagesRequired"}}]}}]} as unknown as DocumentNode<AdminEarningsPlanCloneQuery, AdminEarningsPlanCloneQueryVariables>;
export const AdminAuraEarningsEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminAuraEarningsEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"earningsPlanId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminEarningsPlan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"earningsPlanId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"earningsScreen"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"earningsEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"earningsPlanId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"earningsPlanId"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"itemType"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"occurredAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"displayOrUsername"}}]}},{"kind":"Field","name":{"kind":"Name","value":"earningsPlanItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AdminAuraEarningsEventsQuery, AdminAuraEarningsEventsQueryVariables>;
export const AdminEarningsPlanDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminEarningsPlan"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminEarningsPlan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdminEarningsPlan"}},{"kind":"Field","name":{"kind":"Name","value":"planItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdminEarningsPlanItem"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminEarningsPlan"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EarningsPlan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"roomId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"room"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"startsAt"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"displayOrUsername"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminEarningsPlanItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EarningsPlanItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"itemType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"internalDescription"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"limitAmount"}},{"kind":"Field","name":{"kind":"Name","value":"limitTimeFrame"}},{"kind":"Field","name":{"kind":"Name","value":"messagesRequired"}}]}}]} as unknown as DocumentNode<AdminEarningsPlanQuery, AdminEarningsPlanQueryVariables>;
export const EarningsPlansDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EarningsPlans"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activeOnly"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"earningsScreen"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plans"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"activeOnly"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activeOnly"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeAllUsers"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdminEarningsPlan"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminEarningsPlan"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EarningsPlan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"roomId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"room"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"startsAt"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"displayOrUsername"}}]}}]}}]} as unknown as DocumentNode<EarningsPlansQuery, EarningsPlansQueryVariables>;
export const AdminEarningsPlanEditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminEarningsPlanEdit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminEarningsPlan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"roomId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"startsAt"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"displayOrUsername"}}]}}]}}]}}]} as unknown as DocumentNode<AdminEarningsPlanEditQuery, AdminEarningsPlanEditQueryVariables>;
export const AdminEarningsPlanUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminEarningsPlanUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AdminEarningsPlanUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminEarningsPlanUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"earningsPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<AdminEarningsPlanUpdateMutation, AdminEarningsPlanUpdateMutationVariables>;
export const AllRoomMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllRoomMembers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"membershipRoomId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"membershipRoomId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"membershipRoomId"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AllRoomMembersQuery, AllRoomMembersQueryVariables>;
export const AdminAuraProductUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminAuraProductUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AdminAuraProductUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminAuraProductUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auraProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdminAuraProduct"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminAuraProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AuraProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}},{"kind":"Field","name":{"kind":"Name","value":"storeProductIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"store"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"auraAmount"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseOnWalletScreen"}}]}}]} as unknown as DocumentNode<AdminAuraProductUpdateMutation, AdminAuraProductUpdateMutationVariables>;
export const AdminPredictionsGroupCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminPredictionsGroupCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AdminPredictionsGroupCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminPredictionsGroupCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gameGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<AdminPredictionsGroupCreateMutation, AdminPredictionsGroupCreateMutationVariables>;
export const AdminPredictionGroupForResultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminPredictionGroupForResults"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminPredictionGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resultsMessageText"}},{"kind":"Field","name":{"kind":"Name","value":"resultsScheduledAt"}},{"kind":"Field","name":{"kind":"Name","value":"templateGame"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"resultsInputAt"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"correct"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AdminPredictionGroupForResultsQuery, AdminPredictionGroupForResultsQueryVariables>;
export const AdminPredictionsInputResultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminPredictionsInputResults"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AdminPredictionsInputResultsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminPredictionsInputResults"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gameGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<AdminPredictionsInputResultsMutation, AdminPredictionsInputResultsMutationVariables>;
export const AdminPredictionGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminPredictionGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminPredictionGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startsAt"}},{"kind":"Field","name":{"kind":"Name","value":"gameCount"}},{"kind":"Field","name":{"kind":"Name","value":"pinStartingMessage"}},{"kind":"Field","name":{"kind":"Name","value":"resultsScheduledAt"}},{"kind":"Field","name":{"kind":"Name","value":"games"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"room"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"templateGame"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"resultsInputAt"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<AdminPredictionGroupsQuery, AdminPredictionGroupsQueryVariables>;
export const AdminPredictionsGroupUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminPredictionsGroupUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AdminPredictionsGroupUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminPredictionsGroupUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gameGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<AdminPredictionsGroupUpdateMutation, AdminPredictionsGroupUpdateMutationVariables>;
export const AdminPredictionGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminPredictionGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminPredictionGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startsAt"}},{"kind":"Field","name":{"kind":"Name","value":"launchMessageText"}},{"kind":"Field","name":{"kind":"Name","value":"pinStartingMessage"}},{"kind":"Field","name":{"kind":"Name","value":"templateGame"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"adCreativeId"}},{"kind":"Field","name":{"kind":"Name","value":"resultsInputAt"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"pointValue"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"correct"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"games"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"responseCount"}},{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"membershipsCount"}},{"kind":"Field","name":{"kind":"Name","value":"room"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AdminPredictionGroupQuery, AdminPredictionGroupQueryVariables>;
export const LogoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Logout"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LogoutInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<LogoutMutation, LogoutMutationVariables>;
export const ViewerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CachedViewerContext"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CachedViewerContext"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userRole"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"displayOrUsername"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}}]}}]} as unknown as DocumentNode<ViewerQuery, ViewerQueryVariables>;
export const AdminUserArchiveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminUserArchive"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AdminUserUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminUserUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserOverview"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserOverview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"displayOrUsername"}},{"kind":"Field","name":{"kind":"Name","value":"userStatus"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]} as unknown as DocumentNode<AdminUserArchiveMutation, AdminUserArchiveMutationVariables>;
export const PublishRoomDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PublishRoom"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RoomPublishInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roomPublish"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"room"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseRoom"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Channel_EditChannel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Channel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"webUrl"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"postingPermission"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"}},{"kind":"Field","name":{"kind":"Name","value":"discardedAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseRoom"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Room"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"roomStatus"}},{"kind":"Field","name":{"kind":"Name","value":"roomHandle"}},{"kind":"Field","name":{"kind":"Name","value":"webUrl"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"}},{"kind":"Field","name":{"kind":"Name","value":"vipName"}},{"kind":"Field","name":{"kind":"Name","value":"vipColor"}},{"kind":"Field","name":{"kind":"Name","value":"vipEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"vipBadgeUrl"}},{"kind":"Field","name":{"kind":"Name","value":"sharingEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"photoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"welcomeMessage"}},{"kind":"Field","name":{"kind":"Name","value":"paymentSubscriptionsMode"}},{"kind":"Field","name":{"kind":"Name","value":"appStoreSubscriptionGroupIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"playStoreSubscriptionGroupIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"openChatUntil"}},{"kind":"Field","name":{"kind":"Name","value":"eventLiveTimezonesDefault"}},{"kind":"Field","name":{"kind":"Name","value":"channels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includeDiscarded"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"postingPermission"}},{"kind":"Field","name":{"kind":"Name","value":"discardedAt"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Channel_EditChannel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"}}]}}]}}]} as unknown as DocumentNode<PublishRoomMutation, PublishRoomMutationVariables>;
export const AdminUserSuspendDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminUserSuspend"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"suspend"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"annotateRecaptcha"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminUserSuspend"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"suspend"},"value":{"kind":"Variable","name":{"kind":"Name","value":"suspend"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"annotateRecaptcha"},"value":{"kind":"Variable","name":{"kind":"Name","value":"annotateRecaptcha"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserOverview"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserOverview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"displayOrUsername"}},{"kind":"Field","name":{"kind":"Name","value":"userStatus"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]} as unknown as DocumentNode<AdminUserSuspendMutation, AdminUserSuspendMutationVariables>;
export const AdminRoomsSearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminRoomsSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminRooms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"roomStatuses"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"PUBLISHED"},{"kind":"EnumValue","value":"PENDING_APPROVAL"}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"roomHandle"}},{"kind":"Field","name":{"kind":"Name","value":"activeRoomFollowsCount"}},{"kind":"Field","name":{"kind":"Name","value":"activeRoomMembershipsCount"}},{"kind":"Field","name":{"kind":"Name","value":"channels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"membershipsCount"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AdminRoomsSearchQuery, AdminRoomsSearchQueryVariables>;
export const AdminRoomsSearchFieldDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminRoomsSearchField"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminRooms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"roomStatuses"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"PUBLISHED"},{"kind":"EnumValue","value":"PENDING_APPROVAL"}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"roomHandle"}},{"kind":"Field","name":{"kind":"Name","value":"activeRoomMembershipsCount"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AdminRoomsSearchFieldQuery, AdminRoomsSearchFieldQueryVariables>;
export const RoomMembersSearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RoomMembersSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"membershipRoomId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"membershipRoomId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"membershipRoomId"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RoomMembersSearchQuery, RoomMembersSearchQueryVariables>;
export const UserSearchFieldDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserSearchField"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserSearchFieldQuery, UserSearchFieldQueryVariables>;
export const UploadPresign_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UploadPresign_Mutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UploadPresignInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadPresign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"headers"}},{"kind":"Field","name":{"kind":"Name","value":"signedId"}}]}}]}}]} as unknown as DocumentNode<UploadPresign_MutationMutation, UploadPresign_MutationMutationVariables>;
export const SendDownloadAppLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendDownloadAppLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SendDownloadAppLinkInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendDownloadAppLink"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<SendDownloadAppLinkMutation, SendDownloadAppLinkMutationVariables>;
export const SendFriendInviteLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendFriendInviteLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SendFriendInviteLinkInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendFriendInviteLink"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<SendFriendInviteLinkMutation, SendFriendInviteLinkMutationVariables>;
export const SendRoomShareLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendRoomShareLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SendRoomShareLinkInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendRoomShareLink"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<SendRoomShareLinkMutation, SendRoomShareLinkMutationVariables>;
export const LoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Login"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CredentialsUserAuthInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"login"},"name":{"kind":"Name","value":"credentialsUserAuth"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<LoginMutation, LoginMutationVariables>;
export const EmailTokenAuthDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EmailTokenAuth"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EmailTokenUserAuthInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailTokenUserAuth"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"csrfToken"}}]}}]}}]} as unknown as DocumentNode<EmailTokenAuthMutation, EmailTokenAuthMutationVariables>;
export const EmailAuthChallengeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EmailAuthChallenge"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EmailUserAuthChallengeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailUserAuthChallenge"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<EmailAuthChallengeMutation, EmailAuthChallengeMutationVariables>;
export const UpdateProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProfileMutation, UpdateProfileMutationVariables>;
export const LocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ipGeolocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}}]}}]} as unknown as DocumentNode<LocationQuery, LocationQueryVariables>;
export const UserDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userRole"}}]}}]}}]}}]} as unknown as DocumentNode<UserDetailsQuery, UserDetailsQueryVariables>;